define('common/presentation/i18nResources',[],
    function () {
        const shared = {
            enUS: {
                add: "Add",
                addPhoneNumber: "Add Phone Number",
                agentBypass: "Agent Bypass &rarr;",
                areaCodeInvalid: "Please enter a valid area code.",
                areaCodeRequired: "Please enter an area code.",
                at: "at",
                back: 'Back',
                blocked: 'Blocked',
                cancel: 'Cancel',
                campaignRegistry: "Campaign Registry",
                theCampaignRegistry: "The Campaign Registry",
                close: 'Close',
                comingSoon: 'Coming Soon',
                continue: "Continue",
                create: "Create",
                customerServiceNumberFormatted: "+1 (800) 775-7790",
                default: 'Default',
                delete: 'Delete',
                deviceNameRequired: "Name is required.",
                deviceNameUnique: "This name is already used by another device.",
                devicePhoneNumberUnique: "This number is already in use by another user.",
                devicePhoneNumberUniqueToUser: "This phone number is already registered as a device.",
                discard: "Discard",
                edit: "Edit",
                emailAddressInvalid: "Please enter a valid email address.",
                emailAddressNotFound: "The email address you entered is not associated with a PATLive account.",
                emailAddressRequired: "Please enter an email address.",
                emailAddressRequiredAtLeastOne: "At least one email address is required.",
                emailAddressUnique: "Sorry, the email address you entered is already in use. Please try again.",
                error: "Error",
                extensionAlreadyInUse: "Sorry, this extension is already in use.",
                extensionInvalid: "Please select an extension.",
                fileTooBig: "The selected audio file is too large. File size cannot exceed 4 MB.",
                firstNameIsRequired: "Please enter a first name.",
                industries: {
                    accounting: "Accounting",
                    architecture: "Architecture & Design",
                    arts: "Painting",
                    automotive: "Automotive",
                    beauty: "Beauty Salons & Spas",
                    camping: "Camping & Outdoors",
                    chiropractors: "Chiropractors",
                    cleaning: "Cleaning",
                    construction: "Construction",
                    consulting: "Consulting",
                    dental: "Dental",
                    education: "Education",
                    electrical: "Electrical",
                    financial: "Banking & Financial Services",
                    flooring: "Flooring",
                    funeralHome: "Funeral Home",
                    generalContracting: "General Contracting",
                    health: "Fitness & Wellness",
                    home: "Home Services",
                    hospitality: "Hospitality",
                    humanResources: "Human Resources",
                    hvac: "HVAC",
                    insurance: "Insurance",
                    internet: "Internet & Technology",
                    landscaping: "Landscaping & Lawncare",
                    legal: "Legal",
                    manufacturing: "Manufacturing",
                    marketing: "Advertising & Marketing",
                    media: "Publishing & Media",
                    medical: "Healthcare & Pharma",
                    non: "Non-Profit",
                    other: "Other",
                    personalCare: "Personal Care",
                    plumbing: "Plumbing",
                    real: "Real Estate",
                    religion: "Religious",
                    restaurant: "Restaurants & Bars",
                    retail: "Retail",
                    roofing: "Roofing",
                    sports: "Sports & Recreation",
                    telecommunications: "Telecommunications",
                    transportation: "Transportation",
                    travel: "Travel"
                },
                invalidAudioFile: "The selected file is not a valid audio file. Valid file types are MP3, WAV, WMA, and M4A.",
                lastNameIsRequired: "Please enter a last name.",
                next: "Next",
                no: "No",
                none: "[None]",
                noPermission: "You don't have permissions to do this.",
                noResultsFound: "No Results Found",
                off: "Off",
                ok: "OK",
                on: "On",
                passwordConfirmRequired: "Please re-enter password.",
                passwordDoesNotMatch: "Passwords do not match.",
                passwordIncorrect: "Incorrect password. Please try again.",
                passwordInvalid: "Password must contain 8-32 characters, 1 upper case letter, 1 lower case letter & 1 number.",
                passwordRequired: "Please enter a password.",
                phoneNumber: "Phone Number",
                phoneNumberInvalid: "Please enter a valid phone number.",
                phoneNumberRequired: "Please enter a phone number.",
                phoneNumberRequiredAtLeastOne: "Please enter a phone number. At least one phone number is required.",
                pleaseSelect: "Please select...",
                postalCodeInvalid: "Please enter a valid postal code.",
                postalCodeRequired: "Please enter a postal code.",
                pressOneToAccept: "Require the callee to \"Press 1 to Accept\"?",
                pressOneToAcceptWarningMessage: "<strong>Important!</strong> If you turn this prompt off, PATLive will not be able to tell the difference between a live person that’s answered and an automated system that’s answered." +
                    "<br><br><strong>The practical implication is this…</strong><br>" +
                    "When this feature is turned off and calls are answered by an automated system (like a cell phone’s voicemail for example), any additional actions that may have followed will not be reached. ",
                processing: "Processing...",
                repeating: 'Repeating',
                regionType: {
                    province: 'Province',
                    state: 'State',
                },
                restrictedPhoneNumber: "Must be a US or Canadian phone number.",
                restrictedPhoneNumber_us: "This doesn’t seem to be a valid US phone number.",
                restrictedPhoneNumber_ca: "This doesn’t seem to be a valid Canadian phone number.",
                save: "Save",
                scheduleOnboarding: "Schedule my Onboarding Session",
                schedulingContinueToAccount: "Continue to my account",
                schedulingContinueToOnboarding: "Continue to setup",
                schedulingHeadingText: "Book your onboarding session",
                schedulingSubtitleText: "An Onboarding Specialist will get to know your business and walk you through setting up your service.",
                search: "Search",
                serviceLiveCallAnswering: "Live Call Answering",
                serviceLiveWebChat: "Live Web Chats",
                serviceOutboundCalls: "Live Outbound Calls",
                sortBy: "Sort By",
                sortOptions: {
                    collapseAll: 'Collapse All',
                    emailAddress: 'Email Address',
                    expandAll: 'Expand All',
                    integrationStatus: "Status",
                    name: 'Name',
                    phoneNumber: 'Phone Number',
                    phoneNumber_narrow: 'Number',
                    phoneNumberName: 'Phone Name',
                    phoneNumberName_narrow: 'Name',
                    recentlyAdded: 'Recently Added',
                    recentlyAdded_narrow: 'Added',
                    recentlyModified: 'Recently Modified',
                    recentlyModified_narrow: 'Modified',
                    reportSubject: 'Subject',
                    reportFrequency: 'Frequency',
                },
                submit: "Submit",
                success: "Success",
                supportEmail: "hello@patlive.com",
                titleIsRequired: "Please enter a title.",
                vanity: 'Vanity',
                verificationAnswerRequired: "Verification answer is required.",
                yes: "Yes",
                zipCodeInvalid: "Please enter a valid ZIP code.",
                zipCodeRequired: "Please enter a ZIP code.",
            }
        };

        const sharedMessagingCompliance = {
            enUS: {
                exampleFourDescriptionOne: "Example 4: ",
                exampleFourDescriptionTwo: "Msg from {{brandName}}: Please call me when you get a minute to go over your order.",
                exampleNote: "Note - do not copy and paste these messages verbatim or your account may fail compliance validation.",
                exampleOneDescriptionOne: "Example 1: ",
                exampleOneDescriptionTwo: "Hi {Customer Name}. We got your message and will give you a call back this afternoon. - {{brandName}}",
                exampleThreeDescriptionOne: "Example 3: ",
                exampleThreeDescriptionTwo: "{{brandName}} here! My office is located at 123 Main Street. You can come by anytime M-F between 9 AM and 5 PM.",
                exampleTwoDescriptionOne: "Example 2: ",
                exampleTwoDescriptionTwo: "{{brandName}} Msg: Hi {Customer Name}. I would be happy to provide a quote for my services. When would be a good time to meet?",
                helpAutoResponseInvalid: "Requires a minimum of 20 characters.",
                helpAutoResponseRequired: "Help auto response is required.",
                jobTitleRequired: "Job Title required.",
                labelAccountNotifications: "Account Notifications",
                labelAppointmentReminders: "Appointment Reminders",
                labelConversationMessaging: "Conversation Messaging",
                labelCustomerConsentEmployeeRelationship: "Customers build relationships with one or more of our employees and express a desire to communicate by text for convenience.",
                labelCustomerConsentInitiateConversation: "Customers initiate a conversation by texting our business and we reply.",
                labelCustomerConsentLeadCaptureForms: "Customers provide their phone number and consent to receive messages via a form on our website.",
                labelCustomerConsentOnlineCheckout: "Customers provide their phone number and consent to receive messages during online checkout.",
                labelCustomerConsentOther: "Other",
                labelCustomerConsentOtherInvalid: "Requires a minimum of 40 characters.",
                labelCustomerConsentOtherRequired: "Other is required.",
                labelCustomerConsentPosTransaction: "Customers provide their phone number and consent to receive messages via POS transactions.",
                labelDeliveryStatusUpdates: "Delivery Status Updates",
                labelEmailAddress: "Email Address",
                labelGeneralMarketing: "General Marketing",
                labelHelpAutoResponse: "Help Messaging Auto Response",
                labelHelpAutoResponseDescription: "If recipients reply with HELP, PATLive will send the following auto response. You may edit a portion of the message to suit your business, but please note that you will fail compliance verification if you do not include your brand name along with an email or phone number that you can be reached at.",
                labelHelpPlaceholder: "For help, email support@company.com. To opt-out, reply STOP",
                labelHelpResponse: "Help Response",
                labelHowManyTextsPerDay: "How many texts do you anticipate sending per day?",
                labelJobTitle: "Job Title",
                labelMonthYearFounded: "Month/Year Founded",
                labelPercentOfTextsToCanada: "Do you anticipate >50% texts sent to Canadian phone numbers?",
                labelPointOfContact: "Point of Contact for any Compliance or Fraud Inquiries",
                labelPointOfContactAddress: "Point of Contact Address",
                labelPointOfContactCity: "Point of Contact City",
                labelPointOfContactEmailAddress: "Point of Contact Email Address",
                labelPointOfContactFirstName: "Point of Contact First Name",
                labelPointOfContactJobTitle: "Point of Contact Job Title",
                labelPointOfContactLastName: "Point of Contact Last Name",
                labelPointOfContactPhoneNumber: "Point of Contact Phone Number",
                labelPointOfContactPostalCode: "Point of Contact Postal Code",
                labelPointOfContactProvince: "Point of Contact Province",
                labelPointOfContactState: "Point of Contact State",
                labelPointOfContactZipCode: "Point of Contact Zip",
                labelPollingAndVoting: "Polling and Voting",
                labelSecurityOrSystemAlerts: "Security or System Alerts",
                labelSmsUseEligibility: "I understand that I cannot use Messaging for the following:",
                labelStopAutoResponse: "Stop, Quit, or Unsubscribe Messaging Auto Response",
                labelStopAutoResponseDescriptionOne: "If recipients reply with STOP, QUIT or UNSUBSCRIBE, PATLive will send the following auto response and will add the recipient’s phone number to the opt-out list for the PATLive number that was being used to text them.",
                labelStopAutoResponseDescriptionTwo: "You may edit a portion of the message to suit your business, but please note that you will fail compliance verification if you do not include an email or phone number that you can be reached at.",
                labelStopPlaceholder: "You have opted out and will not receive any further messages from this number.",
                labelStopResponse: "Opt Out Response",
                labelSummaryOfTexting: "Summary of Texting",
                labelTextMessageSampleFour: "Sample 4",
                labelTextMessageSampleOne: "Sample 1",
                labelTextMessageSampleThree: "Sample 3",
                labelTextMessageSampleTwo: "Sample 2",
                labelTextMessagingAutoResponses: "Text Messaging Auto Responses",
                labelTextMessagingBadExampleOne: "Bad Example: ",
                labelTextMessagingBadExampleTwo: "Text messages are used for our team members to communicate with our customers and partners.",
                labelTextMessagingBadExampleWhyOne: "Why is it bad? ",
                labelTextMessagingBadExampleWhyTwo: "It doesn’t say who you are or what you want to communicate.",
                labelTextMessagingCompliance: "Text Messaging Compliance",
                labelTextMessagingConsent: "Text Messaging Consent",
                labelTextMessagingConsentDescription: "How are your recipients providing their numbers and consenting to receive text messages from your business? Select all that apply.",
                labelTextMessagingDelivery: "Text Messaging Delivery",
                labelTextMessagingExamples: "Text Messaging Examples",
                labelTextMessagingGoodExampleOne: "Good Example: ",
                labelTextMessagingGoodExampleTwo: "Messages aimed at customers of a car dealership service center.  Appointment reminders, repair updates, satisfaction follow-up, online bill payment, and 2-way conversations.",
                labelTextMessagingIneligibleUseCases: "Ineligible Use Cases",
                labelTextMessagingPurpose: "Text Messaging Purpose",
                labelTextMessagingPurposeDescription: "Provide a brief description that summarizes how your business will be texting. The description must touch on a) who you are, b) who you will be texting and c) why you are texting them. ",
                labelTypesOfTextMessaging: "What type of text messages will you be sending? Select all that apply.",
                labelWebsiteUrl: "Website URL",
                majorityOfMessagesSentToCanadaRequired: "A Selection is required.",
                messagingTextsPerDayRequired: "A Selection is required.",
                noPlaceholderEmail: "You must include your company’s email or phone number.",
                pleaseSpecify: "Please specify",
                replyStop: "Reply STOP to opt-out.",
                sampleTextMessageInvalid: "Requires a minimum of 20 characters.",
                sampleTextMessageRegulatoryNotice: "Important Note About Regulatory Approval",
                sampleTextMessageRequired: "Sample Message is required.",
                smsIneligibleUseCaseFive: "General:  ",
                smsIneligibleUseCaseFiveExamples: "Phishing, Fraud or scams, Deceptive marketing, Pornography, Sex-related content, Profanity or hate speech, Firearms",
                smsIneligibleUseCaseFour: "Illegal Substances/ Activities: ",
                smsIneligibleUseCaseFourExamples: "Cannabis, Alcohol, Tobacco or vape",
                smsIneligibleUseCaseOne: "High-Risk Financial Services: ",
                smsIneligibleUseCaseOneExamples: "Payday loans, Short-term, high-interest loans, Auto loans, Mortgage loans, Student loans, Gambling, Sweepstakes, Stock alerts, Cryptocurrency",
                smsIneligibleUseCaseThree: "Debt Forgiveness: ",
                smsIneligibleUseCaseThreeExamples: "Work from home programs, Risk investment opportunities, Debt collection or consolidation",
                smsIneligibleUseCaseTwo: "Get Rich Quick Schemes:  ",
                smsIneligibleUseCaseTwoExamples: "Debt consolidation, Debt reduction, Credit repair programs, Deceptive work from home programs, Multi-level marketing",
                smsCaseEligibilityRequired: "Agreement is required.",
                stopAutoResponseInvalid: "Requires a minimum of 20 characters.",
                stopAutoResponseRequired: "Stop, Quit, or Unsubscribe auto response is required.",
                summaryOfTextingInvalid: "Requires a minimum of 40 characters.",
                summaryOfTextingRequired: "Summary of Texting is required.",
                textMessagingComplianceRequired: "Please select type of text messages you will be sending.",
                textMessagingConsentRequired: "Please select how your recipients are consenting to receive text messages.",
                textMessagingDescription: "Provide 4 sample messages of the types of message you may send. Your brand name should be included in each message. ",
                useCaseEligibilityRequired: "Agreement is required.",
                weAppendOptOut: "When we submit your sample messages to the regulatory entity that approves new brand messaging requests, we are required to append your Opt Out message to the end of one of your sample messages. For example, your Sample 1 message will actually be presented to the regulatory entity as:",
                websiteDescription: "Wireless carriers require a website presence in order to verify your identity and permit messaging to their customers. Please provide the url of your business website, such as www.patlive.com. If you do not have a business website, you may use a business social media URL instead, for example, www.facebook.com/PATLive. If your business does not have a website or social media profile, it will not be accepted or approved for messaging by wireless carriers.",
                websiteUrlInvalid: "Please enter a valid URL.",
                websiteUrlRequired: "Website URL is required.",
                weWillNotSendOptOut: "However, when  you actually go to send messages we will NOT automatically append your Opt Out instructions to messages; it is your responsibility to include your Opt Out instructions in messages that require it."
            }
        };

        return {
            "en-US": {
                "common": {
                    "accountNumber": "Account Number",
                    "all-users": "All Users",
                    "allUsers": "All Users",
                    "analytics": "Analytics",
                    "autoAttendants": "Auto Attendants",
                    "billing-admins": "Billing Admins",
                    "billingAdmin": "Billing Admins",
                    "billingAndSystemAdmin": "Billing Admins, System Admins",
                    "blocked": "Blocked",
                    "callRecordings": "Call Recordings",
                    "helpCenter": "Help Center",
                    "none": "None",
                    "okay": "Okay",
                    "tollFree": "Toll-Free",
                    "unknownLocation": "Unknown Location",
                    "settings": "Settings",
                    "system": "System",
                    "system-admins": "System Admins",
                    "systemAdmin": "System Admins",
                    "userGroups": "User Groups",
                    "voicemail": "Voicemail",
                    "region": {
                        "default": "Region",
                        "US": "State",
                        "CA": "Region"
                    },
                    areaCodeInvalid: "Please enter a valid area code.",
                    areaCodeRequired: "Please enter an area code.",
                    back: shared.enUS.back,
                    cancel: shared.enUS.cancel,
                    comingSoon: 'Coming Soon',
                    continue: "Continue",
                    copied: "Copied!",
                    customerServiceNumberFormatted: shared.enUS.customerServiceNumberFormatted,
                    deviceNameRequired: "Name is required.",
                    deviceNameUnique: "This name is already used by another device.",
                    devicePhoneNumberUnique: "This number is already in use by another user.",
                    devicePhoneNumberUniqueToUser: "This phone number is already registered as a device.",
                    discard: "Discard",
                    dismiss: "Dismiss",
                    edit: "Edit",
                    emailAddressInvalid: "Please enter a valid email address.",
                    emailAddressNotFound: "The email address you entered is not associated with a PATLive account.",
                    emailAddressRequired: "Email address is required.",
                    emailAddressRequiredAtLeastOne: "At least one email address is required.",
                    emailAddressUnique: "This email address is already in use by another PATLive user.",
                    extensionAlreadyInUse: "Sorry, this extension is already in use.",
                    extensionInvalid: "Please select an extension.",
                    fileTooBig: "Sorry, the selected audio file is too large. File size cannot exceed 4 MB. Please try again.",
                    firstNameIsRequired: "First name is required.",
                    invalidAudioFile: "Sorry, the selected file is not a valid audio file. Valid file types are MP3, WAV, WMA, and M4A and cannot exceed 4 MB.",
                    lastNameIsRequired: "Last name is required.",
                    needHelp: "Need Help? Call&nbsp;",
                    newAudioFile: "+ New Audio File",
                    next: shared.enUS.next,
                    no: shared.enUS.no,
                    noPermission: "You don't have permissions to do this.",
                    noResults: "No results found",
                    off: shared.enUS.off,
                    ok: shared.enUS.ok,
                    on: shared.enUS.on,
                    passwordConfirmRequired: "Please re-enter your password.",
                    passwordDoesNotMatch: "The passwords you entered do not match.",
                    passwordIncorrect: "Incorrect password. Please try again.",
                    passwordInvalid: "The password you entered is incorrect.",
                    passwordRequired: "Please enter a password.",
                    phoneNumberInvalid: "Please enter a valid phone number.",
                    phoneNumberRequired: "Please enter a phone number.",
                    phoneNumberRequiredAtLeastOne: "Please enter a phone number. At least one phone number is required.",
                    pleaseSelect: shared.enUS.pleaseSelect,
                    postalCodeInvalid: "Please enter a valid postal code.",
                    postalCodeRequired: "Please enter a postal code.",
                    processing: shared.enUS.processing,
                    restrictedPhoneNumber: "Please enter a US or Canadian Phone Number.",
                    restrictedPhoneNumber_us: "This doesn't seem to be a valid US phone number.",
                    restrictedPhoneNumber_ca: "This doesn't seem to be a valid Canadian phone number.",
                    search: shared.enUS.search,
                    selectACountry: "Select a country...",
                    shortCode: "Short Code",
                    signOut: "Sign Out",
                    sortBy: shared.enUS.sortBy,
                    sortOptions: shared.enUS.sortOptions,
                    submit: shared.enUS.submit,
                    supportEmail: shared.enUS.supportEmail,
                    titleIsRequired: "Please enter a title.",
                    verificationAnswerRequired: "Please enter a verification answer.",
                    yes: shared.enUS.yes,
                    zipCodeInvalid: "Please enter a valid ZIP code.",
                    zipCodeRequired: "Please enter a ZIP code.",
                },
                aboutUser: {
                    aboutYourUser: "About Your User",
                    admins: "Admins",
                    autoAttendantsRouted: "The following auto attendants may route calls to you:",
                    english: "English",
                    extensions: "Extensions",
                    extensionAssignments: "The following extension has been assigned to your user",
                    french: "French",
                    phoneNumber: "Phone Number",
                    phoneNumbersRouted: "The following phone number is routed to your user:",
                    phoneNumbersRouted_plural: "The following phone numbers are routed to your user:",
                    requestChangesTalk: "To request changes, talk to one of your account's admins:",
                    userGroupMemberships: "You are a member of the following user groups:",
                },
                accountCreationInProgress: {
                    headerText: "Preparing your account for first-time sign-in",
                    headerMessage: "We'll take you to your workspace in a few seconds",
                },
                appEntryShell: {
                    helpMessage: "Need help? Call&nbsp;",
                    warningModalHeading: "Are you sure?",
                    warningModalBodyText: "If you exit signup, you may not be able to get the same phone number when you return.",
                    warningModalDecline: "No, Continue Signup",
                    warningModalConfirm: "Yes, Exit Signup"
                },
                acceptUserInvite: {
                    accountClosed: "Account Closed",
                    accountClosedMessage: "Sorry, the PATLive account that you were invited to has been closed. Please contact your company's system administrator to find out why the account was closed or, if you need assistance from PATLive customer service, call {{customerServicePhoneNumber}}.",
                    back: shared.enUS.back,
                    confirmPassword: "Confirm Password",
                    confirmPasswordRequired: "Please re-enter your password.",
                    firstName: "First Name",
                    firstNameRequired: "First name is required.",
                    firstSetUp: "First let’s set up your user profile.",
                    jobTitle: "Job Title",
                    lastName: "Last Name",
                    lastNameRequired: "Last name is required.",
                    mobile: "Mobile",
                    mobileUnsupportedTitle: "Sorry! You can't accept this invite on a mobile device.",
                    mobileUnsupportedMessage: "Accept the invite on your desktop or laptop computer. Then, after creating your account, download the mobile app to use PATLive on your phone.",
                    needHelp: "Need Help? Call&nbsp;",
                    next: shared.enUS.next,
                    nextPassword: "Next let’s add your password.",
                    nowDevice: "And now let’s link your profile to your mobile phone.",
                    password: "Password",
                    passwordInvalid: "Password must contain 8-32 characters, 1 upper case letter, 1 lower case letter & 1 number.",
                    passwordPlaceholder: "8-32 characters, 1 upper case, 1 lower case, and 1 number",
                    passwordRequired: "Please enter a password.",
                    phoneNumberRequired: "Mobile phone number is required.",
                    done: "Done",
                    timeZone: "Time Zone",
                    userSetup: "User Setup",
                    verificationQuestion: "Verification Question",
                    verificationAnswer: "Verification Answer",
                    whenYouReceiveACall: "This mobile number will be used to set up your mobile app access and used when calls need to be transferred or forwarded to you.",
                    yourMobilePhoneNumber: "Your Mobile Phone Number"
                },
                invalidLink: {
                    expired: "Expired Link",
                    expiredMessage: "Sorry, this invite link has expired. Please contact your company's system administrator to request a new invite, or if you need assistance from PATLive customer service, call {{customerServicePhoneNumber}}.",
                    invalid: "Invalid Link",
                    invalidMessage: "We're sorry, but this invite is invalid. If you copied the link from your email, please verify that you copied the entire URL. If you feel that you have reached this message in error, please contact your system administrator to receive another invite."
                },
                analytics: {
                    addScheduledReport: "Add Scheduled Report",
                    analytics: 'Analytics',
                    calls: 'Calls',
                    chats: "Chats",
                    day: 'Day',
                    hour: 'Hour',
                    inbound: 'Inbound',
                    month: 'Month',
                    noResultsFound: shared.enUS.noResultsFound,
                    outbound: 'Outbound',
                    stats: 'Stats',
                    total: 'Total',
                    week: 'Week',
                    nonAdminWarning: "Your analytics is limited to calls that you placed or received - you don't have permissions to report on call data associated with other PATLive users. If you need to report on calls placed or received by other users, please have a System Admin add you to the System Admins group.",
                    sendOneTimeReport: "Send One-Time Report",
                },
                analyticsList: {
                    answered: 'Answered',
                    areYouSureYouWantToDeleteThis_recording: "Are you sure you want to delete this Call Recording?",
                    areYouSureYouWantToDeleteThis_voicemail: "Are you sure you want to delete this Voicemail?",
                    billableDuration: 'Billed',
                    blocked: 'Blocked',
                    callRecording: 'Call Recording',
                    cancel: shared.enUS.cancel,
                    date: 'Date',
                    delete: "Delete",
                    deleted: 'Deleted {{date}}',
                    deletedRecording: 'This call recording has been deleted and is no longer available to play.',
                    deletedVoicemail: 'This voicemail has been deleted and is no longer available to play.',
                    delete_recording: "Delete Call Recording",
                    delete_voicemail: "Delete Voicemail",
                    deleteThis_recording: "Delete this Call Recording",
                    deleteThis_voicemail: "Delete this Voicemail",
                    details: 'Details',
                    download: 'Download',
                    duration: 'Duration',
                    from: "From",
                    missed: 'Missed',
                    na: 'N/A',
                    noResults: shared.enUS.noResultsFound,
                    noResultsFound: shared.enUS.noResultsFound,
                    notRecordingSubscriber: "You don't have the required permissions to play this call recording.",
                    notSubscribed: 'Not Subscribed',
                    notVoicemailSubscriber: "You don't have the required permissions to play this voicemail.",
                    new: 'Mark as Reviewed',
                    outbound: 'Outbound',
                    reviewed: 'Mark As New',
                    system: 'System',
                    to: 'To',
                    type: 'Type',
                    voicemail: 'Voicemail',
                },
                analyticsSidebar: {
                    all: "All",
                    anyNumber: 'Any Number',
                    anyUserOrGroup: 'Any User or Group',
                    calls: 'Calls',
                    chats: 'Web Chats',
                    external: "External",
                    filters: "Filters",
                    inbound: 'Inbound',
                    internal: "Internal",
                    minutes: "Minutes",
                    month: 'Month',
                    outbound: 'Outbound',
                    refresh: 'Refresh',
                    scripts: 'Receptionist Scripts',
                    selectNumbers: 'Select Numbers',
                    selectUsersOrGroups: 'Select Users or Groups',
                    total: 'Total',
                    callTypeTooltip: "Analytics only shows calls that <br/> were routed through a phone number.",
                    show: 'Show',
                    connected: 'Phone Numbers',
                    involving: 'Users and Groups'
                },
                analyticsTotals: {
                    answered: 'Answered',
                    inbound: 'Inbound',
                    minutes: 'Minutes',
                    missed: 'Missed',
                    outbound: 'Outbound',
                    system: 'System',
                },
                analyticsSummary: {
                    answered: 'Answered',
                    answeredMinified: 'Answered',
                    averageDuration: 'Average',
                    averageDurationMinified: 'Avg',
                    billed: 'Billed',
                    billedMinified: 'Billed',
                    downloadCsv: 'Download CSV',
                    forwardingNumber: 'Forwarding Number',
                    forwardingNumberMinified: 'Forwarding Number',
                    group: 'Group',
                    hostedNumber: 'Phone Number',
                    hostedNumberMinified: 'Phone Number',
                    inbound: 'Inbound',
                    inboundMinified: 'In',
                    minutes: 'Minutes',
                    minutesMinified: 'Minutes',
                    missed: 'Missed',
                    missedMinified: 'Missed',
                    noResults: shared.enUS.noResultsFound,
                    noResults_user: 'There are no results for Users.',
                    noResults_userGroup: 'There are no results for User Groups.',
                    noResults_forwardingNumber: 'There are no results for Forwarding Numbers.',
                    noResults_hostedNumber: 'There are no results for Phone Numbers.',
                    outbound: 'Outbound',
                    outboundMinified: 'Out',
                    phoneNumber: 'Phone Number',
                    phoneNumberMinified: 'Phone Number',
                    liveReceptionistScript: 'Script',
                    liveReceptionistScriptMinified: 'Script',
                    scheduleReport: "Add Scheduled Report",
                    summary: "Summary",
                    system: 'System',
                    total: 'Total',
                    totalCalls: 'Calls',
                    totalCallsMinified: 'Calls',
                    totalChats: 'Chats',
                    totalChatsMinified: 'Chats',
                    totalDuration: 'Duration',
                    totalDurationMinified: 'Duration',
                    user: 'User',
                    userMinified: 'User',
                    userGroup: 'Group',
                    userGroupMinified: 'Group',
                    voicemails: 'Inbox',
                    voicemailsMinified: 'Inbox',
                    webChatDomain: 'Domain',
                    webChatDomainMinified: 'Domain',
                    webChatWidget: 'Web Chat Widget',
                    webChatWidgetMinified: 'Web Chat Widget',
                },
                filterOptions: {
                    phoneNumber: 'Phone Number',
                    show: 'Show',
                    sortBy: 'Sort By',
                    all: 'All',
                    new: 'New',
                    reviewed: 'Reviewed',
                    invalidTooltip: 'At least one phone number is required'
                },
                addScheduledReportModal: {
                    addEmailAddress: "+ Add Email Address",
                    csv: 'CSV',
                    daily: "Daily",
                    day: "Day",
                    disabledAddEmailAddress: "Cannot add more than 10 email addresses",
                    email: 'Email',
                    emailAddressRequiredAtLeastOne: shared.enUS.emailAddressRequiredAtLeastOne,
                    format: 'Format',
                    frequency: 'Frequency',
                    graphBy: 'Graph Points By',
                    hour: "Hour",
                    message: "Message",
                    month: "Month",
                    monthly: "Monthly",
                    oneTimeReport: "Send One-Time Report",
                    pdf: "PDF",
                    scheduleReport: "Add Scheduled Report",
                    sendNow: "Send One-Time Report",
                    sendToEmailAddressesLabel: "Send to the following email addresses:",
                    subject: "Subject",
                    subjectRequired: "Subject is required",
                    subjectTemplate: "Calls Report for",
                    week: "Week",
                    weekly: "Weekly",
                },
                forgotPassword: {
                    buttonText: "Send Password Reset Email",
                    customerServiceMessage: "If you don't receive it in the next few minutes, please check your spam folder, and if you still don't see it, call us at " + shared.enUS.customerServiceNumberFormatted,
                    emailAddress: "Email Address",
                    emailAddressRequired: shared.enUS.emailAddressRequired,
                    emailAddressInvalid: shared.enUS.emailAddressInvalid,
                    emailAddressUnique: shared.enUS.emailAddressNotFound,
                    emailAddressNotRegistered: shared.enUS.emailAddressNotFound,
                    emailAddressInviteCanceled: shared.enUS.emailAddressNotFound,
                    expiredLinkHeader: "Password reset expired",
                    expiredLinkMessage: "Enter your account email below and we will send you a link to create a new password.",
                    header: "Forgot Your Password?",
                    message: "Enter your account email below and we will send you a link to create a new password.",
                    mobileUnsupportedTitle: "Sorry! You can’t reset your password on a mobile device.",
                    mobileUnsupportedMessage: "Use your desktop or laptop computer.",
                    resetConfirmation: "We've sent a password reset email to",
                    signInLink: "Sign In",
                    userDeactivated: "Your login has been deactivated. Please contact your System Admin or call us at " + shared.enUS.customerServiceNumberFormatted,
                },
                login: {
                    buttonText: "Sign In",
                    dontHaveAnAccount: "Don't have an account?&nbsp;",
                    downloadTheApp: "Download The App",
                    emailAddress: "Email Address",
                    emailAddressRequired: shared.enUS.emailAddressRequired,
                    emailAddressInvalid: shared.enUS.emailAddressInvalid,
                    forgotPassword: "Forgot Password?",
                    greeting: "Sign In",
                    inviteExpired: "Your invite was never accepted and is now expired.",
                    invitePending: "You must accept your invite before you can sign in. Resend Invite",
                    message: "Sign in to your account",
                    mobileUnsupportedTitle: "Sorry! You can’t sign in here. We’re working on it. ",
                    mobileUnsupportedMessage: "You must be on a desktop or laptop computer to use the web app. Alternatively, you can download the mobile app to use PATLive on your phone.",
                    password: "Password",
                    passwordInvalid: "The password you entered is incorrect.",
                    passwordRequired: "Please enter a password.",
                    signup: "Sign up",
                    userDeactivated: "This user has been deactivated.",
                    usernameInvalid: "The email address you entered is not associated with a PATLive account.",
                },
                accountClosed: {
                    accountClosed: "Your account has been closed.",
                    finalInvoiceMessage: "Your credit card will be automatically charged 3 days after the final statement is generated.",
                    finalInvoiceMessageAch: "Your final statement will be generated shortly.",
                    finalInvoiceMessageInvoice: "Your final invoice will be sent once the final statement is generated.",
                    signInLink: "Sign In",
                    sorryToSeeYouGo: "If you ever need to reopen your account, you can do so by signing in to the web app and following the prompts, or call " + shared.enUS.customerServiceNumberFormatted + " and a member of our Customer Service team will be happy to assist you.",
                },
                closedCannotReactivate: {
                    agentBypass: shared.enUS.agentBypass,
                    headerTitle: "Hi, {{firstName}}!",
                    headerMessage: "Your company's PATLive account is closed. If you'd like to reactivate, you'll need to ask one of your company's Billing Admins to do so."
                },
                closedDoNotReactivate: {
                    agentBypass: shared.enUS.agentBypass,
                    headerTitle: "Account Closed",
                    headerMessage: "Your account is closed and cannot be reactivated."
                },
                closedBalanceOwed: {
                    agentBypass: shared.enUS.agentBypass,
                    customerAgreesToPayAcknowledgement: "I understand that {{pastDueBalance}} will be charged to the payment method above.",
                    customerAgreesToTermsOfUse_part1: "I agree to PATLive's ",
                    customerAgreesToTermsOfUse_part2: "terms of use.",
                    headerTitle: "Past Due Balance",
                    newCard: "New Card",
                    paymentMethod: "Payment Method",
                    reactivateAccount: "Reactivate Account",
                    payBalance: "Pay Balance",
                    payBalanceAndReactivateAccount: "Pay & Reactivate Account",
                    payBalanceAndKeepAccountClosed: "Pay & Keep Account Closed",
                    agreementRequired: "You must agree to continue.",
                    acknowledgementRequired: "You must acknowledge that you understand to continue.",
                    warningTitle: "Your account is closed.",
                    warningTitlePastDueBalance: "Your account is closed and you have a past due balance of {{pastDueBalance}}.",
                    warningMessage: "To reactivate, provide a method of payment.",
                    warningMessageCannotReactivate: "To continue, provide a method of payment.",
                    declinedTitle: "Payment failed",
                    declinedMessage: "Verify the details above and try again.",
                    genericFailureTitle: "We’ve encountered an issue",
                    genericFailureMessage: "Please call " + shared.enUS.customerServiceNumberFormatted + " for assistance processing your payment."
                },
                miscellaneousProblems: {
                    agentBypass: shared.enUS.agentBypass,
                    headerTitle: "Security Hold",
                    headerMessage: "Your account has been flagged for a possible security violation."
                },
                payBalance: {
                    agentBypass: shared.enUS.agentBypass,
                    balancePaid: "Balance Paid",
                    balancePaidMessage: "Thanks, your payment of {{paymentAmount}} has been received.",
                    customerAgreesToPayAcknowledgement: "I understand that {{pastDueBalance}} will be charged to the payment method above.",
                    headerTitle: "Past Due Balance",
                    needHelp: "Need Help? Call&nbsp;",
                    newCard: "New Card",
                    payLater: "I’ll pay this later >",
                    payBalance: "Pay Balance",
                    paymentMethod: "Payment Method",
                    agreementRequired: "You must acknowledge that you understand to continue.",
                    warningTitle: "Your account has a past due balance of {{pastDueBalance}}.",
                    warningMessage: "Please check the box below to pay the balance due.",
                    warningMessageAutoClose: "If the balance is not paid by {{- autoCloseDate}}, your account will be closed.",
                    warningMessageNoPaymentMethod: "Please contact us to pay the balance due.",
                    contactUsTitle: "Contact us to pay your balance",
                    contactUsMessagePart1: "To pay your balance, please call us at " + shared.enUS.customerServiceNumberFormatted + " or email ",
                    contactUsMessageLink1: shared.enUS.supportEmail,
                    contactUsMessagePart2: ".",
                    declinedTitle: "Payment failed",
                    declinedMessage: "Verify the details above and try again.",
                    genericFailureTitle: "We’ve encountered an issue",
                    genericFailureMessage: "Please call " + shared.enUS.customerServiceNumberFormatted + " for assistance processing your payment."
                },
                reactivation: {
                    agentBypass: shared.enUS.agentBypass,
                    balancePaid: "Balance Paid",
                    balancePaidMessage: "Thanks, your payment of {{paymentAmount}} has been received.",
                    balancePaidMessageReactivated: "Your account has been reactivated.",
                    balancePaidMessageChoosePlan: "Next, confirm your plan to reactivate your account.",
                    agreeToTerms: "By continuing, you agree to the ",
                    agreeToTermsLink: " PATLive Terms of Use.",
                    customerAgreesToPayAcknowledgement: "I understand that {{pastDueBalance}} will be charged to the payment method above.",
                    headerTitle: "Reactivate Account",
                    newCard: "New Card",
                    paymentMethod: "Payment Method",
                    reactivateAccount: "Reactivate Account",
                    payBalance: "Pay Balance",
                    payBalanceAndContinue: "Pay Balance & Continue",
                    payBalanceAndReactivateAccount: "Pay & Reactivate Account",
                    payBalanceAndKeepAccountClosed: "Pay & Keep Account Closed",
                    acknowledgementRequired: "You must acknowledge that you understand to continue.",
                    welcomeTitle: "Welcome back, {{firstName}}!",
                    warningTitlePastDueBalance: "Welcome back, {{firstName}}! Your account is closed and you have a past due balance of {{pastDueBalance}}.",
                    welcomeMessage: "To reactivate your account, let's begin by confirming your preferred payment method.",
                    welcomeMessageReinstatement: "To reactivate your account, let's confirm your preferred payment method.",
                    welcomeMessageNoCardReinstatement: "Your plan and billing details remain unchanged. You can make changes from your Billing Settings after reactivating your account.",
                    welcomeMessageNoCard: "Let's get your account reactivated. You'll confirm your plan on the next step.",
                    warningMessageCannotReactivate: "To continue, confirm your preferred payment method.",
                    contactUsTitle: "Contact us to reactivate your account",
                    contactUsMessagePart1: "To reactivate your account, please call us at " + shared.enUS.customerServiceNumberFormatted + " or email ",
                    contactUsMessageLink1: shared.enUS.supportEmail,
                    contactUsMessagePart2: ".",
                    declinedTitle: "Card authorization failed.",
                    declinedMessage: "Verify the details above and try again.",
                    genericFailureTitle: "We’ve encountered an issue",
                    genericFailureMessage: "Please call " + shared.enUS.customerServiceNumberFormatted + " for assistance processing your payment."
                },
                reactivationPlans: {
                    agentBypass: shared.enUS.agentBypass,
                    forDetails: "For details, please visit our &nbsp;",
                    headerTitle: "These are your current plans.",
                    headerMessage: "You can adjust your account plans before reactivation or later through your billing settings.",
                    labelChange: "Change",
                    labelRemove: "Remove",
                    packagePickerTitle: "{{type}} Plans",
                    packagePickerMessage_liveReceptionist: "Make the most of every call you receive with the industry’s best 24/7 phone answering service.",
                    packagePickerMessage_webChat: "Capture more leads, book more appointments and provide better support with 24/7 live chat service.",
                    packagePickerMessage_outboundCalling: "Take control of your client communication with our Outbound Calling service.",
                    pricingPage: "pricing page",
                    submit: "Ok! I'm ready to Reactivate"
                },
                reactivationSuccess: {
                    agentBypass: shared.enUS.agentBypass,
                    confirmationMessageTitle: "Welcome back!",
                    confirmationMessageBody: "Your account has been reactivated.",
                    ctaMobileTitle: "PATLive Mobile",
                    ctaMobileBody: "Download the mobile app to start calling and texting.",
                    ctaDesktopTitle: "PATLive Web",
                    ctaDesktopBody: "To add users, view leads, or make changes to how PATLive handles your calls, ",
                    ctaDesktopBodyLink: "sign in to the web app.",
                    ctaOnboardingApptTitle: "Meet Your Onboarding Specialist",
                    ctaOnboardingApptLink: "schedule a meeting ",
                    ctaOnboardingApptMessageOne: "The next step is to ",
                    ctaOnboardingApptMessageTwo: "with an Onboarding Specialist, who will work with you to review your personalized interaction handling instructions for your business.",
                },
                resendInvite: {
                    headerTitle: "Invite Sent",
                    dismiss: "Dismiss",
                    inviteSentMessage: "A new invite email has been sent. It expires {{ expirationDate }}.",
                },
                addPhoneNumber: {
                    invalidVanityCharacter: "Search string can only contain letters and numbers.",
                    invalidLocalVanityLength: "Please enter at least 3 characters.",
                    invalidTollVanityLength: "Please enter at least 4 characters.",
                    pricingPage: "pricing page"
                },
                addPhoneNumberTypeChooser: {
                    addPhoneNumber: shared.enUS.addPhoneNumber,
                    cancel: shared.enUS.cancel,
                    local: "Local",
                    transfer: "Transfer",
                    tollFree: "Toll-Free",
                    whatTypeNumber: 'What type of number do you want to add?',
                },
                addPhoneNumberLocal: {
                    addPhoneNumber: "Add a Local Phone Number",
                    add: shared.enUS.add,
                    back: shared.enUS.back,
                    cancel: shared.enUS.cancel,
                    default: shared.enUS.default,
                    mustSelectAPhoneNumber: "Please select at least one phone number.",
                    pricingMessage: "You'll be charged a monthly fee for each additional phone number. For details, please visit our ",
                    moreComplianceInfoNeeded: {
                        title: "Local phone number messaging limit reached.",
                        warningPart1: "Due to FCC and wireless carrier regulations, VOIP local phone numbers must be registered with the ",
                        warningLink1: shared.enUS.campaignRegistry,
                        warningPart2: " before they can be used for text messaging. To register more than 1 local phone number, you must have an EIN or Registry ID on file.",
                        warningPart3: "To enable messaging on more than 1 local phone number, update your ",
                        warningLink2: "Messaging Compliance",
                        warningPart4: " to include your EIN or Registry ID.",
                        warningPart5: "Alternatively, you can enable messaging on a new phone number if you disable messaging on one of these local phone numbers:",
                    },
                    personalAccountLimitReached: {
                        title: "Local phone number messaging limit reached.",
                        warningPart1: "Due to FCC and wireless carrier regulations, VOIP local phone numbers must be registered with the ",
                        warningLink1: shared.enUS.campaignRegistry,
                        warningPart2: " before they can be used for text messaging. To register more than 1 local phone number, you must be a business or non-profit organization with an EIN or Registry ID on file.",
                        warningPart3: "As a personal account, you cannot enable messaging on more than 1 local phone number. If you need to change your account type and have a valid EIN or Registry ID, call " + shared.enUS.customerServiceNumberFormatted + " or email ",
                        warningLink2: shared.enUS.supportEmail,
                        warningPart4: ".",
                        warningPart5: "Otherwise, you can add the selected number(s), but some will have messaging disabled.",
                    },
                    tcrRegistrationFailed: {
                        title: "We encountered a problem enabling messaging.",
                        warningPart1: "We were unable to verify your business information. The number(s) you selected have been added to your account, but text messaging is currently disabled on the new local number(s) you added.",
                        warningPart2: "For help resolving this error, please call " + shared.enUS.customerServiceNumberFormatted + " or email ",
                        warningLink1: shared.enUS.supportEmail,
                        warningPart3: ".",
                    }
                },
                addPhoneNumberTollFree: {
                    addPhoneNumber: "Add a Toll-Free Phone Number",
                    add: shared.enUS.add,
                    back: shared.enUS.back,
                    cancel: shared.enUS.cancel,
                    default: shared.enUS.default,
                    mustSelectAPhoneNumber: "Please select at least one phone number.",
                    pricingMessage: "You'll be charged a monthly fee for each additional phone number. For details, please visit our ",
                },
                numberPickerConstants: {
                    begins: "Begins With",
                    contains: "Contains",
                    ends: "Ends With",
                    error_begins: "begin with",
                    error_contains: "contain",
                    error_ends: "end with",
                },
                addPhoneNumberPort: {
                    acknowledgementStatement: "By signing below, I attest under penalty of law that I am (a) the legal owner of the phone number(s) included in this port request; or (b) am an authorized employee or representative of the entity requesting the port.  I am, or the entity identified above, is the exclusive end-user subscriber of the phone number(s) included in this port request and I/we assume all liability for the use of the phone number(s).  I acknowledge and understand that I must notify my existing carrier of my intention to change my service provider to PATLive and bear all responsibility for costs that continue to accrue with my former carrier/service provider.",
                    addFailure: "We encountered a problem with the following number - it was not added to your account.",
                    addFailure_plural: "We encountered a problem with the following numbers - they were not added to your account.",
                    addSuccess: 'The following number was successfully queued for transfer to your account.',
                    addSuccess_plural: 'The following numbers were successfully queued for transfer to your account.',
                    addSuccessInfo: 'You’ll receive a notification when the transfer completes. A customer service team member will reach out if we need additional information to complete the transfer.',
                    authorizedSignature: "Authorized signature is required.",
                    addMoreMessage: "To port in more than twenty-five phone numbers, please call PATLive customer service at +1 (800) 775-7790.",
                    addPhoneNumber: "Transfer a Number",
                    addPhoneNumbers: 'Add Phone Numbers',
                    back: shared.enUS.back,
                    billingAddressRequired: "Please enter an address.",
                    billingCityRequired: "Please enter a city.",
                    billingNameRequired: "Please enter a name.",
                    billingNumberLength: shared.enUS.phoneNumberInvalid,
                    billingNumberRequired: shared.enUS.phoneNumberRequired,
                    cancel: shared.enUS.cancel,
                    carrierRequired: "Please enter your current carrier.",
                    desiredPortDateStatement: "I understand that my Desired Port Date is not a guaranteed port-on date and may complete before or after this date due to circumstances outside of PATLive's control.",
                    error: shared.enUS.error,
                    googleWarning: "Before porting in your Google Voice number, you'll need to unlock it. There is a fee that comes with unlocking your number.",
                    googleWarning1: "1. On your computer, go to the ",
                    googleWarning1Link: "Google Voice unlock page",
                    googleWarning2: "2. Point to the Google Voice number you want to transfer, and click Unlock my number.",
                    googleWarning3: "3. Click Continue.",
                    googleWarning4: "4. Pay with your Google Account. You’ll get your receipt by email.",
                    labelAccountNumber: "Account Number",
                    labelAddress: "Address",
                    labelApt: "Apt/Suite",
                    labelAuthorizedSignature: "Authorized Signature",
                    labelCarrier: "Carrier and Phone Number To Port",
                    labelCity: "City",
                    labelCountry: "Country",
                    labelCurrentCarrier: "Current Carrier",
                    labelDesiredPortDate: "Desired Port Date",
                    labelName: "Name",
                    labelNumberToPort: "Phone Number to Port",
                    labelOptional: "Optional",
                    labelPhoneNumber: "Phone Number",
                    labelPinOrPasscode: "Pin/Passcode",
                    labelPostalCode: "Postal Code",
                    labelProvince: "Province",
                    labelState: "State",
                    labelZipCode: "Zip Code",
                    linkAdd: "+ Add Another Number",
                    loggedInAs: "Agents cannot submit transfer number requests for customers.",
                    matchStatement1: "The billing information",
                    matchStatementBold: " must match the billing information on file with your current carrier.",
                    matchStatement2: " If you're unsure, please consult your most recent bill.",
                    next: shared.enUS.next,
                    noPortsWhenForCustomer: "Agents can not submit port number requests for customers",
                    optionOnlyNumber: "This is the only number on the account.",
                    optionOnlyNumber_plural: "These are the only numbers on this account.",
                    optionOtherNumbers: "There are other numbers on the account&semi; do not port them.",
                    placeholderLoading: "Loading...",
                    portDateRequired: "Please specify your desired port date.",
                    portDateAcknowledgment: "You must acknowledge that you understand to continue.",
                    portingWarningTitle: "PATLive is Not a Cell Phone Carrier",
                    portingWarningMessage: "If you want to port your number to PATLive and use it for calling, texting and data services, you will need a second number with your current carrier.",
                    postalCodeInvalid: shared.enUS.postalCodeInvalid,
                    postalCodeRequired: shared.enUS.postalCodeRequired,
                    pricingMessage: "You'll be charged a monthly fee for each additional phone number. For details, please visit our ",
                    selectedNumbers: "Numbers to Port from {{carrierName}}",
                    success: shared.enUS.success,
                    tabTitleAuthorization: "3 ) Authorization",
                    tabTitleBilling: "2 ) Billing",
                    tabTitleNumbers: "1 ) Numbers",
                    transfer: 'Transfer',
                    tooltipAccountNumberLine1: "The account number listed on the",
                    tooltipAccountNumberLine2: "invoice from your current carrier.",
                    tooltipPinOrPasscode: "If a PIN or passcode is required to <br/> access your account, we’ll need it <br/> to port your number away from <br/> your current carrier.",
                    zipCodeInvalid: shared.enUS.zipCodeInvalid,
                    zipCodeRequired: shared.enUS.zipCodeRequired
                },
                addPhoneNumberSummary: {
                    close: shared.enUS.close,
                    messagingDisabled: "Messaging Disabled",
                    phoneNumbersAdded: "Phone numbers added to your account",
                    phoneNumbersFailed: `Phone numbers <strong>not added to your account</strong> because they are no longer available or we encountered an error`,
                    pricingMessage: "You'll be charged a monthly fee for each additional phone number. For details, please visit our ",
                    purchaseSummary: "Purchase Summary",
                    moreComplianceInfoNeeded: {
                        title: "Local phone number messaging limit reached.",
                        warningPart1: "Due to FCC and wireless carrier regulations, VOIP local phone numbers must be registered with the ",
                        warningLink1: shared.enUS.campaignRegistry,
                        warningPart2: " before they can be used for text messaging. To register more than 1 local phone number, you must have an EIN or Registry ID on file.",
                        warningPart3: "To enable messaging on more than 1 local phone number, update your ",
                        warningLink2: "Messaging Compliance",
                        warningPart4: " to include your EIN or Registry ID.",
                        warningPart5: "Alternatively, you can enable messaging on a new phone number if you disable messaging on one of these local phone numbers:",
                    },
                    personalAccountLimitReached: {
                        title: "Local phone number messaging limit reached.",
                        warningPart1: "Due to FCC and wireless carrier regulations, VOIP local phone numbers must be registered with the ",
                        warningLink1: shared.enUS.campaignRegistry,
                        warningPart2: " before they can be used for text messaging. To register more than 1 local phone number, you must be a business or non-profit organization with an EIN or Registry ID on file.",
                        warningPart3: "As a personal account, you cannot enable messaging on more than 1 local phone number. If you need to change your account type and have a valid EIN or Registry ID, call " + shared.enUS.customerServiceNumberFormatted + " or email ",
                        warningLink2: shared.enUS.supportEmail,
                        warningPart4: ".",
                        warningPart5: "Alternatively, you can enable messaging on a new phone number if you disable messaging on one of these local phone numbers:",
                    },
                    tcrRegistrationFailed: {
                        title: "We encountered a problem enabling messaging.",
                        warningPart1: "We were unable to verify your business information. The number(s) you selected have been added to your account, but text messaging is currently disabled on the new local number(s) you added.",
                        warningPart2: "For help resolving this error, please call " + shared.enUS.customerServiceNumberFormatted + " or email ",
                        warningLink1: shared.enUS.supportEmail,
                        warningPart3: ".",
                    },
                },
                receptionist: {
                    header: "Receptionist",
                    noResults: shared.enUS.noResultsFound,
                    noReceptionistMessages: "No Receptionist Messages to Display",
                    isNew: "",
                    isNew_new: "Mark as Reviewed",
                    isNew_reviewed: "Mark as New"
                },
                receptionistMessage: {
                    header: "Receptionist Message",
                    isNew: "",
                    isNew_new: "Mark as Reviewed",
                    isNew_reviewed: "Mark as New",
                    messageNotFound: "Sorry, we can't find that receptionist message.",
                },
                receptionistSidebar: {
                    clearFilters: "Clear Filters",
                    labelFilters: "Filters",
                    labelInteraction: "Interaction",
                    labelJunk: "Include Junk",
                    labelShow: "Show",
                    labelSubscriptions: "Subscriptions",
                    noSubscriptionsAvailable: "No Subscriptions Available",
                    searchMessages: "Search Messages"
                },
                comboBox: {
                    dailyLimitHit: "Daily Limit Reached",
                    noResultsFound: "No Results Found"
                },
                contacts: {
                    added: "Added",
                    address: "Address",
                    appleWatch: "Apple Watch",
                    birthday: "Birthday",
                    call: "Call",
                    ca: "Canada",
                    companyAddressBook: "Company Address Book",
                    deviceLabel: "Houston Office",
                    deviceNumber: "+1 (234) 234-5566",
                    edit: "Edit",
                    email: "Email",
                    extension: "Extension",
                    home: "Home",
                    homeFax: "Home Fax",
                    iPhone: "iPhone",
                    joiningWebApp: "Contacts is joining the Web App!",
                    main: "Main",
                    map: "Map",
                    message: "Message",
                    mobile: "Mobile",
                    modified: "Modified",
                    newCall: "New Call",
                    note: "Notes",
                    other: "Other",
                    pager: "Pager",
                    personal: "Personal",
                    phone: "Phone",
                    school: "School",
                    sendMessage: "Send Message",
                    source: "Source",
                    tresta: "PATLive",
                    trestaUserGroups: "PATLive Users & Groups",
                    url: "URL",
                    work: "Work",
                    workFax: "Work Fax",
                    yourAddressBook: "Your Address Book",
                    us: "United States of America",
                    unsupportedModalTitle: "Unsupported Recipient",
                    unsupportedModalText: "This phone number does not appear to be a North American phone number that's capable of receiving text messages. Check that the number is formatted correctly and try again."
                },
                contactDetails: {
                    edit: "Edit",
                    noPermissionUsers: "You don’t have permissions to edit users.",
                    members: "Members",
                    membership: "Group Membership"
                },
                addContact: {
                    add: shared.enUS.add,
                    addAddress: "+ Add Address",
                    added: "Added",
                    addEmailAddress: "+ Add Email Address",
                    addPhoneNumber: "+ Add Phone Number",
                    address: "Address",
                    addressLineOne: "Address",
                    addressLineTwo: "Address 2",
                    addUrl: "+ Add URL",
                    birthday: "Birthday",
                    block: "Block Contact",
                    cancel: shared.enUS.cancel,
                    city: "City",
                    country: "Country",
                    delete: "Delete Contact",
                    deleteConfirmation: "Are you sure you want to delete this contact?",
                    disabledAddAddress: "Cannot add more than 10 addresses",
                    disabledAddEmailAddress: "Cannot add more than 10 email addresses",
                    disabledAddPhoneNumber: "Cannot add more than 10 phone numbers",
                    disabledAddUrl: "Cannot add more than 10 URLs",
                    disabledEdit: "You don’t have permissions <br> to edit this contact.",
                    disabledShared: "You don't have permissions to save to the shared address book",
                    discard: "Discard Changes",
                    discardConfirmation: "You’re about to discard your changes.",
                    editHeader: "Edit Contact",
                    email: "Email",
                    header: "Add Contact",
                    labelCompany: "Company",
                    labelFirstName: "First Name",
                    labelJobTitle: "Job Title",
                    labelLastName: "Last Name",
                    modified: "Modified",
                    notes: "Notes",
                    number: "Number",
                    other: "Other",
                    phone: "Phone",
                    postal: "Postal",
                    private: "Your Address Book (Private Contact)",
                    province: "Province",
                    save: "Save",
                    shared: "Company Address Book (Shared Contacts)",
                    source: "Source",
                    state: "State",
                    type: "Type",
                    url: "URL",
                    validation: {
                        requiredMessage: "At least one of the following is required:",
                        requiredItems: "First Name, Last Name, Company, Email, or Phone",
                        phoneNumberDuplicate: "This number has already been added.",
                        emailDuplicate: "This email address has already been added.",
                        addressDuplicate: "This address has already been added.",
                        invalidBirthday: "Please enter a valid birthday."
                    },
                    zip: "Zip"
                },
                duplicateContactActionModal: {
                    title: "Contact Already Exists",
                    nDuplicateContacts: "This contact has the same phone or email as another contact.",
                    nDuplicateContacts_plural: "These contacts have the same phone or email.",
                    addConfirmation: "Do you want to create a new contact anyway?",
                    editConfirmation: "Do you want to save anyway?"
                },
                contactsSidebar: {
                    all: "All",
                    companyAddressBook: "Company Address Book",
                    firstName: "First Name",
                    labelAdded: "Added",
                    labelContacts: "Contacts",
                    labelFilters: "Filters",
                    labelModified: "Modified",
                    lastName: "Last Name",
                    noContacts: "No Contacts to display",
                    searchContacts: "Search Contacts",
                    show: "Show",
                    sortBy: "Sort By",
                    trestaUserGroups: "PATLive Users & Groups",
                    yourAddressBook: "Your Address Book",
                    tooltip: "At least one contact source is required."
                },
                messages: {
                    attachmentText: "Attach File",
                    blocked: "Blocked",
                    blockedContact: "Contact Blocked",
                    nBlockedContacts: "{{ count }} participant is blocked",
                    nBlockedContacts_plural: "{{ count }} participants are blocked",
                    blockedNewConversation: "Start a new conversation with remaining participants",
                    comingSoon: "Coming Soon",
                    conversationNotFound: "Sorry, we can't find that conversation.",
                    dailyLimitHit: "Daily Limit Reached",
                    enterToContinue: "Hit Enter to Continue",
                    maxRecipientsReached: "You've reached the max number of recipients",
                    mobile: "Mobile",
                    newMessage: "New Message",
                    nNewMessages: "{{ newMessagesCount }} New Messages",
                    noMessages: "No Messages to display",
                    oneNewMessage: "1 New Message",
                    recipientInputPlaceholder: "Enter a phone number",
                    search: "Search",
                    phoneNumberAccessRevoked: "Phone Number Access Revoked",
                    phoneNumberNoLongerAvailable: "The phone number you selected is no longer available. Please select another phone number to send messages from.",
                    textingHasNotBeenEnabled: "Messaging Hasn't Been Enabled for any Phone Numbers",
                    textingNotEnabled: "Messaging Isn't Enabled for Your User",
                    toEnableMessages: "To enable messages, contact one of your company's System Admins.",
                    toEnableMessagesAdmin1: "To enable messages, go to ",
                    toEnableMessagesAdmin2: "Phone Numbers",
                    toEnableMessagesAdmin3: " > Edit Phone Numbers > Messages tab.",
                    tollFree: "Toll-free",
                    reachedDailyLimit: "You’ve reached your daily limit for text messaging.",
                    reachedDailyLimitReadArticle: "Read Help Article",
                    retrySendingMessage: "Retry Sending Message",
                    deleteMessage: "Delete Message",
                    fullScreen: "Full Screen",
                    play: "Play",
                    pause: "Pause",
                    mute: "Mute",
                    unmute: "Unmute",
                    reachedMaxAttachments: "10 attachment limit reached. Some files were excluded.",
                    fileLarge: "File Too Large",
                    fileLargeExplanation: "Unable to upload the file due to Wireless Carrier size limits.",
                    invalidFileUploadAttempted: "1 file failed to upload and was removed from your message.",
                    nInvalidFilesUploadAttempted: "{{ invalidFiles }} files failed to upload and were removed from your message.",
                    unsubscribed: "Unsubscribed",
                    unsubscribedPhoneNumber: "Phone Number Unsubscribed",
                    nUnsubscribedPhoneNumber: "{{count}} Phone Number Unsubscribed",
                    nUnsubscribedPhoneNumber_plural: "{{count}} Phone Numbers Unsubscribed",
                },
                messageComposeArea: {
                    message: "Message"
                },
                messagesSidebar: {
                    labelMessages: "Messages",
                    noMessages: "No Messages to Display",
                    draftLimitReached: "New Message Draft Limit Reached",
                    searchMessages: "Search Messages"
                },
                messagesSidebarComingSoon: {
                    labelFilters: "Filters",
                    labelMessages: "Messages",
                    searchMessages: "Search Messages"
                },
                conversation: {
                    close: "Close",
                    nRecipients: "{{ recipientCount }} Recipients",
                    unsupported: "Unsupported",
                    tollFreeNoGroupMessagingText: "Currently, toll-free numbers can’t participate in group messaging."
                },
                conversationDetails: {
                    archive: "Archive",
                    archiveConfirmation: "Are you sure you want to archive this conversation?",
                    archiveConfirmationHeader: "Archive Message Thread",
                    cancel: shared.enUS.cancel,
                    conversationName: "Conversation Name",
                    conversationStarted: "Conversation Started",
                    conversationParticipants: "Participants",
                    conversationSubscribers: "Subscribers",
                    links: "Links",
                    location: "Location",
                    markAsNew: "Mark as New",
                    markAsReviewed: "Mark as Reviewed",
                    media: "Photos and Videos",
                    save: shared.enUS.save,
                    seeAll: "See All",
                    tollFree: "Toll-Free",
                    you: "You"
                },
                conversationMedia: {
                    all: "All",
                    photos: "Photos",
                    videos: "Videos",
                    media: "Photos and Videos",
                    noMediaToDisplay: "No {{media}} to Display"
                },
                conversationParticipantCard: {
                    call: "Call",
                    comingSoon: "Coming Soon",
                    contact: "View",
                    sendMessage: "Message",
                    conversationParticipants: "Participants",
                    you: "You",
                    addContact: "Add Contact",
                },
                conversationSubscriberCard: {
                    call: "Call",
                    comingSoon: "Coming Soon",
                    userToUserNotSupported: "User to User Messaging is Not Supported",
                    sendMessage: "Message",
                    viewContact: "View"
                },
                conversationLocation: {
                    tollFreeMapMessage: "Location Data Unavailable"
                },
                inboxSidebar: {
                    clearFilters: "Clear Filters",
                    headerRecordings: "Call Recordings",
                    headerVoicemail: "Voicemail",
                    labelInbox: "Inbox",
                    labelFilters: "Filters",
                    labelShow: "Show",
                    labelSubscriptions: "Subscriptions",
                    noSubscriptionsAvailable: "No Subscriptions Available",
                    searchRecordings: "Search Recordings",
                    searchVoicemail: "Search Voicemail",
                },
                inboxCallRecordings: {
                    delete: "Delete",
                    download: "Download",
                    headerRecordings: "Call Recordings",
                    isNew: "",
                    isNew_new: "Mark as Reviewed",
                    isNew_reviewed: "Mark as New",
                    noRecordings: "No Call Recordings to Display",
                    noResults: "No Results Found",
                },
                inboxVoicemail: {
                    delete: "Delete",
                    download: "Download",
                    headerVoicemail: "Voicemail",
                    isNew: "",
                    isNew_new: "Mark as Reviewed",
                    isNew_reviewed: "Mark as New",
                    noResults: "No Results Found",
                    noVoicemail: "No Voicemails to Display",
                },
                audioFiles: {
                    header: "Audio Files",
                    noResults: shared.enUS.noResultsFound,
                    noAudioFiles: "No Audio Files to Display",
                },
                addAudioFile: {
                    add: shared.enUS.add,
                    cancel: shared.enUS.cancel,
                    conversionFailed: "Conversion failed, please choose another file.",
                    download: "Download",
                    headerAdd: "Add Audio File",
                    headerEdit: "Edit Audio File",
                    labelFile: "File",
                    labelMethod: "Method",
                    labelName: "Name",
                    labelPreview: "Preview",
                    promptNameInvalid: "Please enter a valid audio file name.",
                    promptNameRequired: "Please enter an audio file name.",
                    promptAudioRecordingRequired: "Please record an audio file.",
                    promptAudioUploadRequired: "Please select an audio file.",
                    promptAudioUploadSizeExceedsMax: shared.enUS.fileTooBig,
                    promptAudioUploadTypeInvalid: shared.enUS.invalidAudioFile,
                    promptNameNotUnique: "The name you entered is already in use by another audio file.",
                    promptNameNotLocallyUnique: "The name you entered is already in use by another new audio file.",
                    save: shared.enUS.save,
                },
                autoAttendant: {
                    cancel: shared.enUS.cancel,
                    copy: "Copy Auto Attendant",
                    copyAs: "Copy As",
                    expandCallFlow: "Expand Call Flow",
                    headerAutoAttendant: "Auto Attendants",
                    loopedCallFlowMessage: "You have routed an auto attendant to itself. You can do this, but the call flow cannot be displayed here since it is a self-referencing loop.",
                    nameRequired: "Please enter an auto attendant name.",
                    noResults: "No Results Found",
                    noAutoAttendants: "No Auto Attendants to Display",
                    portInProgress: "Port In Progress",
                    save: shared.enUS.save,
                    uniqueNameRequired: "This name is already in use by another auto attendant.",
                    defaultSeparatorMessage: "Then send it to",
                    hangup: "Hang Up",
                    playRinging: "Ring until answered or caller hangs up",
                    timeoutMessage: " seconds",
                    timeoutSeparatorMessage: "If no answer after ",
                },
                addAutoAttendant: {
                    add: shared.enUS.add,
                    addOrSelectPrompt: "A main greeting is required.",
                    autoAttendantNameRequired: "Auto attendant name is required.",
                    cancel: shared.enUS.cancel,
                    copy: "Save a Copy",
                    createAudioFile: " or create a new one",
                    createAudioFileLinkText: 'Create a new one.',
                    headerAdd: "Add Auto Attendant",
                    headerEdit: "Edit Auto Attendant",
                    inactiveItem: "Disabled",
                    labelName: "Name",
                    menuOptionAdd: "Add Menu Option",
                    menuOptionEdit: "Edit Menu Option",
                    menuRoutesToAtLeastOneEndpoint: "At least one keypress option must be configured.",
                    noAudioFilesWarningMessage: "You haven't created an audio file yet.&nbsp;",
                    pleaseSelect: shared.enUS.pleaseSelect,
                    save: shared.enUS.save,
                    selectAudioFile: "Greet and instruct callers with this audio file ",
                    subMenuRoutesToAtLeastOneEndpoint: "Sub-menu: at least one keypress option must be configured.",
                    uniqueNameRequired: "Auto attendant name is already in use.",
                    validationPleaseFix: "Please correct the problems in these sections and try again.",
                    validationTabDescription: "Oops, it looks like there are some issues with these sections:",
                    voicePromptMissingOnMenu: "Sub-menu: a greeting is required.",
                },
                contactPermissions: {
                    title: "Contacts",
                    description: "Shared Company Address Book",
                    cancel: shared.enUS.cancel,
                    permissionFormLabel: "The following users and groups can add, edit and delete contacts from the Shared Company Address Book",
                    cannotRemoveSystemAdminsGroup: "Cannot Remove System Admins"
                },
                blocking: {
                    title: "Blocking",
                    cancel: shared.enUS.cancel,
                    permissionFormLabel: "The following users and groups can block contacts",
                    cannotRemoveSystemAdminsGroup: "Cannot Remove System Admins",
                    blockPhoneNumberTitle: "Block Phone Number",
                    blockingListTitle: "Blocked Phone Numbers",
                    noPhoneNumbers: "No Phone Numbers to Display",
                    phoneNumber: "Phone Number",
                    phoneNumberRequired: "Phone number is required."
                },
                extensions: {
                    assigned: "Assigned",
                    cancel: shared.enUS.cancel,
                    changeTo: "Change to {{extension}}",
                    ext: "Ext {{extension}}",
                    extension: "Extension",
                    header: "Extensions",
                    name: "Name",
                    noResultsFound: "No Results Found",
                    save: shared.enUS.save,
                    search: shared.enUS.search,
                    type: "Type",
                },
                forwardingNumbers: {
                    header: "Forwarding Numbers",
                    noResults: shared.enUS.noResultsFound,
                    noForwardingNumbers: "No Forwarding Numbers to Display",
                    search: shared.enUS.search,
                },
                addForwardingNumbers: {
                    add: shared.enUS.add,
                    addHeader: "Add Forwarding Number",
                    callerIdLabel: "Caller ID",
                    callerNumber: "Display Caller's Number",
                    cancel: shared.enUS.cancel,
                    dialedNumber: "Display PATLive Number",
                    editHeader: "Edit Forwarding Number",
                    nameLabel: "Name",
                    nameRequired: "Name is required.",
                    nameUnique: "This name is already used by another forwarding number.",
                    numberLabel: "Phone Number",
                    numberRestricted: "This number is not supported.",
                    numberRequired: "Phone number is required.",
                    numberUnique: "This number is already used by another forwarding number.",
                    numberInvalid: shared.enUS.phoneNumberInvalid,
                    save: shared.enUS.save
                },
                integrations: {
                    connect: "Connect",
                    connected: "Connected",
                    header: "Integrations",
                    integrationDescription_clio: "Law practice management software for potential and current clients.",
                    integrationDescription_clioGrow: "Legal marketing and intake platform to help attract and manage clients.",
                    integrationDescription_hubSpot: "Integrate marketing, sales, and customer service in one platform.",
                    integrationDescription_lawmatics: "Lawmatics uses the best of automation and AI to help you convert more leads.",
                    integrationDescription_myCase: "The complete case management software accessible across all your devices.",
                    integrationDescription_jobber: "Efficiently manage your home services business with Jobber’s robust tools.",
                    integrationDescription_practicePanther: "Law practice management software focused on automation.",
                    integrationDescription_smokeball: "Eliminate administrative tasks and focus on high-value work.",
                    integrationDescription_zapier: "Zapier is where innovators put AI to work.",
                    integrationName_clio: "Clio",
                    integrationName_clioGrow: "Clio Grow",
                    integrationName_hubSpot: "HubSpot",
                    integrationName_lawmatics: "Lawmatics",
                    integrationName_myCase: "MyCase",
                    integrationName_jobber: "Jobber",
                    integrationName_practicePanther: "PracticePanther",
                    integrationName_smokeball: "Smokeball",
                    integrationName_zapier: "Zapier",
                    noResults: shared.enUS.noResultsFound,
                    remove: "Remove",
                    search: shared.enUS.search
                },
                addIntegration: {
                    confirmationMessageTitle: "{{integrationName}} Integration Successfully Connected!",
                    confirmationMessageBody: "You can now add the {{integrationName}} integration to your Live Receptionist Scripts. A Script Specialist will follow up with you to complete the setup process within the next 24 business hours.",
                    failureMessageTitle: "{{integrationName}} Integration Connection Error",
                    failureMessageBody: "There appears to have been an error connecting to the {{integrationName}} integration. Please try again.",
                    buttonBack: "Back to Integrations",
                },
                removeIntegrationModal: {
                    areYouSure: "Are you sure you want to remove this integration?",
                    removeIntegration: "Remove Integration"
                },
                addClioGrowTokenModal: {
                    cancel: shared.enUS.cancel,
                    save: shared.enUS.save,
                    addClioGrowToken: "Add Clio Grow",
                    close: shared.enUS.close,
                    confirmationMessage: "Your Clio Grow Inbox Lead Token has been added.",
                    labelClioGrowToken: "Clio Grow Inbox Lead Token",
                    clioGrowTokenRequired: "Clio Grow Inbox Lead Token is required."
                },
                liveReceptionistScripts: {
                    addScript: "Add Script",
                    deactivate: "Deactivate",
                    deactivatePending: "Cannot deactivate a Pending script.",
                    header: "Live Receptionist Scripts",
                    noResults: shared.enUS.noResultsFound,
                    noLiveReceptionistScripts: "No Live Receptionist Scripts to Display",
                    reactivate: "Reactivate",
                    search: shared.enUS.search,
                    supportMessage: "Please contact customer service to add a Live Receptionist Script."
                },
                addLiveReceptionistScript: {
                    accountForwardingNumberTransfer: "What transferring options are available for Forwarding Numbers?",
                    accountUserGroupTransfer: "What transferring options are available for User Groups?",
                    accountUserTransfer: "What transferring options are available for Users?",
                    accountVoicemailBoxTransfer: "What transferring options are available for Voicemail Boxes?",
                    add: shared.enUS.add,
                    addHeader: "Add Live Receptionist Script",
                    addIntegration: "+ Add Integration",
                    addAnother: "+ Add Another",
                    allForwardingNumbers: "All Forwarding Numbers",
                    allUserGroups: "All User Groups",
                    allUsers: "All Users",
                    allVoicemailBoxes: "All Voicemail Boxes",
                    callControls: "Call Controls",
                    callerNumber: "Display Caller's Number",
                    cancel: shared.enUS.cancel,
                    chatControls: "Chat Controls",
                    connectIntegrations: "Connect an integration.",
                    createTransferSchedule: 'Create a Transfer schedule.',
                    customerServiceNumber: "Display Customer Service Number",
                    dialedNumber: "Display PATLive Number",
                    editHeader: "Edit Live Receptionist Script",
                    transferSchedule: "Transfer Schedule",
                    integrations: "Integrations",
                    manualEntryTransfer: "What transferring options are available for Manual Entry?",
                    manuallyControlForwardingNumbers: "Manually control Forwarding Number transfer options",
                    manuallyControlUserGroups: "Manually control User Group transfer options",
                    manuallyControlUsers: "Manually control User transfer options",
                    manuallyControlVoicemailBoxes: "Manually control Voicemail Box transfer options",
                    nameLabel: "Name",
                    nameRequired: "Name is required.",
                    nameUnique: "This name is already used by another live receptionist script.",
                    noTransferScheduleFound: 'You haven\'t created a Transfer schedule yet.',
                    noIntegrationsFound: 'You haven\'t connected an integration yet.',
                    playHoldMusic: "Play Hold Music to Caller",
                    playRinging: "Play Ringing to Caller",
                    readOnlyTitle: "Need to make changes?",
                    readOnlyMessagePart1_integrations: "If you would like to make changes to the integrations for this script, please contact support at +1 (800) 775-7790 or email ",
                    readOnlyMessagePart1_subscribers: "If you would like to make changes to the subscribers for this script, please contact support at " + shared.enUS.customerServiceNumberFormatted + " or email ",
                    readOnlyMessagePart1_transferOptions: "If you would like to make changes to the transfer options for this script, please contact support at " + shared.enUS.customerServiceNumberFormatted + " or email ",
                    readOnlyMessagePart1_transferSchedule: "If you would like to make changes to the transfer schedule for this script, please contact support at " + shared.enUS.customerServiceNumberFormatted + " or email ",
                    readOnlyMessageLink1: shared.enUS.supportEmail,
                    readOnlyMessagePart2: ".",
                    queueHoldSetting: "What do you want callers to hear while in queue?",
                    queueIdCalls: "What queue number should the calls go to?",
                    queueIdChats: "What queue number should the chats go to?",
                    queueIdRequired: "A queue number is required.",
                    save: shared.enUS.save,
                    scriptIdLabel: "Script ID:",
                    selectedForwardingNumbers: "The following forwarding numbers can be transferred to",
                    selectedIntegrations: "Which integrations should be notified when messages are received for this script?",
                    selectedUserGroups: "The following user groups can be transferred to",
                    selectedUsers: "The following users can be transferred to",
                    selectedVoicemailBoxes: "The following voicemail boxes can be transferred to",
                    storedNumbersTransfer: "What transferring options are available for Stored Numbers?",
                    subscribers: "Subscribers",
                    templateLabel: "Template",
                    transferOptions: "Transfer Options",
                    transferOptionCold: "Cold Only Transfers",
                    transferOptionNone: "None Available",
                    transferOptionWarm: "Warm Only Transfers",
                    transferOptionWarmAndCold: "Warm and Cold Transfers",
                    typeLabel: "What service will use this script?",
                    typeDisabledTooltip: "Cannot change the service for this script.",
                    types: {
                        liveReceptionist: "Live Receptionist Service",
                        outboundCalling: "Outbound Calling Service",
                        webChat: "Web Chat Service",
                    },
                    warmTransferCallerId: "What Caller ID should be displayed when warm transferring?",
                    whichForwardingNumbersToTransferTo: "Which Forwarding Numbers are Live Receptionists able to transfer calls to?",
                    whichUserGroupsToTransferTo: "Which User Groups are Live Receptionists able to transfer calls to?",
                    whichUsersToTransferTo: "Which Users are Live Receptionists able to transfer calls to?",
                    whichVoicemailBoxesToTransferTo: "Which Voicemail Boxes are Live Receptionists able to transfer calls to?"
                },
                associateLiveReceptionistScript: {
                    associateHeader: "Associate Live Receptionist Script",
                    portalScriptIdRequired: "Portal Script ID is required.",
                    portalScriptIdInvalid: "Portal Script ID is invalid.",
                    scriptPortalIdLabel: "Live Receptionist Portal ID",
                    typeLabel: "What service will use this script?",
                    types: {
                        liveReceptionist: "Live Receptionist Service",
                        outboundCalling: "Outbound Calling Service",
                        webChat: "Web Chat Service",
                    },
                    save: shared.enUS.save,
                },
                deactivateLiveReceptionistScriptModal: {
                    areYouSure: "Are you sure you want to deactivate this live receptionist script?",
                    deactivateScript: "Deactivate Script"
                },
                reactivateLiveReceptionistScriptModal: {
                    areYouSure: "Are you sure you want to reactivate this live receptionist script?",
                    monthlyCharges: "Monthly charges will resume as listed on our&nbsp;",
                    reactivateScript: "Reactivate Script",
                    pricingPage: "pricing page"
                },
                outboundCallingCampaigns: {
                    addOutboundCalling: "Add Outbound Calling Campaign",
                    activateTooltip: "Activate",
                    cannotActivateTooltip: "This campaign cannot be activated until it has an active script attached.",
                    deactivateCampaignPlanMessage: "However, deactivating this campaign does not terminate your Outbound Calling plan. If you were looking to remove this service, please reach out to your account Billing Admin(s) to remove the Outbound Calling plan from your account.",
                    deactivateTooltip: "Deactivate",
                    deleteCampaignBillingAdminMessage_part1: "However, deactivating this campaign does not terminate your Outbound Calling plan. In order to do so, click ",
                    deleteCampaignBillingAdminLink: "here",
                    deleteCampaignBillingAdminMessage_part2: " to manage your account's plans.",
                    header: "Outbound Calling Campaigns",
                    noResults: shared.enUS.noResultsFound,
                    noCampaigns: "No Outbound Calling Campaigns to Display",
                    noOutboundCallingPackageWarningTitle: "Your account does not have an active Outbound Calling plan.",
                    noOutboundCallingPackageMessage: "In order to unlock Outbound Calling features like creating outbound calling campaigns, please reach out to your account Billing Admin(s) to add an Outbound Calling plan to your account.",
                    noOutboundCallingPackageBillingAdminMessage_part1: "In order to unlock Outbound Calling features like creating outbound calling campaigns, click ",
                    noOutboundCallingPackageBillingAdminLink: "here",
                    noOutboundCallingPackageBillingAdminMessage_part2: " to manage your account's plans.",
                    search: shared.enUS.search
                },
                addOutboundCallingCampaign: {
                    add: shared.enUS.add,
                    addHeader: "Add Outbound Calling Campaign",
                    cancel: shared.enUS.cancel,
                    createLiveReceptionistScript: 'Create a Live Receptionist Script.',
                    createNew: "create a new one",
                    editHeader: "Edit Outbound Calling Campaign",
                    labelCampaignCode: "Campaign Code",
                    labelGenesysCampaignId: "Genesys Campaign ID",
                    labelLiveReceptionistScript: "Live Receptionist Script",
                    labelName: "Name",
                    labelOutboundCallerId: "Outbound Caller ID",
                    liveReceptionistScriptNone: "None Selected",
                    liveReceptionistScriptRequired: "Live Receptionist Script is required.",
                    nameRequired: "Name is required.",
                    noLiveReceptionistScriptWarningMessage: 'You haven\'t created a Live Receptionist Script yet.',
                    noOutboundCallingPackageWarningMessage: 'This account does not have an active Outbound Calling package.',
                    outboundCallerIdRequired: 'Outbound Caller ID is required.',
                    pleaseSelect: shared.enUS.pleaseSelect,
                    readOnlyMessagePart1: "If you would like to make changes to the Live Receptionist Script for this campaign, please contact support at " + shared.enUS.customerServiceNumberFormatted + " or email ",
                    readOnlyMessageLink1: shared.enUS.supportEmail,
                    readOnlyMessagePart2: ".",
                    readOnlyTitle: "Need to make changes?",
                    save: shared.enUS.save
                },
                webChatWidgets: {
                    addWebChat: "Add Web Chat Widget",
                    deleteWidgetPlanMessage: "However, deleting this widget does not terminate your Web Chat plan. If you were looking to remove this service, please reach out to your account Billing Admin(s) to remove the Web Chat plan from your account.",
                    deleteWidgetSnippetMessage: "After you delete this widget, any widget code snippets you have added to your authorized domains will no longer work and can be removed.",
                    deleteWidgetBillingAdminMessage_part1: "However, deleting this widget does not terminate your Web Chat plan. In order to do so, click ",
                    deleteWidgetBillingAdminLink: "here",
                    deleteWidgetBillingAdminMessage_part2: " to manage your account's plans.",
                    header: "Web Chat Widgets",
                    noResults: shared.enUS.noResultsFound,
                    noWebChats: "No Web Chat Widgets to Display",
                    noWebChatPackageWarningTitle: "Your account does not have an active Web Chat plan.",
                    noWebChatPackageMessage: "In order to unlock Web Chat features like creating custom web chat widgets, please reach out to your account Billing Admin(s) to add a Web Chat plan to your account.",
                    noWebChatPackageBillingAdminMessage_part1: "In order to unlock Web Chat features like creating custom web chat widgets, click ",
                    noWebChatPackageBillingAdminLink: "here",
                    noWebChatPackageBillingAdminMessage_part2: " to manage your account's plans.",
                    search: shared.enUS.search
                },
                addWebChatWidget: {
                    add: shared.enUS.add,
                    addDomain: "+ Add Domain",
                    addHeader: "Add Web Chat Widget",
                    cancel: shared.enUS.cancel,
                    codeSnippetInstructions_part1: "Copy and paste the following code snippet into the <b>&lt;head&gt;</b> of your website on any pages you would like the widget to appear.",
                    codeSnippetInstructions_part2: "After deploying the snippet on your website, future saved changes will be applied automatically.",
                    codeSnippetMoreInformation: "For more information on how to install this code snippet, please visit our ",
                    codeSnippetMoreInformationLink: "Setup Guide",
                    codeSnippetPlaceholder: "Once a script has been associated to this widget, your code snippet will become available.",
                    createLiveReceptionistScript: 'Create a live receptionist script.',
                    createNew: "create a new one",
                    disabledAddDomain: "Cannot add more than 10 Authorized Domains",
                    domainDuplicate: "This domain has already been added.",
                    domainInvalid: "Invalid Authorized Domain",
                    domainPlaceholder: "e.g. example.com",
                    editHeader: "Edit Web Chat Widget",
                    labelAuthorizedDomains: "Authorized Domains",
                    labelCodeSnippet: "Website Code Snippet",
                    labelLauncherBackgroundColor: "Launcher Background Color",
                    labelLauncherPreview: "Launcher Preview",
                    labelLauncherTextColor: "Launcher Text Color",
                    labelLiveReceptionistScript: "Live Receptionist Script",
                    labelName: "Name",
                    labelWelcomeMessage: "Welcome Message",
                    launcherBackgroundColorInvalid: "Invalid Launcher Background Color",
                    launcherBackgroundColorRequired: "Launcher Background Color is required.",
                    launcherTextColorInvalid: "Invalid Launcher Text Color",
                    launcherTextColorRequired: "Launcher Text Color is required.",
                    liveReceptionistScriptNone: "None Selected",
                    liveReceptionistScriptRequired: "Live Receptionist Script is required.",
                    nameRequired: "Name is required.",
                    noLiveReceptionistScriptWarningMessage: 'You haven\'t created a live receptionist script for web chats yet.',
                    noWebChatPackageWarningMessage: 'This account does not have an active web chat package.',
                    pleaseSelect: shared.enUS.pleaseSelect,
                    readOnlyMessagePart1: "If you would like to make changes to the live receptionist script for this widget, please contact support at " + shared.enUS.customerServiceNumberFormatted + " or email ",
                    readOnlyMessageLink1: shared.enUS.supportEmail,
                    readOnlyMessagePart2: ".",
                    readOnlyTitle: "Need to make changes?",
                    save: shared.enUS.save,
                    selectLiveReceptionistScript: "Select a live receptionist script or&nbsp;",
                    welcomeMessageDefault: "We will be with you shortly.",
                    welcomeMessageRequired: "Welcome Message is required."
                },
                phoneNumbers: {
                    atLeastOneRequired: "At least one active phone number is required.",
                    deletePortInProgress: "Please contact customer service to cancel phone number port.",
                    disabledItemInbound: "Inbound Calls are Disabled",
                    disabledItemMessages: "Text Messages are Disabled",
                    disabledItemOutbound: "Outbound Calls are Disabled",
                    disabledItemRecording: "Call Recording is Disabled",
                    headerPhoneNumbers: "Phone Numbers",
                    inactiveItem: "Inactive - Click to Activate",
                    loopedCallFlowMessage: "You have routed an auto attendant to itself. You can do this, but the call flow cannot be displayed here since it is a self-referencing loop.",
                    noInheritors: "None",
                    noPhoneNumbersWarningTitle: "You don’t have any phone numbers.",
                    noPhoneNumbersWarningMessage_part1: "You can",
                    noPhoneNumbersWarningMessage_part2: "add a new phone number",
                    noPhoneNumbersWarningMessage_part3: "to start receiving calls.",
                    tabDescriptionInbound_default: "When a call is received, send it to",
                    tabDescriptionInbound_voicePrompt: "When a call is received, play this audio file",
                    tabDescriptionInbound_schedule: "When a call is received, use this schedule",
                    tabDescriptionMessages: "These users and groups can send and receive text messages",
                    tabDescriptionOutbound: "These users and groups can place calls",
                    tabDescriptionRecording: "These users and groups can access the call recordings",
                    noPhoneNumbers: "No Phone Numbers to Display",
                    noResults: "No Results Found",
                    portInProgress: "Port In Progress",
                    pressOne: "Press 1",
                    search: 'Search',
                    tab_inbound: "Inbound Calls",
                    tab_outbound: "Outbound Calls",
                    tab_recording: "Call Recording",
                    tab_messages: "Messages"
                },
                phoneNumberTextMessagingTab: {
                    deniedItemMessages: {
                        label: "We encountered a problem enabling messaging.",
                        descriptionPart1: "Due to FCC and wireless carrier regulations, VOIP local phone numbers must be registered before they can be used for text messaging. Unfortunately, the ",
                        descriptionLink1: shared.enUS.campaignRegistry,
                        descriptionPart2: " denied your registration request.",
                        descriptionPart3: "For help resolving this error and resubmitting your number for registration, please call " + shared.enUS.customerServiceNumberFormatted + " or email ",
                        descriptionLink2: shared.enUS.supportEmail,
                        descriptionPart4: ".",
                    },
                    deniedItemMessagesTollFree: {
                        label: "We encountered a problem enabling messaging.",
                        descriptionPart1: "Due to FCC and wireless carrier regulations, VOIP toll-free phone numbers must go through a verification process before they can be used for text messaging. Unfortunately, this toll-free number was unable to be verified.",
                        descriptionPart2: "For help resolving this error and resubmitting your number for verification, please call " + shared.enUS.customerServiceNumberFormatted + " or email ",
                        descriptionLink1: shared.enUS.supportEmail,
                        descriptionPart3: ".",
                    },
                    pendingItemMessages: {
                        label: "Pending",
                        descriptionPart1: "Why is my request to enable messages queued?",
                        descriptionPart2: "FCC and wireless carrier regulations require VOIP accounts to be vetted before they can be used to send text messages. This process is currently pending and can take up to 30 days. You will be notified by email when your vetting status changes from Pending to either Approved or Rejected.",
                        descriptionPart3: " If your account is approved, Messages will be enabled automatically. If your account is rejected, please reach out to our customer support team for further assistance.",
                    },
                    pendingItemMessagesTollFree: {
                        label: "Pending",
                        descriptionPart1: "Why is my request to enable messages queued?",
                        descriptionPart2: "FCC and wireless carrier regulations require VOIP toll-free phone numbers to go through a verification process. This process is currently pending and can take up to 30 days. You will be notified by email when your vetting status changes from Pending to either Approved or Rejected.",
                        descriptionPart3: " If this number is approved, Messages will be enabled automatically. If this number is rejected, please reach out to our customer support team for further assistance.",
                    },
                },
                protectedContent: {
                    protectedContent: "Protected Content"
                },
                editPhoneNumber: {
                    addAnother: "+ Add Another",
                    authorizedHistory: "Authorized User History:",
                    callRecordingTab: "Call Recording",
                    cancel: "Cancel",
                    disabled: "Disabled",
                    editPhoneNumberTitle: "Edit Phone Number",
                    enabled: "Enabled",
                    messaging: "Messaging",
                    messagingTab: "Messages",
                    none: "None",
                    numberLabel: "Number: ",
                    numberLocationLabel: "Location: ",
                    numberNameLabel: "Name",
                    inboundCallingTab: "Inbound Calls",
                    inboundCallingDisabled: "When this phone number receives a call it will play an out of service message followed by a busy signal.",
                    outboundCallingTab: "Outbound Calls",
                    permissionsWillBeDetermined: "Once saved, {{permissionType}} permissions will be determined based on the inbound call flow",
                    revokePermission: "Revoke Permissions",
                    validationLastAuthorized: "Sorry, you cannot remove the last authorized user",
                    validationPhoneNumberName: "Phone number name must be unique.",
                    validationPleaseFix: "Please correct the problems in these sections and try again.",
                    validationTabDescription: "Oops, it looks like there are some issues with these sections:",
                    humanDetection: "Human Detection",
                    humanDetectionTooltip: "Calls from numbers that aren’t in your contacts will be asked to press 1 to prove they’re human.",
                    whisper: "Whisper",
                    whisperTooltip: "When enabled, plays an audio announcement of the phone number name for incoming call."
                },
                editPhoneNumberCallRecordingTab: {
                    act: "view call recordings",
                    action: "view call recordings from this phone number",
                    actionAlternate: "view call recordings from this phone number",
                    agreeToNotifyInbound: "I agree to notify callers that they are being recorded.",
                    agreeToNotifyOutbound: "I agree to notify all parties that they are being recorded.",
                    callRecordingOptions: {
                        disabled: "Disabled",
                        allCalls: "All Calls",
                        onlyInbound: "Only Inbound Calls",
                        onlyOutbound: "Only Outbound Calls"
                    },
                    controlWhoGetsRecordings: "How do you want to control who sees call recordings from this number?",
                    emailSubscriberDescription: "Add external email addresses to receive call recordings.",
                    grantPermissions: "call recording access",
                    inheritedDescription: "The following users and groups are currently included in the call flow (on the Inbound Calls tab) and, as a result, have inherited access to call recordings from this phone number",
                    inheritPermissionEnabled: "Inherit call recording permissions from the Inbound Calls tab",
                    inheritPermissionDisabled: "Manually control call recording permissions",
                    manualDescription: "Who should have access to the call recordings?",
                    onInboundCalls: "On inbound calls, notify callers by playing this audio file",
                    onInboundCallsError: "You must agree to notify callers.",
                    onOutboundCalls: "On outbound calls",
                    onOutboundCallsError: "You must agree to notify all parties.",
                    permissionType: "recording access",
                    record: "Record",
                },
                editPhoneNumberTextMessagingTab: {
                    act: "message",
                    action: "text on this phone number",
                    actionAlternate: "text on this phone number",
                    beAbleTo: "be able to start new conversations from this phone number",
                    beIncludedIn: "be included in all conversations on this phone number",
                    controlWhoCanMessage: "How do you want to control who can send and receive texts from this number?",
                    grantPermissions: "texting permissions",
                    inheritedDescription: "The following users and groups are currently included in the call flow (on the Inbound Calls tab) and, as a result, will",
                    inheritPermissionEnabled: "Inherit texting permissions from the Inbound Calls tab",
                    inheritPermissionDisabled: "Manually control texting permissions",
                    manualDescription: "The following users and groups have been manually granted texting permissions on this phone number",
                    messagingRequiresMessagingCompliance: {
                        title: "Your messaging compliance must be complete to enable messaging.",
                        warningPart1: "To enable messaging, please complete your ",
                        warningLink1: "Messaging Compliance",
                        warningPart2: ".",
                    },
                    messagingRequiresMoreComplianceInfo: {
                        title: "Cannot enable messaging without more info.",
                        warningPart1: "Due to FCC and wireless carrier regulations, VOIP local phone numbers must be registered with the Campaign Registry ",
                        warningPart2: " before they can be used for text messaging. To register more than 1 local phone number, you must have an EIN or Registry ID on file.",
                        warningPart3: "To enable messaging on more than 1 local phone number, update your ",
                        warningLink2: "Messaging Compliance",
                        warningPart4: " to include your EIN or Registry ID.",
                        warningPart5: "Alternatively, you can disable messaging on the one local phone number that has messaging enabled, and then return here to enable messaging on this number.",
                    },
                    messagingRequiresBusinessAccount: {
                        title: "Local phone number messaging limit reached.",
                        warningPart1: "Due to FCC and wireless carrier regulations, VOIP local phone numbers must be registered with the Campaign Registry",
                        warningPart2: " before they can be used for text messaging. To register more than 1 local phone number, you must be a business, non-profit or government organization with an EIN or Registry ID on file.",
                        warningPart3: "As a personal account, you cannot enable messaging on more than 1 local phone number. If you need to change your account type and you have a valid EIN or Registry ID, call PATLive Customer Service at " + shared.enUS.customerServiceNumberFormatted + " or email ",
                        warningLink2: shared.enUS.supportEmail,
                        warningPart4: ".",
                        warningPart5: "Alternatively, you can disable messaging on the local number that has messaging enabled, and then return here to enable messaging on this number.",
                    },
                    messagingTollFreeLimit: {
                        title: "Toll-Free number messaging limit reached.",
                        warningPart1: "Due to wireless carrier regulations, a business can only have 4 toll-free numbers enabled to send/receive text messages.  PATLive recommends that you set your main customer support number, if toll-free, to receive and send text messages. ",
                        warningPart2: "If you need additional phone numbers for sending and receiving text messages, we recommend setting up local numbers. (Please note, only verified businesses with an EIN number may text on more than one local number.)",
                        warningPart3: "",
                        warningPart4: "",
                        warningPart5: "If you would like this number to send/receive text messages, you can disable messaging on any other numbers with toll-free messaging enabled, and then return here to enable messaging on this number.",
                    },
                    messagingTcrRegistrationFailed: {
                        title: "We encountered a problem enabling messaging.",
                        warningPart1: "We were unable to verify your business information. For help resolving this error, please call " + shared.enUS.customerServiceNumberFormatted + " or email ",
                        warningLink1: shared.enUS.supportEmail,
                        warningPart2: ".",
                    },
                    messagingBandwidthRegistrationDenied: {
                        title: "We encountered a problem enabling messaging.",
                        warningPart1: "For help resolving this error, please call " + shared.enUS.customerServiceNumberFormatted + " or email ",
                        warningLink1: shared.enUS.supportEmail,
                        warningPart2: ".",
                    },
                    messagingDisabledDuringPort: {
                        title: "Cannot enable messaging while number is porting.",
                        warningPart1: "Messaging cannot be enabled until the port process is complete."
                    },
                    messagingDisabledFreeTrial: {
                        title: "Cannot enable messaging while in free trial.",
                        warningPart1: "Messaging cannot be enabled while in a free trial."
                    },
                    messagingRegistrationWillBeQueued: {
                        title: "Why is my request to enable messaging queued?",
                        warningPart1: "FCC and wireless carrier regulations require VOIP accounts to be vetted before they can be used to send text messages. This process is currently pending and can take up to 30 days. You will be notified by email when your vetting status changes from Pending to either Approved or Rejected. ",
                        warningPart2: " If your account is approved, Messages will be enabled automatically. If your account is rejected, please reach out to our customer support team for further assistance.",
                    },
                    messagingRegistrationIsPending: {
                        title: "We’re processing your request to enable messaging.",
                        warningPart1: "Due to FCC and wireless carrier regulations, VOIP local phone numbers must be registered with the Campaign Registry",
                        warningPart2: " before they can be used for text messaging. Your registration has been requested and messaging will be enabled once we receive approval, which can take up to 30 days. An email will be sent once processing is complete.",
                    },
                    messagingRegistrationIsPendingTollFree: {
                        title: "We’re processing your request to enable messaging.",
                        warningPart1: "Due to FCC and wireless carrier regulations, VOIP toll-free phone numbers must go through a verification process",
                        warningPart2: " before they can be used for text messaging. Your verification has been requested and messaging will be enabled once we receive approval, which can take up to 30 days. An email will be sent once processing is complete.",
                    },
                    pending: "Pending",
                    permissionType: "texting",
                    resubmit: "Resubmit"
                },
                messagingFeeConfirmationModal: {
                    agreementRequired: "You must agree to continue.",
                    enableSmsMessagePart1: "FCC and wireless carrier regulations require VOIP accounts to be vetted before they can be used to send text messages. This vetting process is administered by a third-party company and costs ${{amount}}.",
                    enableSmsMessagePart2: "By continuing, you are agreeing to pay a one-time Messaging Activation Cost Recovery Fee of ${{amount}} on your next bill to reimburse PATLive for the cost of vetting your account.",
                    enableSmsMessageAcknowledgement: "I understand that I will incur a ${{amount}} one-time fee on my next bill.",
                    disableSmsMessageAcknowledgement: "I understand that disabling Messages and then re-enabling Messages more than 30 days from today will subject my account to re-vetting, which may take up to 30 days and will incur either a $20 or a $69 one-time fee, based on my business type.",
                    disableSmsMessagePart1: "This is your last phone number with Messages enabled. If you disable Messages on this number, you will have a 30-day window from today during which you may re-enable Messages without having to go through the vetting process again. ",
                    disableSmsMessagePart2: "After 30 days, if you re-enable Messages on any number, you will be required to go through the vetting process again, which may take up to 30 days and will incur another instance of the Messaging Activation Cost Recovery fee that you paid the first time your account was vetted.",
                    headerTitle: "Messaging Activation Fee",
                },
                editPhoneNumberOutboundDialTab: {
                    act: "dial",
                    action: "dial out from this phone number",
                    actionAlternate: "place calls from this phone number",
                    controlWhoCanDial: "How do you want to control who can dial from this number?",
                    grantPermissions: "dialing permissions",
                    inheritedDescription: "The following users and groups are currently included in the call flow (on the Inbound Calls tab) and, as a result, have permissions to dial outbound from this phone number",
                    inheritPermissionEnabled: "Inherit dialing permissions from the Inbound Calls tab",
                    inheritPermissionDisabled: "Manually control dialing permissions",
                    manualDescription: "The following users and groups have been manually granted permissions to dial outbound from this phone number",
                    permissionType: "dialing",
                },
                reports: {
                    header: "Reports",
                    noResults: shared.enUS.noResultsFound,
                    noReports: "No Reports to Display",
                    search: shared.enUS.search,
                    daily: "Daily",
                    monthly: "Monthly",
                    weekly: "Weekly"
                },
                editReport: {
                    addEmailAddress: "+ Add Email Address",
                    all: "All",
                    cancel: shared.enUS.cancel,
                    csv: 'CSV',
                    daily: "Daily",
                    day: "Day",
                    disabledAddEmailAddress: "Cannot add more than 10 email addresses",
                    email: 'Email',
                    emailAddressRequiredAtLeastOne: shared.enUS.emailAddressRequiredAtLeastOne,
                    format: 'Format',
                    frequency: 'Frequency',
                    graphBy: 'Graph Points By',
                    header: "Edit Report",
                    hour: "Hour",
                    involvingHostedNumbers: "Phone Numbers",
                    involvingHostedNumbersText: "{{count}} Phone Number",
                    involvingHostedNumbersText_plural: "{{count}} Phone Numbers",
                    involvingUsersAndGroups: "Users and Groups",
                    involvingUsersAndGroupsText: "{{count}} User or Group",
                    involvingUsersAndGroupsText_plural: "{{count}} Users and Groups",
                    message: "Message",
                    month: "Month",
                    monthly: "Monthly",
                    pdf: "PDF",
                    sendToEmailAddressesLabel: "Send to the following email addresses:",
                    subject: "Subject",
                    subjectRequired: "Subject is required",
                    timeframe: "Timeframe",
                    week: "Week",
                    weekly: "Weekly",
                },
                schedules: {
                    header: "Schedules",
                    noResults: shared.enUS.noResultsFound,
                    noSchedules: "No Schedules to Display",
                    search: shared.enUS.search
                },
                callQueues: {
                    deleteHeading: "Delete {{type}}",
                    header: "Call Queues",
                    inUseByCallflow: "Sorry, this call queue cannot be deleted because a call flow still sends calls to it. Route those calls somewhere else first.",
                    noCallQueues: "No Call Queues to Display",
                    noResults: shared.enUS.noResultsFound,
                    ok: shared.enUS.ok,
                    poolSummary: "{{count}} pool, up to {{maxCallers}} callers waiting",
                    poolSummary_plural: "{{count}} pools, up to {{maxCallers}} callers waiting",
                    search: shared.enUS.search
                },
                addCallQueue: {
                    add: shared.enUS.add,
                    addPool: "+ Add Pool",
                    cancel: shared.enUS.cancel,
                    headerAdd: "Add Call Queue",
                    headerEdit: "Edit Call Queue",
                    lastItemTooltip: "At least one pool is required.",
                    maxCallersInQueue: "Max callers queued",
                    maxCallersInQueueInvalid: "Please enter how many max callers may be queued for this pool.",
                    maxConcurrentDestinationCalls: "Max callers at destination",
                    maxConcurrentDestinationCallsInvalid: "Please enter how many callers this pool may have in progress at once.",
                    maxWaitSeconds: "Max queued time (sec)",
                    maxWaitSecondsInvalid: "Please enter how long a caller may wait.",
                    name: "Name",
                    nameNotUnique: "This name is already used by another call queue.",
                    nameRequired: "Name is required.",
                    noGreeting: shared.enUS.none,
                    playHoldMusic: "Play hold music",
                    poolNameMustBeUnique: "This name is already used by another pool within this call queue.",
                    poolNameRequired: "Name is required.",
                    poolPlaceholderMessage: "Agents, Overflow, etc.",
                    poolLimits: "Pool Limits",
                    pools: "Pools",
                    poolsDescription: "Callers fill the pools in order: they wait for the first pool with room, and move to the next one only once that pool's waiting room is full.",
                    queueFull: "When Every Pool Is Full",
                    queueFullDescription: "A caller who arrives when every pool is already holding its maximum has nowhere to wait, so they are sent here instead.",
                    queueFullRouteToTitle: "Send these callers to",
                    queueHoldSetting: "What should callers hear while they wait?",
                    routeToTitle: "Release callers from this pool to",
                    routingRuleError: "Please make a selection.",
                    save: shared.enUS.save,
                    unnamedPool_sequence: "Unnamed Pool {{sequence}}",
                    validationPleaseFix: "Please correct the problems in these pools and try again.",
                    validationPoolDescription: "Oops, it looks like there are some issues with these pools:",
                    welcomeGreeting: "Welcome Greeting",
                    welcomeGreetingDescription: "Played once when a caller arrives, before they start waiting."
                },
                addSchedule: {
                    add: shared.enUS.add,
                    addRange: "+ Add Schedule Range",
                    cancel: shared.enUS.cancel,
                    days: "Days of Week",
                    friday: "F",
                    from: "From",
                    headerAdd: "Add Schedule",
                    headerEdit: "Edit Schedule",
                    lastItemTooltip: "At least one schedule range is required.",
                    map: "Schedule Map",
                    maxRanges: "You have reached the limit of 28 ranges per schedule.",
                    monday: "M",
                    name: "Name",
                    nameRequired: "Name is required.",
                    nameNotUnique: "This name is already used by another schedule.",
                    otherTimes: "All Other Times",
                    otherTimesDescription: "When the current day and time doesn’t fall within one of the schedule ranges above, we’ll send calls here.",
                    range: "Schedule Range",
                    rangeNameMustBeUnique: "This name is already used by another range within this schedule.",
                    rangePlaceholderMessage: "Office Hours, Lunch, etc.",
                    routeToTitle: "When a call is received during this schedule range",
                    routingRuleError: "Please make a selection.",
                    saturday: "S",
                    save: shared.enUS.save,
                    segmentsShouldNotOverlap: "Schedule ranges cannot overlap; this range conflicts with another range.",
                    segmentsShouldNotOverlap_name: "Schedule ranges cannot overlap; this range conflicts with range {{name}}",
                    selectedDayRequired: "At least one day must be selected.",
                    sunday: "S",
                    thursday: "Th",
                    timeSelectionsInvalid: "Start time must be before end time.",
                    to: "To",
                    tuesday: "T",
                    unnamedSegment: "Unnamed Schedule Segment",
                    validationPleaseFix: "Please correct the problems in these ranges and try again.",
                    validationTabDescription: "Oops, it looks like there are some issues with these ranges:",
                    wednesday: "W",
                },
                humanDetection: {
                    aboutTitle: "About Human Detection",
                    aboutDescription: "Block automated spam and robocalls with Human Detection. When enabled, calls from numbers that aren’t in your contacts will be asked to press 1 to prove they’re human. If you need to receive calls from automated systems, you can whitelist them here, or you can turn off Human Detection at the phone number level.",
                    addPhoneNumberTitle: "Add Phone Number to Whitelist",
                    cancel: shared.enUS.cancel,
                    humanDetection: "Human Detection",
                    noPhoneNumbers: "No Phone Numbers to Display",
                    phoneNumber: shared.enUS.phoneNumber,
                    phoneNumberRequired: "Phone number is required.",
                    save: shared.enUS.save,
                    toEnableHumanDetection1: "To enable or disable, go to ",
                    toEnableHumanDetection2: "Phone Numbers",
                    toEnableHumanDetection3: " > Edit Phone Numbers > Inbound Calls tab",
                    whitelistTitle: "Human Detection Whitelist",
                },
                messagingCompliance: {
                    autoResponseTab: "Help & Opt-Out",
                    cancel: shared.enUS.cancel,
                    enableSmsTitle: "Ready to Enable SMS",
                    enableSmsMessage: "Your SMS registration is complete! In order to begin sending/receiving text messages, you must enable text messaging on a phone number from your Phone Numbers settings.",
                    headerTitle: "Messaging Compliance",
                    localSmsTab: "Local Messaging",
                    profileTab: "Profile",
                    resubmitBrand: "Resubmit Brand",
                    resubmitCampaign: "Resubmit Campaign",
                    save: shared.enUS.save,
                    smsPinRequiredWarningTitle: "SMS Registration PIN Required",
                    smsPinRequiredWarningDescriptionPart1: "Your SMS registration requires verification with a one time passcode. ",
                    smsPinRequiredWarningDescriptionLink1: "Click here to verify",
                    smsPinRejected: "Incorrect SMS PIN, please try again.",
                    tcrBrandValidationFailedWarningTitle: "SMS Registration Error",
                    tcrBrandValidationFailedWarningPart1: "We were unable to create your SMS registration with the Campaign Registry. Please double check your Messaging Compliance information to verify that it is correct.",
                    tcrBrandValidationFailedWarningPart2: "If you continue to receive this error, please contact support at " + shared.enUS.customerServiceNumberFormatted + " or email ",
                    tcrBrandValidationFailedWarningLink1: shared.enUS.supportEmail,
                    tcrBrandValidationFailedWarningPart3: ".",
                    tcrBrandValidationPendingTitle: "Your SMS Registration is Pending",
                    tcrBrandValidationPendingPart1: "FCC and wireless carrier regulations require VOIP accounts to be vetted before they can be used to send text messages. This process is currently pending and could take up to 1-2 hours. You will be notified by email when your vetting status changes from Pending to either Approved or Rejected.",
                    tcrBrandValidationPendingPart2: "If you continue to receive this message, please contact support at " + shared.enUS.customerServiceNumberFormatted + " or email ",
                    tcrBrandValidationPendingLink1: shared.enUS.supportEmail,
                    tcrBrandValidationPendingPart3: ".",
                    tollfreeSmsTab: "Toll-Free Messaging",
                    validationPleaseFix: "Please correct the problems in these sections and try again.",
                    validationTabDescription: "Oops, it looks like there are some issues with these sections:"
                },
                messagingComplianceAutoResponseTab: {
                    helpAutoResponseInvalid: sharedMessagingCompliance.enUS.helpAutoResponseInvalid,
                    helpAutoResponseRequired: sharedMessagingCompliance.enUS.helpAutoResponseRequired,
                    labelHelpAutoResponse: sharedMessagingCompliance.enUS.labelHelpAutoResponse,
                    labelHelpAutoResponseDescription: sharedMessagingCompliance.enUS.labelHelpAutoResponseDescription,
                    labelHelpPlaceholder: sharedMessagingCompliance.enUS.labelHelpPlaceholder,
                    labelHelpResponse: sharedMessagingCompliance.enUS.labelHelpResponse,
                    labelStopAutoResponse: sharedMessagingCompliance.enUS.labelStopAutoResponse,
                    labelStopAutoResponseDescriptionOne: sharedMessagingCompliance.enUS.labelStopAutoResponseDescriptionOne,
                    labelStopAutoResponseDescriptionTwo: sharedMessagingCompliance.enUS.labelStopAutoResponseDescriptionTwo,
                    labelStopPlaceholder: sharedMessagingCompliance.enUS.labelStopPlaceholder,
                    labelStopResponse: sharedMessagingCompliance.enUS.labelStopResponse,
                    labelTextMessagingAutoResponses: sharedMessagingCompliance.enUS.labelTextMessagingAutoResponses,
                    noPlaceholderEmail: sharedMessagingCompliance.enUS.noPlaceholderEmail,
                    stopAutoResponseInvalid: sharedMessagingCompliance.enUS.stopAutoResponseInvalid,
                    stopAutoResponseRequired: sharedMessagingCompliance.enUS.stopAutoResponseRequired,
                },
                messagingComplianceLocalMessagingTab: {
                    disabled: "Disabled",
                    enabled: "Enabled",
                    exampleFourDescriptionOne: sharedMessagingCompliance.enUS.exampleFourDescriptionOne,
                    exampleFourDescriptionTwo: sharedMessagingCompliance.enUS.exampleFourDescriptionTwo,
                    exampleNote: sharedMessagingCompliance.enUS.exampleNote,
                    exampleOneDescriptionOne: sharedMessagingCompliance.enUS.exampleOneDescriptionOne,
                    exampleOneDescriptionTwo: sharedMessagingCompliance.enUS.exampleOneDescriptionTwo,
                    exampleThreeDescriptionOne: sharedMessagingCompliance.enUS.exampleThreeDescriptionOne,
                    exampleThreeDescriptionTwo: sharedMessagingCompliance.enUS.exampleThreeDescriptionTwo,
                    exampleTwoDescriptionOne: sharedMessagingCompliance.enUS.exampleTwoDescriptionOne,
                    exampleTwoDescriptionTwo: sharedMessagingCompliance.enUS.exampleTwoDescriptionTwo,
                    labelAccountNotifications: sharedMessagingCompliance.enUS.labelAccountNotifications,
                    labelAppointmentReminders: sharedMessagingCompliance.enUS.labelAppointmentReminders,
                    labelConversationMessaging: sharedMessagingCompliance.enUS.labelConversationMessaging,
                    labelCustomerConsentEmployeeRelationship: sharedMessagingCompliance.enUS.labelCustomerConsentEmployeeRelationship,
                    labelCustomerConsentInitiateConversation: sharedMessagingCompliance.enUS.labelCustomerConsentInitiateConversation,
                    labelCustomerConsentLeadCaptureForms: sharedMessagingCompliance.enUS.labelCustomerConsentLeadCaptureForms,
                    labelCustomerConsentOnlineCheckout: sharedMessagingCompliance.enUS.labelCustomerConsentOnlineCheckout,
                    labelCustomerConsentOther: sharedMessagingCompliance.enUS.labelCustomerConsentOther,
                    labelCustomerConsentOtherInvalid: sharedMessagingCompliance.enUS.labelCustomerConsentOtherInvalid,
                    labelCustomerConsentOtherRequired: sharedMessagingCompliance.enUS.labelCustomerConsentOtherRequired,
                    labelCustomerConsentPosTransaction: sharedMessagingCompliance.enUS.labelCustomerConsentPosTransaction,
                    labelDeliveryStatusUpdates: sharedMessagingCompliance.enUS.labelDeliveryStatusUpdates,
                    labelGeneralMarketing: sharedMessagingCompliance.enUS.labelGeneralMarketing,
                    labelMobilePhoneNumberDescription: "PIN Verification",
                    labelMobilePhoneNumber: "Mobile Phone Number",
                    labelVerificationDescriptionUnverified: "Unverified - Will Verify on Save",
                    labelVerificationDescriptionVerified: "Verified",
                    labelVerificationLink: "Unverified - Click to Verify",
                    labelPollingAndVoting: sharedMessagingCompliance.enUS.labelPollingAndVoting,
                    labelSecurityOrSystemAlerts: sharedMessagingCompliance.enUS.labelSecurityOrSystemAlerts,
                    labelSmsUseEligibility: sharedMessagingCompliance.enUS.labelSmsUseEligibility,
                    labelSummaryOfTexting: sharedMessagingCompliance.enUS.labelSummaryOfTexting,
                    labelTextMessageSampleFour: sharedMessagingCompliance.enUS.labelTextMessageSampleFour,
                    labelTextMessageSampleOne: sharedMessagingCompliance.enUS.labelTextMessageSampleOne,
                    labelTextMessageSampleThree: sharedMessagingCompliance.enUS.labelTextMessageSampleThree,
                    labelTextMessageSampleTwo: sharedMessagingCompliance.enUS.labelTextMessageSampleTwo,
                    labelTextMessagingBadExampleOne: sharedMessagingCompliance.enUS.labelTextMessagingBadExampleOne,
                    labelTextMessagingBadExampleTwo: sharedMessagingCompliance.enUS.labelTextMessagingBadExampleTwo,
                    labelTextMessagingBadExampleWhyOne: sharedMessagingCompliance.enUS.labelTextMessagingBadExampleWhyOne,
                    labelTextMessagingBadExampleWhyTwo: sharedMessagingCompliance.enUS.labelTextMessagingBadExampleWhyTwo,
                    labelTextMessagingCompliance: sharedMessagingCompliance.enUS.labelTextMessagingCompliance,
                    labelTextMessagingConsent: sharedMessagingCompliance.enUS.labelTextMessagingConsent,
                    labelTextMessagingConsentDescription: sharedMessagingCompliance.enUS.labelTextMessagingConsentDescription,
                    labelTextMessagingDelivery: sharedMessagingCompliance.enUS.labelTextMessagingDelivery,
                    labelTextMessagingExamples: sharedMessagingCompliance.enUS.labelTextMessagingExamples,
                    labelTextMessagingGoodExampleOne: sharedMessagingCompliance.enUS.labelTextMessagingGoodExampleOne,
                    labelTextMessagingGoodExampleTwo: sharedMessagingCompliance.enUS.labelTextMessagingGoodExampleTwo,
                    labelTextMessagingIneligibleUseCases: sharedMessagingCompliance.enUS.labelTextMessagingIneligibleUseCases,
                    labelTextMessagingPurpose: sharedMessagingCompliance.enUS.labelTextMessagingPurpose,
                    labelTextMessagingPurposeDescription: sharedMessagingCompliance.enUS.labelTextMessagingPurposeDescription,
                    labelTypesOfTextMessaging: sharedMessagingCompliance.enUS.labelTypesOfTextMessaging,
                    mobilePhoneNumberDescription: "Please enter the mobile phone number where you would like your one-time verification code to be sent.",
                    phoneNumberInvalid: shared.enUS.phoneNumberInvalid,
                    phoneNumberRequired: "Phone Number is required.",
                    phoneNumberOnThisAccount: "Please enter a mobile phone number that is not a PATLive phone number.",
                    pleaseSpecify: sharedMessagingCompliance.enUS.pleaseSpecify,
                    replyStop: sharedMessagingCompliance.enUS.replyStop,
                    sampleTextMessageInvalid: sharedMessagingCompliance.enUS.sampleTextMessageInvalid,
                    sampleTextMessageRegulatoryNotice: sharedMessagingCompliance.enUS.sampleTextMessageRegulatoryNotice,
                    sampleTextMessageRequired: sharedMessagingCompliance.enUS.sampleTextMessageRequired,
                    select: "Select",
                    smsIneligibleUseCaseFive: sharedMessagingCompliance.enUS.smsIneligibleUseCaseFive,
                    smsIneligibleUseCaseFiveExamples: sharedMessagingCompliance.enUS.smsIneligibleUseCaseFiveExamples,
                    smsIneligibleUseCaseFour: sharedMessagingCompliance.enUS.smsIneligibleUseCaseFour,
                    smsIneligibleUseCaseFourExamples: sharedMessagingCompliance.enUS.smsIneligibleUseCaseFourExamples,
                    smsIneligibleUseCaseOne: sharedMessagingCompliance.enUS.smsIneligibleUseCaseOne,
                    smsIneligibleUseCaseOneExamples: sharedMessagingCompliance.enUS.smsIneligibleUseCaseOneExamples,
                    smsIneligibleUseCaseThree: sharedMessagingCompliance.enUS.smsIneligibleUseCaseThree,
                    smsIneligibleUseCaseThreeExamples: sharedMessagingCompliance.enUS.smsIneligibleUseCaseThreeExamples,
                    smsIneligibleUseCaseTwo: sharedMessagingCompliance.enUS.smsIneligibleUseCaseTwo,
                    smsIneligibleUseCaseTwoExamples: sharedMessagingCompliance.enUS.smsIneligibleUseCaseTwoExamples,
                    useCaseEligibilityRequired: sharedMessagingCompliance.enUS.useCaseEligibilityRequired,
                    summaryOfTextingInvalid: sharedMessagingCompliance.enUS.summaryOfTextingInvalid,
                    summaryOfTextingRequired: sharedMessagingCompliance.enUS.summaryOfTextingRequired,
                    textMessagingComplianceRequired: sharedMessagingCompliance.enUS.textMessagingComplianceRequired,
                    textMessagingConsentRequired: sharedMessagingCompliance.enUS.textMessagingConsentRequired,
                    textMessagingDescription: sharedMessagingCompliance.enUS.textMessagingDescription,
                    weAppendOptOut: sharedMessagingCompliance.enUS.weAppendOptOut,
                    weWillNotSendOptOut: sharedMessagingCompliance.enUS.weWillNotSendOptOut,
                    messagingDisabledFreeTrial: {
                        title: "Cannot complete local registration while in free trial.",
                        warningPart1: "This form will become available once your free trial is complete."
                    },
                    messagingEnabledForLocalNumber: {
                        title: "Local Phone Number(s) currently have messaging enabled.",
                        warning: "All Local phone numbers must have messaging disabled before you can disable your Local Messaging registration."
                    },
                    useCaseTwoFactorAuthentication: {
                        label: "Two-Factor Authentication (2FA)",
                        tooltip: "Two-Factor authentication, one-time use password, password reset."
                    },
                    useCaseAccountNotification: {
                        label: "Account Notifications",
                        tooltip: "All reminders, alerts, and notifications.  (Examples include:  flight delayed, hotel booked, appointment reminders)."
                    },
                    useCaseCustomerCare: {
                        label: "Customer Care",
                        tooltip: "All customer care messaging, including account management and customer support."
                    },
                    useCaseDeliveryNotification: {
                        label: "Delivery Notifications",
                        tooltip: "Information about the status of the delivery of a product or service."
                    },
                    useCaseFraudAlert: {
                        label: "Fraud Alerts",
                        tooltip: "Fraud alert notifications."
                    },
                    useCaseMarketing: {
                        label: "Marketing",
                        tooltip: "Any communication with marketing and/or promotional content."
                    },
                    useCasePollingAndVoting: {
                        label: "Polling and Voting",
                        tooltip: "The sending of surveys and polling/voting campaigns."
                    },
                    useCasePublicServiceAnnouncement: {
                        label: "Public Service Announcements",
                        tooltip: "An informational message that is meant to raise the audience's awareness about an important issue."
                    },
                    useCaseSecurityAlert: {
                        label: "Security Alerts",
                        tooltip: "A notification that the security of a system, either software or hardware, has been compromised in some way and there is an action you need to take."
                    },
                },
                messagingComplianceProfileTab: {
                    acknowledgementBulletOne: "all information above is true and accurate",
                    acknowledgementBulletThree: "all calls and texts and content therein will comply with applicable local, state, and federal laws",
                    acknowledgementBulletTwo: "this account will be used for business, non-personal communications only",
                    acknowledgementLineOne: "I attest under penalty of perjury that",
                    acknowledgementSignature: "Type Your Name to Acknowledge Your Agreement",
                    acknowledgementStatement: "I understand that improperly classifying a business account as personal, submitting false information, or failure to abide by applicable laws governing calling, texting and content therein may result in non-delivery of calls/texts, termination of my service and fines of up to $10,000 per violation.",
                    authorizedSignatureRequired: "Agreement is required.",
                    addressRequired: "Address is required.",
                    brandNameRequired: "DBA or Brand Name is required.",
                    businessNameRequired: "Legal Name of Business is required.",
                    businessNumberDescription: "Enter your Business Number (BN). Do NOT enter your Registry ID (also known as Corporation Number) or Federal Tax ID Number (TIN). Ensure that your legal company name is consistent with your registration and is properly spelled. The address you enter should also be the same as that used in registering with the Canada Revenue Agency.",
                    businessNumberRequired: "Business Number is required",
                    charity: "Non-Profit Organization",
                    cityRequired: "City is required.",
                    companySizeRequired: "Company Size is required.",
                    einDescriptionOne: "If you are a US company or a foreign company with a US IRS Employer Identification Number (EIN), please enter that 9-digit number here and ensure that your legal company name is consistent with your IRS registration and is properly spelled. The address you enter should also be the same as that used in registering with the IRS.",
                    einDescriptionTwo: "This is required for text messaging to be enabled on more than 5 local numbers.",
                    einTaxIdInvalid: "EIN / Tax ID is invalid.",
                    einTaxIdRequired: "EIN / Tax ID is required.",
                    emailAddressInvalid: "Please enter a valid email address.",
                    emailAddressRequired: "Please enter an email address.",
                    exchangeRequired: "Exchange is required.",
                    firstNameRequired: "First Name is required.",
                    formOfBusinessRequired: "Form of Business is required.",
                    franchise: "Franchise",
                    government: "Government",
                    industryRequired: "Industry is required.",
                    jobTitleRequired: "Job Title is required.",
                    labelAddressLineOne: "Address",
                    labelAddressLineTwo: "Address 2 (optional)",
                    labelAgreement: "Agreement",
                    labelBrandName: "DBA or Brand Name",
                    labelBusinessName: "Legal Name of Business",
                    labelBusinessNumber: "Business Number",
                    labelCity: "City",
                    labelCountry: "Country",
                    labelCountryOfRegistration: "Country of Registration",
                    labelEinTaxId: "EIN",
                    labelEmailAddress: "Email Address",
                    labelExchange: "Exchange",
                    labelFirstName: "First Name",
                    labelFormOfBusiness: "Form of Business",
                    labelIndustry: "Industry",
                    labelJobTitle: "Job Title",
                    labelLastName: "Last Name",
                    labelPhoneNumber: "Phone Number",
                    labelPointOfContact: "Point of Contact for any Compliance or Fraud Inquiries",
                    labelPostalCode: "Postal Code",
                    labelProvince: "Province",
                    labelProvinceOfIncorporation: "Province of Incorporation",
                    labelRegistryId: "Registry ID",
                    labelSameAsBusinessAddress: "Same as Business Address",
                    labelState: "State",
                    labelStateOfIncorporation: "State of Incorporation",
                    labelStockSymbol: "Stock Symbol",
                    labelWebsiteUrl: "Website URL",
                    labelZipCode: "Zip",
                    lastNameRequired: "Last Name is required.",
                    locationDescriptionOne: "Please provide the address associated with your ",
                    locationDescriptionThree: "which could be different than the address of your payment method.",
                    locationDescriptionTwo: "business registration,",
                    nonProfitWarningTitle: "Registering as a Non-Profit Organization",
                    nonProfitWarningDescription: "This type should be selected only by organizations with the NON-PROFIT status. Organizations with the NOT-FOR-PROFIT status should instead register as a Private Company.",
                    phoneNumberInvalid: shared.enUS.phoneNumberInvalid,
                    phoneNumberRequired: "Phone Number is required.",
                    postalCodeInvalid: "Please enter a valid postal code.",
                    postalCodeRequired: "Postal code is required.",
                    privateCompany: "Registered Private Corporation",
                    provinceRequired: "Province is required.",
                    provinceOfIncorporationRequired: "Province of Incorporation is required.",
                    publiclyTraded: "Publicly Traded Corporation",
                    publicUtility: "Public Utility",
                    registryIdTooltip: "Registry Id is no longer accepted by The Campaign Registry",
                    select: "Select",
                    soleProprietor: "Sole Proprietor",
                    stateRequired: "State is required.",
                    stateOfIncorporationRequired: "State of Incorporation is required.",
                    stockSymbolRequired: "Stock Symbol is required.",
                    verifiedBrandTooltip: "Please contact support at <br/> " + shared.enUS.customerServiceNumberFormatted + " to update.",
                    websiteDescription: "Wireless carriers require a website presence in order to verify your identity and permit messaging to their customers. Please provide the url of your business website, such as www.patlive.com. If you do not have a business website, you may use a business social media URL instead, for example, www.facebook.com/PATLive. If your business does not have a website or social media profile, it will not be accepted or approved for messaging by wireless carriers.",
                    websiteUrlInvalid: "Please enter a valid URL.",
                    websiteUrlRequired: "Website URL is required.",
                    zipCodeInvalid: "Please enter a valid ZIP code.",
                    zipCodeRequired: "Please enter a ZIP code.",
                    none: "NONE",
                    nasdaq: "NASDAQ",
                    nyse: "NYSE",
                    amex: "AMEX",
                    amx: "AMX",
                    asx: "ASX",
                    b3: "B3",
                    bme: "BME",
                    bse: "BSE",
                    fra: "FRA",
                    icex: "ICEX",
                    jpx: "JPX",
                    jse: "JSE",
                    krx: "KRX",
                    lon: "LON",
                    nse: "NSE",
                    omx: "OMX",
                    sehk: "SEHK",
                    sgx: "SGX",
                    sse: "SSE",
                    sto: "STO",
                    swx: "SWX",
                    szse: "SZSE",
                    tsx: "TSX",
                    twse: "TWSE",
                    vse: "VSE",
                    other: "OTHER",
                    agriculture: "Agriculture",
                    architecture: "Architecture",
                    arts: "Arts and Artists",
                    beauty: "Beauty and Personal Care",
                    business: "Business Services",
                    computers: "Computers and Electronics",
                    construction: "Construction",
                    consulting: "Consulting",
                    creative: "Creative Services/Agency",
                    daily: "Daily Deals/E-Coupons",
                    eCommerce: "ECommerce",
                    education: "Education and Training",
                    entertainment: "Entertainment and Events",
                    gambling: "Gambling",
                    games: "Gaming",
                    health: "Health and Fitness",
                    home: "Home and Garden",
                    insurance: "Insurance",
                    legal: "Legal",
                    manufacturing: "Manufacturing",
                    marketing: "Marketing and Advertising",
                    media: "Media and Publishing",
                    medical: "Medical, Dental, and Healthcare",
                    music: "Music and Musicians",
                    non: "Non-Profit",
                    pharmaceuticals: "Pharmaceuticals",
                    photo: "Photo and Video",
                    politics: "Politics",
                    professional: "Professional Services",
                    "public": "Public Relations",
                    real: "Real Estate",
                    recruitment: "Recruitment and Staffing",
                    religion: "Religion",
                    restaurant: "Restaurant and Venue",
                    retail: "Retail",
                    social: "Social Networks and Online Communities",
                    software: "Software and Web App",
                    sports: "Sports",
                    telecommunications: "Telecommunications",
                    travel: "Travel and Transportation",
                    vitamin: "Vitamin Supplements",
                    energy: "Energy and Utilities",
                    financial: "Financial and Banking Services",
                    food: "Food Services"
                },
                messagingComplianceTollFreeMessagingTab: {
                    disabled: "Disabled",
                    enabled: "Enabled",
                    exampleFourDescriptionOne: sharedMessagingCompliance.enUS.exampleFourDescriptionOne,
                    exampleFourDescriptionTwo: sharedMessagingCompliance.enUS.exampleFourDescriptionTwo,
                    exampleNote: sharedMessagingCompliance.enUS.exampleNote,
                    exampleOneDescriptionOne: sharedMessagingCompliance.enUS.exampleOneDescriptionOne,
                    exampleOneDescriptionTwo: sharedMessagingCompliance.enUS.exampleOneDescriptionTwo,
                    exampleThreeDescriptionOne: sharedMessagingCompliance.enUS.exampleThreeDescriptionOne,
                    exampleThreeDescriptionTwo: sharedMessagingCompliance.enUS.exampleThreeDescriptionTwo,
                    exampleTwoDescriptionOne: sharedMessagingCompliance.enUS.exampleTwoDescriptionOne,
                    exampleTwoDescriptionTwo: sharedMessagingCompliance.enUS.exampleTwoDescriptionTwo,
                    labelAccountNotifications: sharedMessagingCompliance.enUS.labelAccountNotifications,
                    labelAppointmentReminders: sharedMessagingCompliance.enUS.labelAppointmentReminders,
                    labelConversationMessaging: sharedMessagingCompliance.enUS.labelConversationMessaging,
                    labelCustomerConsentEmployeeRelationship: sharedMessagingCompliance.enUS.labelCustomerConsentEmployeeRelationship,
                    labelCustomerConsentInitiateConversation: sharedMessagingCompliance.enUS.labelCustomerConsentInitiateConversation,
                    labelCustomerConsentLeadCaptureForms: sharedMessagingCompliance.enUS.labelCustomerConsentLeadCaptureForms,
                    labelCustomerConsentOnlineCheckout: sharedMessagingCompliance.enUS.labelCustomerConsentOnlineCheckout,
                    labelCustomerConsentOther: sharedMessagingCompliance.enUS.labelCustomerConsentOther,
                    labelCustomerConsentOtherInvalid: sharedMessagingCompliance.enUS.labelCustomerConsentOtherInvalid,
                    labelCustomerConsentOtherRequired: sharedMessagingCompliance.enUS.labelCustomerConsentOtherRequired,
                    labelCustomerConsentPosTransaction: sharedMessagingCompliance.enUS.labelCustomerConsentPosTransaction,
                    labelDeliveryStatusUpdates: sharedMessagingCompliance.enUS.labelDeliveryStatusUpdates,
                    labelGeneralMarketing: sharedMessagingCompliance.enUS.labelGeneralMarketing,
                    labelHowManyTextsPerDay: sharedMessagingCompliance.enUS.labelHowManyTextsPerDay,
                    labelPercentOfTextsToCanada: sharedMessagingCompliance.enUS.labelPercentOfTextsToCanada,
                    labelPollingAndVoting: sharedMessagingCompliance.enUS.labelPollingAndVoting,
                    labelSecurityOrSystemAlerts: sharedMessagingCompliance.enUS.labelSecurityOrSystemAlerts,
                    labelSummaryOfTexting: sharedMessagingCompliance.enUS.labelSummaryOfTexting,
                    labelTextMessageSampleFour: sharedMessagingCompliance.enUS.labelTextMessageSampleFour,
                    labelTextMessageSampleOne: sharedMessagingCompliance.enUS.labelTextMessageSampleOne,
                    labelTextMessageSampleThree: sharedMessagingCompliance.enUS.labelTextMessageSampleThree,
                    labelTextMessageSampleTwo: sharedMessagingCompliance.enUS.labelTextMessageSampleTwo,
                    labelTextMessagingBadExampleOne: sharedMessagingCompliance.enUS.labelTextMessagingBadExampleOne,
                    labelTextMessagingBadExampleTwo: sharedMessagingCompliance.enUS.labelTextMessagingBadExampleTwo,
                    labelTextMessagingBadExampleWhyOne: sharedMessagingCompliance.enUS.labelTextMessagingBadExampleWhyOne,
                    labelTextMessagingBadExampleWhyTwo: sharedMessagingCompliance.enUS.labelTextMessagingBadExampleWhyTwo,
                    labelTextMessagingCompliance: sharedMessagingCompliance.enUS.labelTextMessagingCompliance,
                    labelTextMessagingConsent: sharedMessagingCompliance.enUS.labelTextMessagingConsent,
                    labelTextMessagingConsentDescription: sharedMessagingCompliance.enUS.labelTextMessagingConsentDescription,
                    labelTextMessagingDelivery: sharedMessagingCompliance.enUS.labelTextMessagingDelivery,
                    labelTextMessagingExamples: sharedMessagingCompliance.enUS.labelTextMessagingExamples,
                    labelTextMessagingIneligibleUseCases: sharedMessagingCompliance.enUS.labelTextMessagingIneligibleUseCases,
                    labelTextMessagingGoodExampleOne: sharedMessagingCompliance.enUS.labelTextMessagingGoodExampleOne,
                    labelTextMessagingGoodExampleTwo: sharedMessagingCompliance.enUS.labelTextMessagingGoodExampleTwo,
                    labelTextMessagingPurpose: sharedMessagingCompliance.enUS.labelTextMessagingPurpose,
                    labelTextMessagingPurposeDescription: sharedMessagingCompliance.enUS.labelTextMessagingPurposeDescription,
                    labelSmsUseEligibility: sharedMessagingCompliance.enUS.labelSmsUseEligibility,
                    labelTypesOfTextMessaging: sharedMessagingCompliance.enUS.labelTypesOfTextMessaging,
                    majorityOfMessagesSentToCanadaRequired: sharedMessagingCompliance.enUS.majorityOfMessagesSentToCanadaRequired,
                    messagingTextsPerDayRequired: sharedMessagingCompliance.enUS.messagingTextsPerDayRequired,
                    pleaseSpecify: sharedMessagingCompliance.enUS.pleaseSpecify,
                    replyStop: sharedMessagingCompliance.enUS.replyStop,
                    sampleTextMessageInvalid: sharedMessagingCompliance.enUS.sampleTextMessageInvalid,
                    sampleTextMessageRegulatoryNotice: sharedMessagingCompliance.enUS.sampleTextMessageRegulatoryNotice,
                    sampleTextMessageRequired: sharedMessagingCompliance.enUS.sampleTextMessageRequired,
                    select: "Select",
                    smsIneligibleUseCaseFive: sharedMessagingCompliance.enUS.smsIneligibleUseCaseFive,
                    smsIneligibleUseCaseFiveExamples: sharedMessagingCompliance.enUS.smsIneligibleUseCaseFiveExamples,
                    smsIneligibleUseCaseFour: sharedMessagingCompliance.enUS.smsIneligibleUseCaseFour,
                    smsIneligibleUseCaseFourExamples: sharedMessagingCompliance.enUS.smsIneligibleUseCaseFourExamples,
                    smsIneligibleUseCaseOne: sharedMessagingCompliance.enUS.smsIneligibleUseCaseOne,
                    smsIneligibleUseCaseOneExamples: sharedMessagingCompliance.enUS.smsIneligibleUseCaseOneExamples,
                    smsIneligibleUseCaseThree: sharedMessagingCompliance.enUS.smsIneligibleUseCaseThree,
                    smsIneligibleUseCaseThreeExamples: sharedMessagingCompliance.enUS.smsIneligibleUseCaseThreeExamples,
                    smsIneligibleUseCaseTwo: sharedMessagingCompliance.enUS.smsIneligibleUseCaseTwo,
                    smsIneligibleUseCaseTwoExamples: sharedMessagingCompliance.enUS.smsIneligibleUseCaseTwoExamples,
                    useCaseEligibilityRequired: sharedMessagingCompliance.enUS.useCaseEligibilityRequired,
                    summaryOfTextingInvalid: sharedMessagingCompliance.enUS.summaryOfTextingInvalid,
                    summaryOfTextingRequired: sharedMessagingCompliance.enUS.summaryOfTextingRequired,
                    textMessagingComplianceRequired: sharedMessagingCompliance.enUS.textMessagingComplianceRequired,
                    textMessagingConsentRequired: sharedMessagingCompliance.enUS.textMessagingConsentRequired,
                    textMessagingDescription: sharedMessagingCompliance.enUS.textMessagingDescription,
                    zeroToFiveHundred: "0-500",
                    fiveHundredAndOneToOneThousand: "501-1000",
                    oneThousandAndOneToTwoThousand: "1001-2000",
                    moreThanTwoThousand: "More than 2000/day",
                    weAppendOptOut: sharedMessagingCompliance.enUS.weAppendOptOut,
                    weWillNotSendOptOut: sharedMessagingCompliance.enUS.weWillNotSendOptOut,
                    messagingDisabledFreeTrial: {
                        title: "Cannot complete toll-free registration while in free trial.",
                        warningPart1: "This form will become available once your free trial is complete."
                    },
                    messagingEnabledForTollfreeNumber: {
                        title: "Toll-Free Phone Number(s) currently have messaging enabled.",
                        warning: "All Toll-Free phone numbers must have messaging disabled before you can disable your Toll-Free Messaging registration."
                    },
                    useCase: {
                        twoFactorAuthentication: "Two-Factor Authentication",
                        appNotifications: "App Notifications",
                        appointments: "Appointments",
                        auctions: "Auctions",
                        autoRepairServices: "Auto Repair Services",
                        bankTransfers: "Bank Transfers",
                        billing: "Billing",
                        bookingConfirmations: "Booking Confirmations",
                        businessUpdates: "Business Updates",
                        careerTraining: "Career Training",
                        chatbot: "Chatbot",
                        conversationalAlerts: "Conversational / Alerts",
                        courierServicesDeliveries: "Courier Services & Deliveries",
                        covid19Alerts: "COVID-19 Alerts",
                        emergencyAlerts: "Emergency Alerts",
                        eventsPlanning: "Events & Planning",
                        financialServices: "Financial Services",
                        fraudAlerts: "Fraud Alerts",
                        fundraising: "Fundraising",
                        generalMarketing: "General Marketing",
                        generalSchoolUpdates: "General School Updates",
                        healthcareAlerts: "Healthcare Alerts",
                        housingCommunityUpdates: "Housing Community Updates",
                        hrStaffing: "HR / Staffing",
                        insuranceServices: "Insurance Services",
                        jobDispatch: "Job Dispatch",
                        legalServices: "Legal Services",
                        motivationalReminders: "Motivational Reminders",
                        notaryNotifications: "Notary Notifications",
                        orderNotifications: "Order Notifications",
                        political: "Political",
                        publicWorks: "Public Works",
                        realEstateServices: "Real Estate Services",
                        religiousServices: "Religious Services",
                        repairAndDiagnosticsAlerts: "Repair and Diagnostics Alerts",
                        rewardsProgram: "Rewards Program",
                        surveys: "Surveys",
                        systemAlerts: "System Alerts",
                        votingReminders: "Voting Reminders",
                        waitListAlerts: "Waitlist Alerts",
                        webinarReminders: "Webinar Reminders",
                        workshopAlerts: "Workshop Alerts"
                    }
                },
                authorizedSignatureActionModal: {
                    acknowledgementSignature: "Type Your Name to Acknowledge Your Agreement",
                    authorizedSignatureRequired: "Agreement is required.",
                    headerText: "Agreement Required",
                    warningTitle: "I attest under penalty of perjury that all information in this form is true and accurate.",
                    warningMessage: "I understand that submitting false information may result in non-delivery of calls/texts, termination of my service and fines of up to $10,000 per violation.",
                },
                otpVerificationActionModal: {
                    headerText: "Local Messaging Verification",
                    smsPinCaptureDescription: "Please enter the PIN sent to {{mobilePhoneNumber}}. If you would like the PIN to be sent to a different number, please click Cancel and update the \"PIN Verification\" field on Local Messaging with your desired number.",
                    smsPinCaptureTitle: "SMS Registration PIN",
                    smsPinInputLabel: "SMS PIN:",
                    smsPinRequired: "SMS PIN cannot be empty",
                    smsPinResend: "Resend SMS PIN"
                },
                confirmDisabledNumbersModal: {
                    disabledSmsMessage: "To comply with new regulations, messaging has been disabled for all local number(s) <b>except</b> the one below. A System Admin may change which number is enabled for messaging in the Phone Number Settings at any time.",
                    requirementMessage: "Thank you for updating your information.  Unfortunately, wireless carriers such as T-Mobile and Verizon have put in place new restrictions on who can text customers on their networks.  Personal and sole proprietor accounts are now only allowed to use messaging on one (1) local phone number.  These restrictions are industry-wide and are not imposed by PATLive.",
                    smsDisabledTitle: "SMS Notice"
                },
                tcrBrandRegistrationFailures: {
                    invalidInput: "",
                    duplicateRecord: "Duplicate record detected. This maybe be triggered by attempts to submit two identical brand registration concurrently.",
                    brandLimitExceeded: "Exceeded the maximum number of brands for your CSP account.",
                    countryRestricted: "Brand's country is blacklisted and not allowed to be registered in TCR.",
                    soleProprietorNotEnabled: "CSP account not enabled for sole proprietor feature.",
                    duplicateBrand: "Duplicate threshold detected while updating/creating brand record.",
                    unsupportedPhoneNumber: "Unsupported phone number or mobile phone number. E.g. SP brand requires US/CA wireless phone number in mobile phone number.",
                    unsupportedEmailAddress: "Unsupported email address. Disposable email is not permitted.",
                    invalidAddress: "Invalid street address. Must ensure all address fields collectively form a valid postal address.",
                    unsupportedAddress: "Unsupported street address. E.g. SP brand requires US/CA street address.",
                    invalidBrandName: "Obfuscation check failed on brand fields, including first name, last name, and brand name for SP brand",
                    tcrSystemError: "TCR internal system error. Please contact TCR support.",
                    tempSystemError: "Temporary system error. Unable to complete brand registration due to temporary system error. Please retry request in 30 seconds.",
                    externalVetUnavailable: "The external vetting provider is unable to accept request at this time. Please retry request in 30 seconds."
                },
                voicemailBoxes: {
                    deactivateTooltip: "Cannot delete system voicemail boxes.",
                    deactivateUserTooltip: "To remove this voicemail box, deactivate the user.",
                    deactivateGroupTooltip: "To remove this voicemail box, deactivate the group.",
                    header: "Voicemail Boxes",
                    noResults: shared.enUS.noResultsFound,
                    noVoicemailBoxes: "No Voicemail Boxes to Display",
                    search: shared.enUS.search,
                },
                addVoicemailBox: {
                    add: shared.enUS.add,
                    cancel: shared.enUS.cancel,
                    greetingsTab: "Greetings",
                    headerAdd: "Add Voicemail Box",
                    headerEdit: "Edit Voicemail Box",
                    lastMember: "Cannot remove user from their own voicemail box.",
                    lastMemberSelf: "Cannot remove yourself from your own voicemail box.",
                    name: "Name",
                    nameInline: "Name: ",
                    nameRequired: "Name is required.",
                    nameNotUnique: "This name is already used by another voicemail box.",
                    save: shared.enUS.save,
                    subscribersTab: "Subscribers",
                    type: "Type: ",
                    validationPleaseFix: "Please correct the problems in these sections and try again.",
                    validationTabDescription: "Oops, it looks like there are some issues with these sections:",
                },
                addVoicemailBoxGreetings: {
                    addItemTitle: "+ Add Another",
                    currentTooltip: "Cannot delete the current greeting.",
                    default: "Current Greeting",
                    deleteTooltip: "Cannot delete the default greeting.",
                    editTooltip: "Cannot edit the default greeting.",
                    nameRequired: "Name is required.",
                    nameNotUnique: "This name is already used by another greeting.",
                    setDefault: "Make Current",
                },
                users: {
                    cancelInvite: "Cancel Invite",
                    deactivateSelf: "Cannot deactivate yourself.",
                    header: "Users",
                    invitedUser: "Invited User",
                    noResults: shared.enUS.noResultsFound,
                    noUsers: "No Users to Display",
                    reactivate: "Reactivate User",
                    resendInvite: "Resend Invite",
                    search: shared.enUS.search,
                },
                addUserModal: {
                    addAnother: "+ Add Another",
                    addUser: "Add User",
                    additionalCharge: "Once you have reached the limit of users included with your plan, you'll be charged a monthly fee for each additional user.",
                    emailAddressDuplicate: "You’ve already provided this email in the invite list.",
                    forDetails: "For details, please visit our &nbsp;",
                    labelBillingAdmin: "Do you want this user to be a Billing Admin?",
                    labelEmail: "Email Address",
                    labelSystemAdmin: "Do you want this user to be a System Admin?",
                    maxUserInvites: "Limit of 10 user invites per batch.",
                    pricingPage: "pricing page",
                    remove: "Remove",
                    scriptUpdatesMessagePart1: "If you would like to make changes to any of your scripts after adding users, please contact support at " + shared.enUS.customerServiceNumberFormatted + " or email ",
                    scriptUpdatesMessageLink1: shared.enUS.supportEmail,
                    scriptUpdatesMessagePart2: ".",
                    tooltipBilling: "Billing Admins have access to Billing configurations in PATLive and can view and alter all billing settings, including statements, payment methods, one-time payments and account status changes like closing or reopening your account.",
                    tooltipSystem: "System Admins have access to System configurations in PATLive and can view and alter all system settings. System Admins may make changes that impact your monthly charges, but they do not have the ability to view statements or alter billing settings.",
                },
                deactivateUserModal: {
                    areYouSure_cancel: "Are you sure you want to cancel this invite?",
                    areYouSure_deactivate: "Are you sure you want to deactivate this user?",
                    callsRoutedToUser: "Calls are being routed to {{firstName}} (or their voicemail box) from",
                    cancel: shared.enUS.cancel,
                    cancelInvite: "Cancel Invite",
                    deactivateHeader: "Deactivate User",
                    onlyAuthorizedMessager: "{{firstName}} is the only person receiving texts from these numbers",
                    onlyMemberOfUserGroup: "{{firstName}} is the only member of these groups",
                    onlySubscriberCallRecordings: "{{firstName}} is the only subscriber of these numbers' call recordings",
                    onlySubscriberLiveReceptionistScripts: "{{firstName}} is the only subscriber of these live receptionist scripts",
                    onlySubscriberVoicemailBoxes: "{{firstName}} is the only subscriber of these voicemail boxes",
                    transferOptionOnLiveReceptionistScripts: "{{firstName}} is a transfer option on these live receptionist scripts.",
                    pleaseSelect: shared.enUS.pleaseSelect,
                    proceedWarning: "To proceed, you must designate another user or group to take {{firstName, makePossessive}} place in the following scenarios.",
                    proceedInstruct: "Alternatively, you can manually resolve these conflicts and then come back to try deactivating {{firstName}} again.",
                    scriptUpdatesMessagePart1: "If you would like to make changes to any of your scripts after deactivating this user, please contact support at " + shared.enUS.customerServiceNumberFormatted + " or email ",
                    scriptUpdatesMessageLink1: shared.enUS.supportEmail,
                    scriptUpdatesMessagePart2: ".",
                    selectionRequired: "Please make a selection to continue",
                    sendCallsToQuestion: "Select a user or group to replace {{firstName}} in the below scenarios",
                },
                reactivateUserModal: {
                    areYouSure_reactivate: "Are you sure you want to reactivate this user?",
                    areYouSure_resend: "Are you sure you want to send a new invite?",
                    cancel: shared.enUS.cancel,
                    monthlyCharges: "Monthly charges will resume as listed on our&nbsp;",
                    reactivateUser: "Reactivate User",
                    resendInvite: "Resend Invite",
                    pricingPage: "pricing page",
                    scriptUpdatesMessagePart1: "If you would like to make changes to any of your scripts after reactivating this user, please contact support at " + shared.enUS.customerServiceNumberFormatted + " or email ",
                    scriptUpdatesMessageLink1: shared.enUS.supportEmail,
                    scriptUpdatesMessagePart2: "."
                },
                editUser: {
                    cancel: shared.enUS.cancel,
                    devicesTab: "Devices",
                    groupsTab: "Groups",
                    header: "Edit User",
                    profileTab: "Profile",
                    subscriptionsTab: "Subscriptions",
                    validationPleaseFix: "Please correct the problems in these sections and try again.",
                    validationTabDescription: "Oops, it looks like there are some issues with these sections:",
                    voicemailTab: "Voicemail"
                },
                userGroups: {
                    deactivateTooltip: "Cannot deactivate system groups.",
                    header: "Groups",
                    member: "{{count}} Member",
                    member_plural: "{{count}} Members",
                    noResults: shared.enUS.noResultsFound,
                    noUserGroups: "No Groups to Display",
                    search: shared.enUS.search,
                },
                deactivateUserGroupModal: {
                    areYouSure: "Are you sure you want to deactivate this group?",
                    callsRoutedToUserGroup: "Calls are being routed to {{groupName}} (or their voicemail box) from",
                    deactivateHeader: "Deactivate Group",
                    member: "{{count}} Member",
                    member_plural: "{{count}} Members",
                    onlyAuthorizedMessager: "{{groupName}} is the only one receiving texts from these numbers",
                    onlySubscriberCallRecordings: "{{groupName}} is the only subscriber of these numbers' call recordings",
                    onlySubscriberLiveReceptionistScripts: "{{groupName}} is the only subscriber of these live receptionist scripts",
                    onlySubscriberVoicemailBoxes: "{{groupName}} is the only subscriber of these voicemail boxes",
                    transferOptionOnLiveReceptionistScripts: "{{groupName}} is a transfer option on these live receptionist scripts.",
                    pleaseSelect: shared.enUS.pleaseSelect,
                    proceedWarning: "To proceed, you must designate another user or group to take {{groupName, makePossessive}} place in the following scenarios.",
                    proceedInstruct: "Alternatively, you can manually resolve these conflicts and then come back to try deactivating {{groupName}} again.",
                    selectionRequired: "Please make a selection to continue",
                    sendCallsToQuestion: "Select a user or group to replace {{groupName}} in the below scenarios",
                },
                reactivateUserGroupModal: {
                    areYouSure: "Are you sure you want to reactivate this group?",
                    member: "{{count}} Member",
                    member_plural: "{{count}} Members",
                    reactivateGroup: "Reactivate Group",
                },
                addUserGroup: {
                    add: shared.enUS.add,
                    cancel: shared.enUS.cancel,
                    headerAdd: "Add Group",
                    headerEdit: "Edit Group",
                    profileTab: "Profile",
                    save: shared.enUS.save,
                    validationPleaseFix: "Please correct the problems in these sections and try again.",
                    validationTabDescription: "Oops, it looks like there are some issues with these sections:",
                    voicemailTab: "Voicemail"
                },
                userGroupProfile: {
                    allUsersGroupMember: "Cannot modify members of All Users group.",
                    billingAdminsGroupMember: "Cannot remove yourself from Billing Admins group.",
                    groupNameTooltip: "Cannot rename system groups.",
                    nameRequired: "Please enter a group name.",
                    nameNotUnique: "Group name is already in use.",
                    labelGroupMembers: "Members",
                    labelGroupName: "Name",
                    labelGroupNameDisabled: "Name:",
                    lastItemTooltip: "At least one member is required.",
                    systemAdminsGroupMember: "Cannot remove yourself from System Admins group.",
                },
                userGroupVoicemail: {
                    cancel: shared.enUS.cancel,
                    greetingsTab: "Greetings",
                    save: shared.enUS.save,
                    subscribersTab: "Subscribers",
                },
                userGroupVoicemailGreetings: {
                    addItemTitle: "+ Add Another",
                    currentTooltip: "Cannot delete the current greeting.",
                    default: "Current Greeting",
                    deleteTooltip: "Cannot delete the default greeting.",
                    editTooltip: "Cannot edit the default greeting.",
                    setDefault: "Make Current",
                },
                numberPicker: {
                    alternatePrefix: "We don't have any {{prefix}} numbers in stock right now.",
                    availableNumbers: "Available Numbers",
                    back: shared.enUS.back,
                    default: shared.enUS.default,
                    failedReservation: "We were unable to reserve the following number: {{phoneNumber}}",
                    failedProvision: "We were unable to provision the following number: {{phoneNumber}}",
                    maxNumbersCanAdd: "You can only select {{maxNumber}} phone numbers",
                    messagingDisabled: "Messaging Disabled",
                    mustSelectAPhoneNumber: "Please select at least one phone number.",
                    next: "Refresh Numbers",
                    noNpaResults: "We don't have any {{city}} {{npa}} numbers in stock right now, but we do have the {{npa}} area code available in these cities that are local to {{city}}.",
                    noRegionCityResults: "We don't have any {{city}} {{npa}} numbers in stock right now, but we do have these area codes that are local to {{city}} {{npa}}.",
                    noRepeatingNumberResults: "We don't have any repeating numbers in the {{npa}} area code.",
                    noResultsFound: shared.enUS.noResultsFound,
                    noResults: "We don't have any {{city}} {{npa}} numbers in stock right now. To inquire about backorder status, please call +1 (800) 775-7790.",
                    noVanityResults: 'Sorry, we can’t find any numbers that {{vanityType}} "{{vanityString}}"',
                    noTollFreeVanityResults: 'Sorry, we can’t find any numbers that {{vanityType}} "{{vanityString}}" - even when we expanded your search to include all toll-free prefixes.',
                    numberPickerLoading: "Loading...",
                    prefix: 'Prefix',
                    pricingMessage: "You'll be charged a monthly fee for each additional phone number. For details, please visit our ",
                    pricingPage: "pricing page.",
                    province: shared.enUS.regionType.province,
                    resultsHere: "Search results will appear here.",
                    repeating: shared.enUS.repeating,
                    search: shared.enUS.search,
                    selectCity: "City",
                    selectCountry: "Country",
                    selectedNumbers: "Selected Numbers",
                    selectNpa: "Area Code",
                    selectPrefix: "Area Code",
                    selectVanity: "Vanity Number",
                    state: shared.enUS.regionType.state,
                    unavailableButLocalEquivalent: "We don't have any {{city}} {{npa}} numbers currently, but we do have other area codes that are local equivalents to {{city}} {{npa}}:",
                    unavailableInCity: "We don't have any {{npa}} numbers in {{city}} currently, but we do have {{npa}} numbers available in these cities.",
                    unavailableInRegionCity: "Sorry, but we don't have any {{city}} {{npa}} numbers. We automatically searched for numbers in other area codes and cities that are local equivalents to your selection, but we don't have any of those in stock, either. <br/> <br/> However, in most cases, we can replenish out-of-stock areas in as little as 3-5 business days. For assistance with a custom order, please call +1 (800) 775-7790.",
                    vanity: shared.enUS.vanity,
                },
                signupNumberPicker: {
                    alternatePrefix: "We don't have any {{prefix}} numbers in stock right now.",
                    availableNumbers: "Available Numbers",
                    back: shared.enUS.back,
                    default: shared.enUS.default,
                    failedReservation: "We were unable to reserve the following number: {{phoneNumber}}",
                    failedProvision: "We were unable to provision the following number: {{phoneNumber}}",
                    maxNumbersCanAdd: "You can only select {{maxNumber}} phone numbers",
                    mustSelectAPhoneNumber: "Please select at least one phone number.",
                    next: "Refresh Numbers",
                    noNpaResults: "We don't have any {{city}} {{npa}} numbers in stock right now, but we do have the {{npa}} area code available in these cities that are local to {{city}}.",
                    noRegionCityResults: "We don't have any {{city}} {{npa}} numbers in stock right now, but we do have these area codes that are local to {{city}} {{npa}}.",
                    noRepeatingNumberResults: "We don't have any repeating numbers in the {{npa}} area code.",
                    noResultsFound: shared.enUS.noResultsFound,
                    noResults: "We don't have any {{city}} {{npa}} numbers in stock right now. To inquire about backorder status, please call +1 (800) 775-7790.",
                    noVanityResults: 'Sorry, we can’t find any numbers that {{vanityType}} "{{vanityString}}"',
                    numberPickerLoading: "Loading...",
                    prefix: 'Prefix',
                    pricingMessage: "You'll be charged a monthly fee for each additional phone number. For details, please visit our ",
                    province: shared.enUS.regionType.province,
                    resultsHere: "Search results will appear here.",
                    repeating: shared.enUS.repeating,
                    selectCity: "City",
                    selectCountry: "Country",
                    selectedNumbers: "Selected Numbers",
                    selectNpa: "Area Code",
                    selectPrefix: "Area Code",
                    selectVanity: "Vanity Number",
                    state: shared.enUS.regionType.state,
                    unavailableButLocalEquivalent: "We don't have any {{city}} {{npa}} numbers currently, but we do have other area codes that are local equivalents to {{city}} {{npa}}:",
                    unavailableInCity: "We don't have any {{npa}} numbers in {{city}} currently, but we do have {{npa}} numbers available in these cities.",
                    unavailableInRegionCity: "Sorry, but we don't have any {{city}} {{npa}} numbers. We automatically searched for numbers in other area codes and cities that are local equivalents to your selection, but we don't have any of those in stock, either. <br/> <br/> However, in most cases, we can replenish out-of-stock areas in as little as 3-5 business days. For assistance with a custom order, please call +1 (800) 775-7790.",
                    vanity: shared.enUS.vanity,
                    vanitySearchLocal: "Enter 3–7 characters to search for numbers<br/>with your vanity word or phrase.",
                    vanitySearchTollFree: "Enter 4–7 characters to search for numbers<br/>with your vanity word or phrase."
                },
                paymentMethod: {
                    paymentMethods: "Payment Methods",
                    billingMethodInfoTitle: "Automatic card payments are off",
                    billingMethodInfoMessageAch: "Your account is billed by bank transfer (ACH), so cards you add here are used only for one-time payments, not automatic charges. To switch to automatic credit card billing, please call us at " + shared.enUS.customerServiceNumberFormatted + " or email ",
                    billingMethodInfoMessageInvoice: "Your account is billed by invoice, so cards you add here are used only for one-time payments, not automatic charges. To switch to automatic credit card billing, please call us at " + shared.enUS.customerServiceNumberFormatted + " or email ",
                    billingMethodInfoMessageLink: shared.enUS.supportEmail,
                    billingMethodInfoMessageEnd: ".",
                    billingMethodTooltip: "Contact us to update your billing method.",
                    noPaymentDuringTrial: "One-time Payments cannot be made<br/>during the free trial period.",
                    noBalanceDue: "No balance due at this time.",
                    makeAPayment: "Make a Payment",
                    defaultCard: "Default Card",
                    makeDefaultCard: "Make Default",
                    deletePaymentMethodTitle: "Delete Payment Method",
                    deletePaymentMethodContent: "Are you sure you want to delete this payment method?",
                    editPaymentMethod: "Edit Payment Method",
                    defaultTooltip: 'Cannot delete the default payment method.',
                    lastItemTooltip: 'At least one payment method is required.',
                    lastValidItemTooltip: 'Cannot delete the last valid payment method.',
                    endingIn: "Ending in {{digits}}",
                },
                addPaymentMethod: {
                    billingMethodInfoTitle: "This card won’t be charged automatically",
                    billingMethodInfoMessageAch: "Your account is billed by bank transfer (ACH), so cards you add are used only for one-time payments.",
                    billingMethodInfoMessageInvoice: "Your account is billed by invoice, so cards you add are used only for one-time payments.",
                    cancel: 'Cancel',
                    nameOnCard: "Name on Card",
                    nameOnCardRequired: "Name on card is required.",
                    cardNumber: "Card Number",
                    cardNumberInvalid: "Invalid card number.",
                    cardNumberRequired: "Card number is required.",
                    cardType: "Card Type",
                    country: "Country",
                    countryInvalid: "Please select a valid country.",
                    cvv: "CVV",
                    cvvInvalid: "Invalid CVV",
                    cvvRequiredToAdd: "CVV is required.",
                    cvvRequiredToEdit: "Please re-enter your CVV to save.",
                    declinedTitle: "Card authorization failed.",
                    declinedMessage: "Please verify your card details and try again.",
                    duplicateCard: "This card is already on your account.",
                    endingIn: "Ending in {{digits}}",
                    expired: "Expired",
                    expirationDate: "Expiration Date",
                    expirationDateInvalid: "Invalid expiration date.",
                    genericFailureTitle: "We’ve encountered a problem.",
                    genericFailureMessage: "Please call " + shared.enUS.customerServiceNumberFormatted + " for assistance.",
                    headerAdd: "Add Payment Method",
                    headerEdit: "Edit Payment Method",
                    makeASelection: "Please make a selection.",
                    noSpecialCharacters: "Special characters are not allowed.",
                    postalCode: "Postal Code",
                    postalCodeInvalid: "Invalid postal code.",
                    postalCodeRequired: "Postal code is required.",
                    zipCode: "Zip Code",
                    zipCodeInvalid: "Invalid zip code.",
                    zipCodeRequired: "Zip code is required.",
                },
                makeAPayment: {
                    amount: "Amount",
                    currentBalance: "Current Balance of ",
                    endingIn: " ending in ",
                    headerButtonText: 'Next',
                    otherAmount: "Other Amount",
                    pastDueBalance: "Past Due Balance of ",
                    paymentMethod: "Payment Method",
                    specifyAmount: "Specify Amount",
                    title: "Make a Payment",
                    validationIsInFreeTrial: "You cannot make a payment during the free trial.",
                    validationNoBalance: "Your account has a current balance of $0. To make a one-time payment, you must have an outstanding balance.",
                    validationNoPaymentMethod_part1: "You don't have a valid payment method on file. To make a one-time payment, please ",
                    validationNoPaymentMethod_part2: "add a new payment method or update your current payment method.",
                    validationCannotExceedCurrentBalance: 'Amount cannot exceed current balance.',
                    declinedTitle: "Payment failed",
                    declinedMessage: "Verify the details above and try again.",
                    genericFailureTitle: "We’ve encountered an issue",
                    genericFailureMessage: "Please call " + shared.enUS.customerServiceNumberFormatted + " for assistance processing your payment."
                },
                plans: {
                    title: "Plans",
                    description: "These are your current plans. They will be billed on the same billing cycle. You can update any plan at any time.",
                    includedChatSessions: "{{count}} chat session(s) included.",
                    includedOutboundContacts: "{{count}} outbound contact(s) included.",
                    includedMinutes: "{{count}} minute(s) included.",
                    includedMinutes_telephony: "{{count}} inbound/outbound minute(s) included.",
                    includedMinutes_liveReceptionist: "{{count}} receptionist minute(s) included.",
                    includedPhoneNumbers: "{{count}} phone number(s) included.",
                    includedScripts: "{{count}} script(s) included.",
                    includedUsers: "{{count}} user(s) included.",
                    labelActivatePlan: "Activate Plan",
                    labelActive: "Active",
                    labelLiveReceptionist: "Live Receptionist",
                    labelNone: "No Plan Selected",
                    labelOutboundCalling: "Outbound Calling",
                    labelRetired: "Legacy",
                    labelTelephony: "PATLive Flex",
                    labelWebChat: "Web Chat",
                    payAsYouGo: "Pay as you go",
                    pricePerAdditionalChatSession: "Then {{price}}/session.",
                    pricePerAdditionalOutboundContact: "Then {{price}}/contact.",
                    pricePerAdditionalMinute: "Then {{price}}/minute.",
                    pricePerMonth: "{{price}}/mo.",
                    pricePerAdditionalPhoneNumber: "Then {{price}}/number.",
                    pricePerAdditionalScript: "Then {{price}}/script.",
                    pricePerAdditionalUser: "Then {{price}}/user.",
                    tagActive: "Active",
                    tagOnboarding: "Onboarding",
                    tagRetired: "Legacy",
                    unlimited: "Unlimited"
                },
                addPlan: {
                    cancel: "Cancel",
                    legacyPackageTitle: "You've got the {{name}} (Legacy) plan!",
                    legacyPackageMessageOne: "We no longer offer your plan to new customers. You can switch to one of the new plans below or ",
                    legacyPackageMessageLink: "contact us",
                    legacyPackageMessageTwo: " with questions.",
                    meteredBillingMessageOne: "If you use a service and reach your plan's monthly limit, Metered Billing allows you to avoid that service being deactivated as well as service interruptions in your business. Instead you'll be billed for any additional using a flat rate for the remainder of the month.",
                    meteredBillingMessageTwo: "Metered Billing only takes effect when you exceed your purchased plan's monthly limits.",
                    onboardingRequiredMessageOne: "When you're adding a new plan for the first time, you'll need to complete an onboarding process for each new plan. This will be a one-time process and will not affect your existing plans.",
                    onboardingRequiredMessageTwo: "Your Onboarding Specialist will be notified and you will receive an email containing instructions you need to follow to complete the onboarding process.",
                    onboardingRequiredMessageThree: "Your new plan won't be activated until all the necessary steps have been completed.",
                    planChangeMessageOne: "<strong>Yes!</strong> You can change your plan at any time.",
                    planChangeMessageTwo: "<li><strong>Upgrading your plan:</strong> Your new plan will start immediately. On your next bill, you'll see your new plan cost along with a prorated charge for the upgraded plan from this month.</li>",
                    planChangeMessageThree: "<li><strong>Downgrading your plan:</strong> Your new, lower-cost plan will kick in at the start of your next billing cycle. You'll see the new plan cost on your following bill.</li>",
                    planChangeMessageFour: "In both cases, we will continue to use your existing interaction handling instructions. Need changes? Just give us a call at +1 (800) 775-7790. We're here to help!",
                    title: "Manage {{type}} Plan",
                    titleInformation: "Key Information about Plans",
                    titleAddingPlan: "Adding a New Plan",
                    titlePlanChanges: "Upgrading or Downgrading Plans",
                    titleRemovePlan: "Removing a Plan",
                    removingPlanMessage: "Your plan will automatically renew until you cancel it. After you remove the plan, you'll still have access to all the paid features until the end of your billing cycle. You can add it back at any time.",
                    addingPlans: {
                        title: "What happens when I add a new plan?",
                        subtitle: "",
                    },
                    changingPlans: {
                        title: "Can I upgrade or downgrade my plan?",
                        subtitle: "",
                    },
                    meteredBilling: {
                        title: "How does Metered Billing work?",
                        subtitle: "",
                    },
                    removingPlans: {
                        title: "How can I remove a plan?",
                        subtitle: "",
                    },
                },
                addCustomPlanActionModal: {
                    buttonLabelScheduleConsultation: "Schedule a Meeting",
                    headerTitle: "Need a larger plan?",
                    largerPlanMessage: "Let us know what you're looking for and we'll build a custom plan that fits your business.",
                },
                addPlanActionModal: {
                    agreeToTerms: "By continuing, you agree to the ",
                    agreeToTermsLink: " PATLive Terms of Use.",
                    areYouSure: "Are you sure you want to continue with the following plan?",
                    confirm: "Confirm",
                    headerTitle: "Confirm Plan Selection",
                    labelNew: "New",
                    labelLiveReceptionist: "Live Receptionist",
                    labelOnboardingRequired: "Plan Requires Onboarding",
                    labelOutboundCalling: "Outbound Calling",
                    labelRetired: "Legacy",
                    labelWebChat: "Web Chat",
                    pricePerMonth: "{{price}}/mo.",
                    onboardingRequiredMessage: "Looks like you're adding a new plan for the first time. Your Onboarding Specialist will be notified and an email with your next steps will be sent to you.",
                    tagActive: "Active",
                    tagOnboarding: "Onboarding Required",
                    tagRetired: "Legacy",
                },
                removePlan: {
                    areYouSure: "Are you sure?",
                    areYouSwitchingServices: "Are you switching to another service?",
                    canYouExplainTheIssue: "Please describe the issue(s) you were having.",
                    canYouProvideSummaryOfCustomerServiceIssue: "Please provide a summary of the customer service issue.",
                    doYouHaveFeedback: "Do you have any feedback you'd like to share with us?",
                    cancel: "Cancel",
                    cancellationComment: "Cancellation Comment",
                    removePlan: "Remove Plan",
                    fraudStatus: "Fraud Status",
                    header: "Remove Plan",
                    howLikelyAreYouToRecommend: "How likely are you to recommend PATLive to a friend?",
                    pleaseMakeSelection: "Please make a selection.",
                    pleaseProvideResponse: "Please provide a response.",
                    pleaseSelect: "Select",
                    pleaseSelectReason: "Please select a reason.",
                    pleaseSpecify: "Please specify",
                    pleaseSpecifyWhichService: "Please specify the service you are switching to.",
                    pleaseSpecifyFeaturesNeeded: "What features did you need?",
                    pleaseSpecifyOtherReasonForCancelling: "Please specify the reason you want to remove this plan.",
                    pleaseSpecifyReasonForCancelling: "Please specify the reason you are cancelling.",
                    reasons: {
                        lacksFeatures: "Lacks feature(s)",
                        tooDifficult: "Too difficult to use",
                        tooExpensive: "Too expensive",
                        billingProblem: "Billing issue",
                        technicalProblem: "Technical issue",
                        poorCustomerService: "Poor customer service",
                        noLongerNeeded: "No longer needed",
                        other: "Other"
                    },
                    noLongerNeededReasons: {
                        temporaryCampaign: "Temporary campaign or use case ended",
                        noLongerInBusiness: "No longer in business",
                        notUsingIt: "Just wasn't using it",
                        other: "Other"
                    },
                    tooExpensiveReasons: {
                        notGoodValue: "Not a good value for the money",
                        taxesAndFeesTooHigh: "Taxes and fees are too high",
                        other: "Other"
                    },
                    title: "Remove {{type}} Plan",
                    whatDidYouHaveTroubleWith: "Please describe the issue(s) you were having.",
                    whatsYourViewOfPricing: "Which best fits your view of PATLive’s pricing?",
                    whyDoYouNoLongerNeedPlan: "Which best describes why you no longer need this plan?",
                    whatWasTheIssue: "What was the issue?",
                    whichService: "Which service?",
                    whyDoYouWantToRemovePlan: "Why do you want to remove this plan?"
                },
                removePlanActionModal: {
                    areYouSure: "Are you sure you want to remove this plan?",
                    callsRoutedToScript: "Calls are being routed to a script from",
                    campaignsRoutedToScript: "Outbound calling campaigns are being routed to a script from",
                    cancel: shared.enUS.cancel,
                    chatsRoutedToScript: "Web chats are being routed to a script from",
                    closeAccountWarning1: "Hey there! Looks like you're ready to remove your last plan. Were you considering closing your account and canceling all services? If so, please click ",
                    closeAccountWarningLink: "here",
                    closeAccountWarning2: " to do so.",
                    closeAccountInstruct: "If you prefer to maintain access to our full range of business phone system features, when you remove this plan we will transition you to our {{name}} plan for {{price}}/mo.",
                    continue: "Continue",
                    header: "Remove Plan",
                    pleaseSelect: shared.enUS.pleaseSelect,
                    proceedWarning: "To proceed, you must designate a user or group to take the place of any scripts in the following scenarios.",
                    proceedInstruct: "Alternatively, you can manually resolve these conflicts and then come back to try removing the plan again.",
                    selectionRequired: "Please make a selection to continue",
                    sendCallsToQuestion: "Select a user or group to replace the scripts in the below scenarios",
                },
                removePlanConfirmationModal: {
                    cancel: shared.enUS.cancel,
                    continue: "Continue",
                    header: "Remove Plan",
                    instructionMessage: "The following plan will be removed from your account immediately and you will no longer have access to any included features.",
                    outboundCallingCampaignAccessTitle: "Outbound Calling Campaign Access",
                    outboundCallingCampaignAccessMessage: "Any outbound calling campaigns on your account will no longer be active.",
                    scriptsAccessTitle: "Scripts Access",
                    scriptsAccessMessage_liveReceptionist: "All scripts associated with the plan will be deactivated and calls can no longer be routed to them.",
                    scriptsAccessMessage_outboundCalling: "All scripts associated with the plan will be deactivated and any outbound calling campaigns on your account will no longer be able to access them.",
                    scriptsAccessMessage_webChat: "All scripts associated with the plan will be deactivated and any web chat widget(s) installed on your website will no longer be able to access scripts.",
                    webChatWidgetAccessTitle: "Web Chat Widget Access",
                    webChatWidgetAccessMessage: "Any web chat widgets installed on your website will no longer be active and any web chat sessions will be ended.",
                },
                packagePicker: {
                    buttonSelect: "Select",
                    buttonSelected: "Selected",
                    largerPlan: "Need a larger plan?",
                    notIncluded: "Prices do not include taxes and fees.",
                    oneTimeSetupFee: "*Cost shown does not include the one-time setup fee of {{cost}}.",
                    labelActive: "Current",
                    labelActiveSignup: "Selected",
                    labelPerMonth: "/mo.",
                    labelPopular: "Most Popular",
                    packageTab: {
                        classic: {
                            label: 'Classic plans',
                            description: 'Ideal for businesses who value simplicity and essential features at an affordable price. Award-winning service, core functionality, and reliable support from our standard support team. Perfect for those seeking a straightforward, cost-effective solution without compromising quality service for their clients.'
                        },
                        signature: {
                            label: 'Signature plans',
                            description: 'Ideal for businesses that want comprehensive support and strategic partnership. Experience premium, concierge-style service with a small, dedicated team of receptionists and an Account Manager delivering personalized, white-glove support and enhanced features, finely tuned to your business.'
                        }
                    },
                    packageFeatures: {
                        additionalMinutes: "Additional minutes {{price}}",
                        additionalPhoneNumbers: "Additional phone numbers {{price}}",
                        additionalUsers: "Additional users {{price}}",
                        additionalChats: "Additional chats {{price}}",
                        additionalContacts: "Additional contacts {{price}}",
                        additionalScripts: "Additional scripts {{price}}",
                        includedMinutes_0: "No minutes included",
                        includedMinutes: "{{count}} minute included",
                        includedMinutes_plural: "{{count}} minutes included",
                        includedMinutes_unlimited: "Unlimited minutes included",
                        includedPhoneNumbers_0: "No phone numbers included",
                        includedPhoneNumbers: "{{count}} phone number included",
                        includedPhoneNumbers_plural: "{{count}} phone numbers included",
                        includedPhoneNumbers_unlimited: "Unlimited phone numbers included",
                        includedUsers_0: "No users included",
                        includedUsers: "{{count}} user included",
                        includedUsers_plural: "{{count}} users included",
                        includedUsers_unlimited: "Unlimited users included",
                        includedChats_0: "No chat sessions included",
                        includedChats: "{{count}} chat session included",
                        includedChats_plural: "{{count}} chat sessions included",
                        includedChats_unlimited: "Unlimited chat sessions included",
                        includedContacts_0: "No outbound contacts included",
                        includedContacts: "{{count}} outbound contact included",
                        includedContacts_plural: "{{count}} outbound contacts included",
                        includedContacts_unlimited: "Unlimited outbound contacts included",
                        includedScripts_0: "No scripts included",
                        includedScripts: "{{count}} script included",
                        includedScripts_plural: "{{count}} scripts included",
                        includedScripts_unlimited: "Unlimited scripts included",
                    },
                    packageGrid: {
                        included: "Included with Plan",
                        includedChats: "Chat Sessions",
                        includedContacts: "Outbound Contacts",
                        includedMinutes: "Minutes",
                        includedNumbers: "Phone Numbers",
                        includedScripts: "Scripts",
                        includedUsers: "Users",
                        extra: "Metered Billing",
                        extraChat: "Extra Chats",
                        extraContact: "Extra Contacts",
                        extraMinute: "Extra Minutes",
                        extraNumber: "Extra Numbers",
                        extraScript: "Extra Scripts",
                        extraUser: "Extra Users",
                        plan: "",
                        price: "Price",
                        pricePerMonth: "{{price}}/mo.",
                        pricePerChat: "{{price}}/session",
                        pricePerContact: "{{price}}/contact",
                        pricePerMinute: "{{price}}/minute",
                        pricePerNumber: "{{price}}/number",
                        pricePerScript: "{{price}}/script",
                        pricePerUser: "{{price}}/user",
                    },
                    pricePerMonthTooltip: "Price shown includes a $10 user fee and a $5 phone number fee.",
                    titleCompare: "Compare Plans & Pricing"
                },
                resetPassword: {
                    changePassword: "Change Password",
                    chooseNewPassword: "Please set a new password",
                    confirmPassword: "Confirm Password",
                    confirmPasswordRequired: "Please re-enter your new password.",
                    confirmPasswordDoesNotMatch: "Passwords do not match.",
                    emailAddress: "Email Address",
                    mobileUnsupportedTitle: "Sorry! You can’t reset your password on a mobile device.",
                    mobileUnsupportedMessage: "Use your desktop or laptop computer.",
                    newPasswordRequired: "Please enter a password.",
                    newPasswordInvalid: "Password must contain 8-32 characters, 1 upper case letter, 1 lower case letter & 1 number.",
                    password: "New Password",
                    passwordResetConfirmation: "Password Successfully Reset!",
                    passwordResetConfirmationMessage: "You may now sign in with your new password.",
                    resetPassword: "Reset Password",
                    signIn: "Sign In"
                },
                signupAside: {
                    trialHeader: "14 days completely free",
                    trialMessage: "Your free trial includes access to everything we offer with no restrictions or limits.",
                    readyHeader: "The trial starts when you're ready",
                    readyMessage: "Go live instantly with message taking, or build a custom call flow with an Onboarding Specialist and go live within 48 hours. Either way, your 14 days don't start until you're ready."
                },
                signupForCustomer: {
                    affiliate: "Affiliate",
                    edit: "Edit",
                    forCustomer: "Signup for Customer",
                    hubspotContact: "HubSpot Contact",
                    patLive: "Legacy Account",
                },
                signupForCustomerModal: {
                    headerText: "Edit Signup for Customer",
                    hubSpotContactRecordIdInvalid: "No HubSpot Contact Record found. Please try again.",
                    hubSpotContactEmailUnique: "HubSpot Contact's email address is already in use by another user.",
                    labelAffiliate: "Affiliate",
                    labelHubSpotContactRecordId: "HubSpot Contact Record ID",
                    labelPatLiveAccountNumber: "Legacy PATLive Account Number",
                    patLiveAccountNumberInvalid: "Please enter a valid PATLive Account Number",
                },
                signupFooter: {
                    agentBypass: shared.enUS.agentBypass,
                    agreeToTerms: "By clicking the above button, I agree to PATLive's Terms of Use.",
                    flowBFooterLocalText: 'Don’t want a local number? &nbsp; Click here to see all options.',
                    flowBFooterTollFreeText: 'Don’t want a toll-free number? &nbsp; Click here to see all options.',
                    flowBFooterPortText: 'Don’t want to port your number? &nbsp; Click here to see all options.',
                    next: "Next",
                    back: "Back",
                },
                signupError: {
                    title: "Something about this signup seemed suspicious and was blocked.",
                    contact_support_message_1: "If you were not using a VPN and believe this was a mistake, please reach out to",
                    contact_support_message_2: "Customer Support",
                    contact_support_message_3: "for assistance.",
                    disable_vpn_message_1: "If you are using a VPN, please disable it and then",
                    disable_vpn_message_2: "click here",
                    disable_vpn_message_3: "to retry."
                },
                signupNotSupported: {
                    buttonLabelBack_plans: "Back to Plan Selection",
                    buttonLabelBack_welcome: "Back to Welcome",
                    buttonLabelContinue: "Schedule a Meeting",
                    notSupportedMessageTitle: "Let's Talk About Your Needs",
                    notSupportedMessageBody_webChat: "Thank you for your interest in our Live Web Chats! These services require a personalized setup to ensure they meet your specific business requirements.",
                    notSupportedMessageBody_outboundCalling: "Thank you for your interest in our Live Outbound Calls! These premium services require a personalized setup to ensure they meet your specific business requirements.",
                    ctaScheduleMeetingTitle: "Why Schedule a Meeting?",
                    ctaScheduleMeetingBody: {
                        useCases: "Discuss your specific use cases and requirements",
                        customSolution: "Get a customized solution tailored to your business",
                        bestPractices: "Learn about integration options and best practices",
                        handsOnSupport: "Receive hands-on support during setup"
                    },
                },
                signupScheduling: {
                    headingText: shared.enUS.schedulingHeadingText,
                    subtitleText: shared.enUS.schedulingSubtitleText,
                    serviceLiveCallAnswering: shared.enUS.serviceLiveCallAnswering,
                    serviceLiveWebChat: shared.enUS.serviceLiveWebChat,
                    serviceOutboundCalls: shared.enUS.serviceOutboundCalls,
                    continueToOnboarding: shared.enUS.schedulingContinueToOnboarding,
                    continueToAccount: shared.enUS.schedulingContinueToAccount,
                },
                signupFreeTrial: {
                    headingText: "Start your 14-day free trial.",
                    subtitleText: "Our live receptionist services are flexible, affordable, and easy to add — and completely free to try for two full weeks.",
                    benefit1: "Create your account instantly.",
                    benefit2: "Configure online or on an onboarding call.",
                    benefit3: "We can start taking your calls immediately.",
                    benefit4: "No limits or restrictions during the free trial.",
                    benefit5: "Personalized support and rollout monitoring.",
                    benefit6: "Upgrade, downgrade, or cancel at any time.",
                    getStarted: "Select your plan",
                },
                signupSuccess: {
                    goToMyAccount: "Go to my account",
                    headingText: "Welcome! We've created your account 🎉",
                    infoMessageLiveReceptionistOnly: "Up next, we'll take you into your account so you can look around, but remember, we can't begin taking your calls until you've:",
                    infoStepLiveReceptionistOnlyOnline: "Configured message taking service online",
                    infoStepLiveReceptionistOnlyCall: "Or, scheduled an onboarding call so we can help you set up a custom call flow.",
                    infoMessageWebChatOnly: "Up next, we'll take you into your account so you can look around, but remember, we can't go live with your chats until you've scheduled an onboarding call so we can help you set up a custom chat flow.",
                    infoMessageOutboundCallingOnly: "Up next, we'll take you into your account so you can look around, but remember, you can't start queuing outreaches until you've scheduled an onboarding call so we can help you set up a custom call flow.",
                    infoMessageMixedServices: "Up next, we'll take you into your account so you can look around, but remember, you can't go live until you've scheduled an onboarding call so we can help you set up your custom handling flows.",
                    infoMessageNoOnboarding: "Up next, we'll take you into your account so you can look around. There's nothing else to set up, so your account is ready to go.",
                },
                signupEmailVerify: {
                    headingText: "Enter your verification code",
                    subtitleText: "We emailed it to {{userEmail}}.",
                },
                signupEmail: {
                    headingText: "Enter your email",
                    subtitleText: "This is for your user. You can add other users in your account.",
                    confirmEmail: "Confirm your email",
                    emailBelongsToAnotherHubspotContact: "This email address belongs to a different HubSpot Contact.",
                    emailAddressRequired: "Please enter your email address.",
                    enterTheVerificationCode: "Enter the code sent to {{sentToEmail}}",
                    hubSpotContactEmailMessage: "If you are signing up with a HubSpot Contact, the current HubSpot Contact email will be updated to match the email used during signup.",
                    hubSpotContactEmailTitle: "Signup for Customer",
                    labelEmail: "Email Address",
                    labelVerificationCode: "Verification Code",
                    loginLink: "Sign In",
                    loginText: "Already have an account?",
                    resendEmail: "Email a new code",
                    resendIn: "Email a new code ({{seconds}}s)",
                    reservationInProgressHeader: "Reserving your number...",
                    reservationFailedHeader: "Reservation Failed",
                    reservationFailedMessage: "There was an issue reserving the phone number you selected.",
                    maxVerificationAttemptsReached: "Too many incorrect codes have been attempted.",
                    modalButtonText: "Select a New Number",
                    verificationCodeRequired: "Please enter a verification code.",
                    incorrectVerificationCode: "Invalid verification code."
                },
                signupModal: {
                    modalButtonText: "Select a New Number",
                    reservationFailedMessage: "There was an issue trying to reserve the number you selected, please try selecting a new number.",
                },
                signupPaymentMethod: {
                    headingText: "Add a payment method",
                    subtitleText: "Your card will not be charged if you cancel during the free trial. To cancel, just tap Close Account in Billing Settings or call us.",
                    ach: "ACH",
                    agreeToTerms: "By continuing, you agree to the PATLive ",
                    agreeToTermsLink: "Terms of Use.",
                    addressLineOne: "Address",
                    addressLineTwo: "Address 2",
                    addressRequired: "Address is required.",
                    agentBypassPreAuthorization: "Bypass pre-authorization checks for this payment method?",
                    agentBypassWelcomeEmail: "Bypass welcome email for this customer?",
                    agreeToTerms_part1: "By clicking the above button, I agree to PATLive's ",
                    agreeToTerms_part2: "Terms of Use.",
                    billingAddress: "Billing Address",
                    billingMethod: "Billing Method",
                    cardHolderName: "Cardholder's Name",
                    cardHolderNameRequired: "Please enter the cardholder's name.",
                    cardNumber: "Credit Card Number",
                    cardNumberInvalid: "Please enter a valid card number.",
                    cardNumberRequired: "Please enter a card number.",
                    city: "City",
                    cityRequired: "City is required.",
                    country: "Country",
                    countryRequired: "Please select a country.",
                    creditCard: "Credit Card",
                    create_account_failed: "We're having trouble authorizing your card. Please try again later, or call +1 (800) 775-7790 for assistance.",
                    credit_card_declined: "Your credit card failed to authorize. Please verify your card information and try again.",
                    cvv: "CVV",
                    cvvInvalid: "Invalid",
                    cvvRequired: "Required",
                    duplicateCard: "This card is already on your account.",
                    expirationDate: "Expiration Date",
                    expirationDateInvalid: "Invalid expiration date.",
                    failed_to_reserve_phone_numbers: "failed_to_reserve_phone_numbers",
                    header: "Almost Done!",
                    invalid_email_address: "This email address is already in use on another PATLive account.",
                    invalid_postal_code: shared.enUS.postalCodeInvalid,
                    invoice: "Invoice",
                    missingAuthorizedSignature: "It looks like you refreshed your browser. For security, we'll need you to re-enter your authorized signature to continue.",
                    missingPassword: "It looks like you refreshed your browser. For security, we'll need you to re-enter your password to continue.",
                    modalAuthorizedSignatureButtonText: "Okay",
                    modalPasswordButtonText: "Okay",
                    no_email_address_provided: "Please enter an email address.",
                    no_mobile_phone_number_provided: "We need a mobile phone number to generate your default device",
                    noSpecialCharacters: "Special characters are not allowed.",
                    optional: "(optional)",
                    payment_gateway_down: "We're having trouble authorizing your card. Please try again later, or call +1 (800) 775-7790 for assistance.",
                    paymentMethod: "Payment Method",
                    postalCode: "Postal Code",
                    province: "Province",
                    provinceRequired: "Province is required.",
                    select: "Select",
                    start: "Create Account",
                    state: "State",
                    stateRequired: "State is required.",
                    timeZone: "Time Zone",
                    trialEnd: "Your free trial will end on {{freeTrialEndDate}}.",
                    zipCode: "Zip Code",
                },
                signupPlans: {
                    headingTextMultiSelect: "Select your services",
                    subtitleTextMultiSelect: "You can add just one, two, or all three.",
                    headingTextMultiSelectSelected: "Would you like to add anything else?",
                    subtitleTextMultiSelectSelected: "You can modify or cancel your services at any time.",
                    headingTextTelephony: "Confirm your plan",
                    hostedNumbersTitle: "Hosted Numbers is now part of PATLive",
                    hostedNumbersMessage: "To celebrate, we’re offering all new customers a 14 day free trial as a welcome 🎉",
                    subtitleTextTelephony: "A full suite of premium features is included.",
                    headingTextPackagePicker_liveReceptionist: "Choose your call answering plan",
                    headingTextPackagePicker_webChat: "Choose your web chats plan",
                    headingTextPackagePicker_outboundCalling: "Choose your outbound calls plan",
                    subtitleTextPackagePicker_liveReceptionist: "You can change or cancel your plan at any time.",
                    subtitleTextPackagePicker_webChat: "You can change or cancel your plan at any time.",
                    subtitleTextPackagePicker_outboundCalling: "You can change or cancel your plan at any time.",
                    buttonChange: "Change Service",
                    buttonSelect: "Add Service",
                    contactUs: "Contact us.",
                    includedChats_0: "Pay as you go",
                    includedChats: "{{count}} chat",
                    includedChats_plural: "{{count}} chats",
                    includedChats_unlimited: "Unlimited chats",
                    includedMinutes_0: "Pay as you go",
                    includedMinutes: "{{count}} minute",
                    includedMinutes_plural: "{{count}} minutes",
                    includedMinutes_unlimited: "Unlimited minutes",
                    includedOutboundContacts_0: "Pay as you go",
                    includedOutboundContacts: "{{count}} outreach",
                    includedOutboundContacts_plural: "{{count}} outreaches",
                    includedOutboundContacts_unlimited: "Unlimited outreaches",
                    labelLiveReceptionist: shared.enUS.serviceLiveCallAnswering,
                    labelNone: "No plan selected",
                    labelOutboundCalling: shared.enUS.serviceOutboundCalls,
                    labelTelephony: "PATLive Flex",
                    labelWebChat: shared.enUS.serviceLiveWebChat,
                    telephonyServiceTitle: "Business Phone System",
                    liveReceptionistServiceDescription: "Select to ensure <strong>every call is answered live</strong> by highly trained professionals. From message taking and appointment scheduling to detailed lead capture and thoughtful inquiry handling, we step in seamlessly when you need us most.",
                    liveReceptionistServiceTitle: "Live Call Answering",
                    forDetails: "For more details, please visit our &nbsp;",
                    headerTitle: "These are your current plans.",
                    headerMessage: "You can adjust your account plans before signup or later through your billing settings.",
                    noPlanSelected: "No plan selected",
                    outboundCallingServiceDescription: "Select to cover appointment reminders, immediate lead follow-ups and client check-ins. We handle your <strong>outreach needs</strong> when timing matters and consistent follow-through makes all the difference.",
                    outboundCallingServiceTitle: "Live Outbound Calls",
                    pricingContact: "Not seeing what you're looking for? Call us at&nbsp;",
                    packagePickerTitle: "{{type}} Plans",
                    packagePickerMessage_liveReceptionist: "Make the most of every call you receive with the industry’s best 24/7 phone answering service.",
                    packagePickerMessage_webChat: "Capture more leads, book more appointments and provide better support with 24/7 live web chat service.",
                    packagePickerMessage_outboundCalling: "Take control of your client communication with our outbound calls service.",
                    pricePerMonth: "{{price}}/mo.",
                    pricingPage: "pricing page",
                    remove: "Remove Service",
                    scheduleConsultationTitle: "Schedule a Consultation",
                    scheduleConsultationMessage_webChat: "To proceed with signup for our Live Web Chats, please schedule a consultation with a team member. They will guide you through the account setup process and provide detailed insights about PATLive's Live Web Chats.",
                    scheduleConsultationMessage_outboundCalling: "To proceed with signup for our Live Outbound Calls, please schedule a consultation with a team member. They will guide you through the account setup process and provide detailed insights about PATLive's Live Outbound Calls.",
                    selectAtLeastOnePlan: "Please select at least one plan to continue.",
                    webChatServiceDescription: "Select to extend the same professional, <strong>live support to your website</strong>—engaging visitors, answering questions, and closing the gap on missed online opportunities.",
                    webChatServiceTitle: "Live Web Chats",
                    buttonLabelContinue: "Next",
                    buttonLabelScheduleConsultation: "Schedule a Meeting",
                    notSupportedTitle_webChat: "Live Web Chats",
                    notSupportedTitle_outboundCalling: "Live Outbound Calls",
                    notSupportedTitle_largerPlan: "Need a larger plan?",
                    notSupportedMessage_webChat: "Live Web Chats requires customized white glove setup by one of our Product Specialists.",
                    notSupportedMessage_outboundCalling: "Live Outbound Calls requires customized white glove setup by one of our Product Specialists.",
                    notSupportedMessage_largerPlan: "Let us know what you're looking for and we'll build a custom plan that fits your business.",
                },
                signupPackagePicker: {
                    labelActive: "Selected",
                    labelPerMonth: "/mo.",
                    labelPopular: "Most Popular",
                    largerPlan: "Need a larger plan?",
                    notIncluded: "Prices do not include taxes and fees.",
                    oneTimeSetupFee: "*Cost shown does not include the one-time setup fee of {{cost}}.",
                    packagePickerTitle_liveReceptionist: "Live Call Answering Plans",
                    packagePickerTitle_webChat: "Live Web Chats Plans",
                    packagePickerTitle_outboundCalling: "Live Outbound Calls Plans",
                    packageTab: {
                        classic: {
                            label: 'PATLive Classic Service',
                            description: 'Award-winning PATLive service recommended for its comprehensive premium feature set, excellent customer support, and value pricing.'
                        },
                        signature: {
                            label: 'Signature Service',
                            description: 'A concierge-style service finely tuned to your needs. Signature pairs your business with a <strong>small dedicated team of elite receptionists</strong> who learn the nuances of your business, allowing them to handle calls with increasing precision and personal connection..'
                        }
                    },
                    packageFeatures: {
                        additionalMinutes: "Additional minutes {{price}}",
                        additionalPhoneNumbers: "Additional phone numbers {{price}}",
                        additionalUsers: "Additional users {{price}}",
                        additionalChats: "Additional chats {{price}}",
                        additionalContacts: "Additional contacts {{price}}",
                        additionalScripts: "Additional scripts {{price}}",
                        includedMinutes_0: "No minutes included",
                        includedMinutes: "{{count}} minute included",
                        includedMinutes_plural: "{{count}} minutes included",
                        includedMinutes_unlimited: "Unlimited minutes included",
                        includedPhoneNumbers_0: "No phone numbers included",
                        includedPhoneNumbers: "{{count}} phone number included",
                        includedPhoneNumbers_plural: "{{count}} phone numbers included",
                        includedPhoneNumbers_unlimited: "Unlimited phone numbers included",
                        includedUsers_0: "No users included",
                        includedUsers: "{{count}} user included",
                        includedUsers_plural: "{{count}} users included",
                        includedUsers_unlimited: "Unlimited users included",
                        includedChats_0: "No chat sessions included",
                        includedChats: "{{count}} chat session included",
                        includedChats_plural: "{{count}} chat sessions included",
                        includedChats_unlimited: "Unlimited chat sessions included",
                        includedContacts_0: "No outbound contacts included",
                        includedContacts: "{{count}} outbound contact included",
                        includedContacts_plural: "{{count}} outbound contacts included",
                        includedContacts_unlimited: "Unlimited outbound contacts included",
                        includedScripts_0: "No scripts included",
                        includedScripts: "{{count}} script included",
                        includedScripts_plural: "{{count}} scripts included",
                        includedScripts_unlimited: "Unlimited scripts included",
                        pricePerMonth: "{{price}}/mo.",
                        pricePerChat: "{{price}}/session",
                        pricePerContact: "{{price}}/contact",
                        pricePerMinute: "{{price}}/minute",
                        pricePerNumber: "{{price}}/number",
                        pricePerScript: "{{price}}/script",
                        pricePerUser: "{{price}}/user"
                    },
                },
                signupPricingTable: {
                    colPlan: "Plan",
                    colMonthly: "Monthly",
                    colAdditional: "Additional",
                    colAdditional_liveReceptionist: "Additional min",
                    colAdditional_webChat: "Additional chat",
                    colAdditional_outboundCalling: "Additional outreach",
                    labelPayAsYouGo: "Pay as you go",
                    labelPopular: "Most popular",
                    labelSelect: "Select",
                    labelSelected: "Selected",
                    moreLabel: "Show larger plans",
                    lessLabel: "Hide larger plans",
                    oneTimeSetupFee: "*Cost shown does not include the one-time setup fee of {{cost}}.",
                },
                signupProfile: {
                    headingText: "Create your user",
                    subtitleText: "Your user registration details are not shared with callers.",
                    firstName: "First Name",
                    firstNameRequired: "Please enter your first name.",
                    howDidYouHearAboutUs: "How did you hear about us?",
                    lastName: "Last Name",
                    lastNameRequired: "Please enter your last name.",
                    mobileNumber: "Mobile Number",
                    optional: "(optional)",
                    ownPortedNumber: "You cannot use the same number that you're porting in to PATLive.",
                    ownPurchasedNumber: "You entered the number you're buying. Please enter your mobile number.",
                    phoneNumberInvalid: "Please enter a valid phone number.",
                    phoneNumberRequired: "Please enter your mobile phone number.",
                    restrictedPhoneNumber: shared.enUS.restrictedPhoneNumber,
                    select: "Select"
                },
                signupHeader: {
                    stepMessage: "Step {{step}} of {{totalSteps}}",
                },
                signupSecurity: {
                    headingText: "Set your password",
                    subtitleText: "Password must contain 8-32 characters, at least 1 uppercase letter, 1 lowercase letter, and 1 number.",
                    city_mother_and_father_met: "In what city or town did your mother and father meet?",
                    confirmPassword: "Confirm Password",
                    confirmPasswordInvalid: "Passwords do not match.",
                    confirmPasswordRequired: "Please confirm your password.",
                    first_pet: "What was the name of your first pet?",
                    high_school_mascot: "What was your high school mascot?",
                    nickname: "What was your childhood nickname?",
                    password: "Password",
                    passwordInvalid: "Invalid password.",
                    passwordRequired: "Please enter a password.",
                    sixth_grade_school: "What school did you attend for sixth grade?",
                    verificationAnswer: "Verification Answer",
                    verificationAnswerRequired: "Please enter your verification answer.",
                    verificationQuestion: "Verification Question",
                },
                signupPhoneNumberPort: {
                    headingText: "Enter your number",
                    subtitleText: "Tell us the number you'd like to bring to PATLive.",
                    addMoreMessage: "To port in more than three phone numbers, please call +1 (800) 775-7790.",
                    carrierRequired: "Please enter your current carrier.",
                    flowBText: 'Don’t want to port your number? <br />  Click here to see all options.',
                    googleWarning: "Before porting in your Google Voice number, you'll need to unlock it. There is a fee that comes with unlocking your number.",
                    googleWarning1: "1. On your computer, go to the ",
                    googleWarning1Link: "Google Voice unlock page",
                    googleWarning2: "2. Point to the Google Voice number you want to transfer, and click Unlock my number.",
                    googleWarning3: "3. Click Continue.",
                    googleWarning4: "4. Pay with your Google Account. You’ll get your receipt by email.",
                    labelCarrier: "Carrier and Phone Number To Port",
                    labelCurrentCarrier: "Current Carrier",
                    labelNumberToPort: "Phone Number to Port",
                    linkAdd: "+ Add Another Number",
                    modalGotIt: "Ok, Got It",
                    modalHeader: "PATLive is Not a Cell Phone Carrier...",
                    modalMessage: "You cannot port your cell phone number to PATLive and continue to use it on your cell phone for calling, texting, and data services. In order to continue using calling, texting, and data services on your current cell phone, you will need to add another phone number with your current carrier before porting the original number to PATLive.",
                    optionOnlyNumber: "This is the only number on this account.",
                    optionOnlyNumber_plural: "These are the only numbers on this account.",
                    optionOtherNumbers: "I have other numbers on this account and do not want to port them.",
                    tabTitleAuthorization: "Authorization",
                    tabTitleBilling: "Billing",
                    tabTitlePort: "Numbers to Port",
                    tabTitleNumbers: "Numbers"
                },
                numberToPort: {
                    duplicatePhoneNumber: "This number is already being ported into PATLive.",
                    phoneNumberInvalid: "Please enter a valid phone number.",
                    phoneNumberNotPortable: "This number cannot be ported into PATLive.",
                    phoneNumberOnAnotherAccount: "This number is already associated with a PATLive account.",
                    phoneNumberRequired: "Please enter a phone number.",
                    restrictedPhoneNumber: shared.enUS.restrictedPhoneNumber,
                    tooltipLine1: "To port numbers from multiple ",
                    tooltipLine2: "carriers or accounts, call",
                    tooltipLine3: "+1 (800) 775-7790 for assistance."
                },
                onboardingFooter: {
                    done: "Done",
                    nextStep: "Next",
                    previousStep: "Back",
                },
                onboardingHeader: {
                    helpMessage: "Need help? Call&nbsp;",
                },
                onboardingShell: {
                    finishLater: "I'll finish this later",
                },
                onboardingScheduling: {
                    continueToAccount: shared.enUS.schedulingContinueToAccount,
                    continueToOnboarding: shared.enUS.schedulingContinueToOnboarding,
                },
                onboardingWelcome: {
                    agentBypass: shared.enUS.agentBypass,
                    onboardingOptionCallDescription: "Begin taking calls in 24-48 hours — you'll schedule a call with an Onboarding Specialist who will meet with you to get an in-depth understanding of your business and your goals. We'll create a custom call flow that takes full advantage of all our capabilities, so our receptionists can answer as a seamless member of your team.",
                    onboardingOptionCallTitle: "Custom Call Flow",
                    onboardingOptionOnlineDescription: "Begin taking calls immediately — you'll go through an online wizard to provide a simple overview of your business, your office hours, and common things callers ask about. We can begin answering calls as soon as you're done, but we can only provide basic information about your business and take messages.",
                    onboardingOptionOnlineTitle: "Message Taking Service",
                    scheduleOnboarding: shared.enUS.scheduleOnboarding,
                    headerTitle: "How do you want us to answer your calls?",
                    startOnboarding: "Continue Setup",
                },
                onboardingIdentity: {
                    accountBusinessName: "What's your business name?",
                    addPhoneNumber: "+ Add Phone Number",
                    agentTone: "What business tone should we use with callers?",
                    agentToneTooltip: "This helps receptionists tailor interactions according to your preferred tone",
                    businessName: "What business name should we use in your greetings?",
                    businessNameMessage: "This name will be used by our receptionists when answering your calls. For example: 'Thank you for calling {{name}}, how may I help you?'",
                    businessNameRequired: "A business name is required.",
                    businessNamePlaceholder: "[Business Name]",
                    businessDescription: "How would you describe what you do?",
                    businessDescriptionHelper: "Think of it as your elevator pitch - we'll deliver it.",
                    businessDescriptionPlaceholder: "In 1–2 sentences, tell us what you do...",
                    businessDescriptionRequired: "A business description is required.",
                    businessDescriptionTooltip: "A short description to help receptionists understand your business",
                    casualTone: {
                        title: "Casual",
                        description: "Example: 'Sorry, Lisa is in a meeting right now. Can I have her call you back when she's free?'"
                    },
                    companySize: "How big is your team?",
                    disabledAddPhoneNumber: "Cannot add more than 10 phone numbers",
                    formTitle: "'Thank you for calling {{name}}. How can I help you today?'",
                    forwardFromNumbers: "Enter the phone number(s) you'll be forwarding from.",
                    forwardFromNumbersTooltip: "To help receptionists verify call origin",
                    forwardMyOwnNumber: "My phone number",
                    headingText: "Let's start with hello",
                    subtitleText: "This section helps us understand who you are, what you do, and how you want us to answer.",
                    industries: {
                        accounting: shared.enUS.industries.accounting,
                        architecture: shared.enUS.industries.architecture,
                        arts: shared.enUS.industries.arts,
                        automotive: shared.enUS.industries.automotive,
                        beauty: shared.enUS.industries.beauty,
                        camping: shared.enUS.industries.camping,
                        chiropractors: shared.enUS.industries.chiropractors,
                        cleaning: shared.enUS.industries.cleaning,
                        construction: shared.enUS.industries.construction,
                        consulting: shared.enUS.industries.consulting,
                        dental: shared.enUS.industries.dental,
                        education: shared.enUS.industries.education,
                        electrical: shared.enUS.industries.electrical,
                        financial: shared.enUS.industries.financial,
                        flooring: shared.enUS.industries.flooring,
                        funeralHome: shared.enUS.industries.funeralHome,
                        generalContracting: shared.enUS.industries.generalContracting,
                        health: shared.enUS.industries.health,
                        home: shared.enUS.industries.home,
                        hospitality: shared.enUS.industries.hospitality,
                        humanResources: shared.enUS.industries.humanResources,
                        hvac: shared.enUS.industries.hvac,
                        insurance: shared.enUS.industries.insurance,
                        internet: shared.enUS.industries.internet,
                        landscaping: shared.enUS.industries.landscaping,
                        legal: shared.enUS.industries.legal,
                        manufacturing: shared.enUS.industries.manufacturing,
                        marketing: shared.enUS.industries.marketing,
                        media: shared.enUS.industries.media,
                        medical: shared.enUS.industries.medical,
                        non: shared.enUS.industries.non,
                        other: shared.enUS.industries.other,
                        personalCare: shared.enUS.industries.personalCare,
                        plumbing: shared.enUS.industries.plumbing,
                        real: shared.enUS.industries.real,
                        religion: shared.enUS.industries.religion,
                        restaurant: shared.enUS.industries.restaurant,
                        retail: shared.enUS.industries.retail,
                        roofing: shared.enUS.industries.roofing,
                        sports: shared.enUS.industries.sports,
                        telecommunications: shared.enUS.industries.telecommunications,
                        transportation: shared.enUS.industries.transportation,
                        travel: shared.enUS.industries.travel,
                    },
                    industry: "What industry is your business in?",
                    industryTooltip: "This helps us speak your language and handle calls the way your clients expect",
                    optional: "(optional)",
                    phoneNumberRequired: "At least one phone number is required.",
                    pleaseMakeSelection: "Please make a selection.",
                    professionalTone: {
                        title: "Formal",
                        description: "Example: 'I am sorry, Ms. Smith is currently in a meeting. May I take a message, or would you prefer her voice mail?'"
                    },
                    sectionBusinessDescription: "Business Description",
                    toggleMayForwardFromNumbers: "What number will your callers be dialing?",
                    usePATLiveNumber: "My PATLive number",
                    select: "Select"
                },
                onboardingAvailability: {
                    businessHoursMessage: "These hours tell our receptionists when your business is open. We'll adapt our greeting and messaging based on whether it's during or after your business hours.",
                    callerFollowUp: "How soon do you typically follow up with callers?",
                    close: "To",
                    closed: "Closed",
                    day: "Day",
                    fixedScheduleTitle: "Regular Hours",
                    fixedScheduleDescription: "We operate on a consistent weekly schedule",
                    friday: "Friday",
                    headingText: "Now let's set your availability",
                    subtitleText: "This helps us answer questions about your hours and callbacks",
                    flexibleHoursInfoMessage: "No problem! Our receptionists will let callers know that your hours vary. You can provide specific availability instructions later.",
                    flexibleScheduleTitle: "Flexible Hours",
                    flexibleScheduleDescription: "Our hours vary or change frequently",
                    monday: "Monday",
                    open: "From",
                    operatingHoursRequired: "Please enter an open or close time.",
                    other: "Other",
                    pleaseMakeSelection: "Please make a selection.",
                    pleaseProvideResponse: "Please provide a response.",
                    pleaseSpecify: "Please specify",
                    sameDay: "Same Day",
                    saturday: "Saturday",
                    scheduleType: "Schedule Type",
                    scheduleTypeLabel: "How would you describe your schedule?",
                    select: "Select",
                    showOperatingHours: "Do you have business hours you'd like us to share?",
                    flexibleOperatingHoursTooltip: "If you don't provide operating hours, our receptionists will let callers know that your hours vary",
                    regularOperatingHoursTooltip: "You can further customize availability details after this setup",
                    status: "Status",
                    sunday: "Sunday",
                    thursday: "Thursday",
                    timeZone: "What time zone is your business located in?",
                    timeZoneTooltip: "We'll use this to make sure greetings, hours, and response times are always on cue",
                    timeZoneRequired: "Time zone is required.",
                    tuesday: "Tuesday",
                    wednesday: "Wednesday",
                    withinTwoDays: "24-48 hours",
                },
                onboardingInformation: {
                    addressLineOne: "Address",
                    addressLineTwo: "Address 2",
                    addressRequired: "Address is required.",
                    addTeamMember: "+ Add Team Member",
                    businessTeamMessage: "Add key team members callers might ask for",
                    city: "City",
                    cityRequired: "City is required.",
                    country: "Country",
                    countryRequired: "Please select a country.",
                    disabledAddTeamMember: "Cannot add more than 10 team members during setup",
                    emailAddress: "Which email should we give out?",
                    emailAddressRequired: "An email address is required.",
                    faxNumber: "What's your fax number?",
                    faxNumberInvalid: "Invalid fax number.",
                    faxNumberRequired: "A fax number is required.",
                    headingText: "Next let's address some FAQs",
                    subtitleText: "Callers tend to ask about these things. If you want us to share them, just toggle them on and fill in the details.",
                    locationMessage: "This helps us provide accurate information to callers who ask about your location",
                    name: "Name",
                    optional: "(optional)",
                    number: "Phone Number",
                    phoneNumber: "What's the best number to share?",
                    phoneNumberDuplicate: "This number has already been added.",
                    phoneNumberInvalid: shared.enUS.phoneNumberInvalid,
                    phoneNumberRequired: "A phone number is required.",
                    postalCode: "Postal Code",
                    postalCodeInvalid: "Invalid postal code.",
                    postalCodeRequired: "Postal code is required.",
                    province: "Province",
                    provinceRequired: "Province is required.",
                    sectionBusinessTeam: "Team Members",
                    select: "Select",
                    state: "State",
                    stateRequired: "State is required.",
                    teamMemberRequired: "At least one team member name is required.",
                    title: "Title",
                    toggleBusinessLocation: "Office address",
                    toggleEmailAddress: "Email address",
                    toggleFaxNumber: "Fax number",
                    togglePhoneNumber: "Main number",
                    toggleTeamMembers: "Team members",
                    toggleWebsiteUrl: "Website url",
                    useBillingAddress: "Use my billing address",
                    websiteUrl: "What's your URL?",
                    websiteUrlInvalid: "Invalid website url.",
                    websiteUrlRequired: "A website url is required.",
                    zipCode: "Zip Code",
                    zipCodeInvalid: "Invalid zip code.",
                    zipCodeRequired: "Zip code is required."
                },
                onboardingDelivery: {
                    toggleSmsNotifications: "Would you like to receive SMS notifications, too?",
                    wantsOnboardingSpecialist: "I'd like an Onboarding Specialist to review my setup with me",
                    onboardingCallBooked: "An Onboarding Specialist will review this setup with you during the onboarding call you've already scheduled.",
                    addEmailAddress: "+ Add Email Address",
                    addPhoneNumber: "+ Add Phone Number",
                    disabledAddEmailAddress: "Cannot add more than 10 email addresses",
                    disabledAddPhoneNumber: "Cannot add more than 10 phone numbers",
                    emailAddressDuplicate:  "This email address has already been added.",
                    emailAddressInvalid: shared.enUS.emailAddressInvalid,
                    emailAddressRequired: "At least one email address is required.",
                    headingText: "And last let's set up notifications",
                    subtitleText: "This is where we'll send your messages after each call. You can also access your messages in our web and mobile apps.",
                    email: "What email addresses should we send your messages to?",
                    emailTooltip: "Used for message delivery only. Changes or additions here will not affect your account email.",
                    number: "What phone numbers should we text your messages to? <br>",
                    numberTooltip: "Used for message delivery only. Changes or additions here will not affect your account phone number.",
                    phoneNumberDuplicate: "This number has already been added.",
                    phoneNumberInvalid: shared.enUS.phoneNumberInvalid,
                    phoneNumberRequired: "At least one phone number is required.",
                    sectionMessageRecipients: "Message Recipients",
                },
                onboardingInProgress: {
                    headerTitle: "Setting up your service",
                    headerMessage: "We'll take you to your workspace in a few seconds",
                    stepScript: "Creating your custom script",
                    stepCallflow: "Configuring your call flow",
                    stepTrial: "Activating your phone number",
                },
                routeTo: {
                    addOrSelectPrompt: "A greeting is required.",
                    afterPlayingAudioFile: "After playing this audio file, do the following",
                    answerTimeoutLabel: "If the call is not answered after&nbsp",
                    atThisPoint: "At this point in the call flow",
                    createNew: "create a new one",
                    hangUp: "Hang up",
                    internalUse: "For internal use only. System will not reveal this label to callers.",
                    labelSubMenu: "Menu Label",
                    noTimeout: "no timeout",
                    playAudioFile: 'Play an&nbsp;<strong>audio file</strong>',
                    pleaseSelect: shared.enUS.pleaseSelect,
                    ringingWillPlay: 'Ringing will play until user answers or caller hangs up',
                    rolloverTo: 'Rollover to',
                    rolloverToUserVoicemail: 'Rollover to user\'s voicemail box',
                    rolloverToUserGroupVoicemail: 'Rollover to user group\'s voicemail box',
                    rolloverToVoicemailBox: 'Rollover to {{ownerName, makePossessive}} voicemail box',
                    routeToAnotherDestination: 'Continue with another action',
                    seconds: 'seconds',
                    sendToAutoAttendant: 'Send the call to an&nbsp;<strong>auto attendant</strong>',
                    sendToForwardingNumber: 'Send the call to a&nbsp;<strong>forwarding number</strong>',
                    sendToSubMenu: 'Send the call to a&nbsp;<strong>submenu</strong>',
                    sendToUser: 'Send the call to a&nbsp;<strong>user</strong>',
                    sendToGroup: 'Send the call to a&nbsp;<strong>group</strong>',
                    sendToVoicemailBox: 'Send the call to a&nbsp;<strong>voicemail box</strong>',
                    sendToLiveReceptionistScript: 'Send the call to a&nbsp;<strong>live receptionist</strong>',
                    sendToCallQueue: 'Send the call to a&nbsp;<strong>call queue</strong>',
                    useSchedule: 'Use a&nbsp;<strong>schedule</strong>&nbsp;to determine where the call should go',
                    voicemailBox: 'voicemail box',
                    whenOptionSelected: "When this menu option is selected",
                    whenReceivingCall: "When this phone number receives a call"
                },
                routeToModal: {
                    answerTimeoutLabel: "If no answer after",
                    cancel: shared.enUS.cancel,
                },
                routeToAutoAttendant: {
                    createAutoAttendant: 'create an auto attendant.',
                    noAutoAttendantsWarningMessage: 'You haven\'t created an auto attendant yet. Select a different option or&nbsp;',
                    none: shared.enUS.none,
                    selectAutoAttendant: "Select which auto attendant or&nbsp;",
                },
                routeToForwardingNumber: {
                    createForwardingNumber: 'create a forwarding number.',
                    noForwardingNumbersWarningMessage: 'You haven\'t created a forwarding number yet. Select a different option or&nbsp;',
                    none: shared.enUS.none,
                    pressOneToAccept: shared.enUS.pressOneToAccept,
                    pressOneToAcceptWarningMessage: shared.enUS.pressOneToAcceptWarningMessage,
                    selectForwardingNumber: "Select which forwarding number or&nbsp;",
                },
                routeToCallQueue: {
                    selectCallQueue: "Select a call queue",
                },
                routeToLiveReceptionistScript: {
                    createLiveReceptionistScript: 'create a live receptionist script.',
                    noLiveReceptionistScriptWarningMessage: 'You haven\'t created a live receptionist script for live receptionist calls yet. Select a different option or&nbsp;',
                    none: shared.enUS.none,
                    selectLiveReceptionistScript: "Select a live receptionist script or&nbsp;",
                },
                routeToPrompt: {
                    createAudioFile: 'create an audio file.',
                    noAudioFilesWarningMessage: 'You haven\'t created an audio file yet. Select a different option or&nbsp;',
                    none: shared.enUS.none,
                    selectPrompt: "Select an audio file or&nbsp;",
                },
                routeToSchedule: {
                    createSchedule: 'create a schedule.',
                    noSchedulesWarningMessage: 'You haven\'t created a schedule yet. Select a different option or&nbsp;',
                    none: shared.enUS.none,
                    selectSchedule: "Select which schedule or&nbsp;",
                },
                routeToSubmenu: {
                    selectPrompt: "Play these menu instructions or&nbsp;",
                    createNew: "create a new audio file",
                },
                routeToUser: {
                    pressOneToAccept: shared.enUS.pressOneToAccept,
                    pressOneToAcceptWarningMessage: shared.enUS.pressOneToAcceptWarningMessage,
                    selectUser: "Select which user or&nbsp;",
                },
                routeToUserGroup: {
                    pressOneToAccept: shared.enUS.pressOneToAccept,
                    pressOneToAcceptWarningMessage: shared.enUS.pressOneToAcceptWarningMessage,
                    selectUserGroup: "Select which group or&nbsp;",
                },
                routeToVoicemailBox: {
                    selectVoicemailBox: "Select which voicemail box or&nbsp;",
                },
                signupPhoneNumberPortBilling: {
                    headingText: "Your carrier details",
                    subtitleText: "We need these to request the transfer from your current provider.",
                    billingAddressRequired: "Please enter an address.",
                    billingCityRequired: "Please enter a city.",
                    billingNameRequired: "Please enter a name.",
                    billingNumberLength: shared.enUS.phoneNumberInvalid,
                    billingNumberRequired: shared.enUS.phoneNumberRequired,
                    labelAccountNumber: "Account Number",
                    labelAddress: "Address",
                    labelApt: "Apt/Suite",
                    labelCountry: "Country",
                    labelCity: "City",
                    labelName: "Name",
                    labelPhoneNumber: "Phone Number",
                    labelPinOrPasscode: "Pin/Passcode",
                    labelPostalCode: "Postal Code",
                    labelProvince: "Province",
                    labelState: "State",
                    labelZipCode: "Zip Code",
                    modalGotIt: "Ok, Got It",
                    modalHeader: "Important Information Below",
                    modalHelpStatement: "If you're unsure of how your information is listed with your current carrier, please consult your most recent bill.",
                    modalMatchStatement1: "The billing information you're about to enter",
                    modalMatchStatement2: " on file with your current carrier, exactly as listed on your bill.",
                    modalMatchStatementUnderlined: " must match the billing information",
                    placeholderLoading: "Loading...",
                    postalCodeInvalid: shared.enUS.postalCodeInvalid,
                    postalCodeRequired: shared.enUS.postalCodeRequired,
                    tabTitleAuthorization: "Authorization",
                    tabTitleBilling: "Billing",
                    tabTitleNumbers: "Numbers",
                    tabTitlePort: "Numbers to Port",
                    tooltipAccountNumberLine1: "The account number listed on the",
                    tooltipAccountNumberLine2: "invoice from your current carrier.",
                    tooltipPinOrPasscodeLine1: "If a PIN or passcode is required to",
                    tooltipPinOrPasscodeLine2: "access your account, we’ll need it",
                    tooltipPinOrPasscodeLine3: "to port your number away from your current carrier.",
                    zipCodeInvalid: shared.enUS.zipCodeInvalid,
                    zipCodeRequired: shared.enUS.zipCodeRequired
                },
                signupPhoneNumberPortAuthorization: {
                    headingText: "Authorize the transfer",
                    subtitleText: "Your signature lets us request the number on your behalf.",
                    acknowledgementStatement: "By signing below, I attest under penalty of law that I am (a) the legal owner of the phone number(s) included in this port request; or (b) am an authorized employee or representative of the entity requesting the port.  I am, or the entity identified above, is the exclusive end-user subscriber of the phone number(s) included in this port request and I/we assume all liability for the use of the phone number(s).  I acknowledge and understand that I must notify my existing carrier of my intention to change my service provider to PATLive and bear all responsibility for costs that continue to accrue with my former carrier/service provider.",
                    acknowledgementRequired: "You must acknowledge that you understand to continue.",
                    authorizedSignature: "Authorized signature is required.",
                    desiredPortDateStatement: "I understand that my Desired Port Date is not a guaranteed port-on date and may complete before or after this date due to circumstances outside of PATLive's control. If your port date changes, PATLive will reach out ASAP to let you know.",
                    labelAuthorizedSignature: "Signature",
                    labelDesiredPortDate: "Desired Port Date",
                    portDateRequired: "Please specify your desired port date.",
                    portDateAcknowledgment: "Required",
                    tabTitleAuthorization: "Authorization",
                    tabTitleBilling: "Billing",
                    tabTitleNumbers: "Numbers",
                    tabTitlePort: "Numbers to Port"
                },
                signupPhoneNumberType: {
                    headingText: "Select your number type",
                    subtitleText: "This is the phone number your customers will call.",
                    asideHeader: "Pick a Number",
                    asideMainText: "Choose whether you'd like a local or toll-free business number, or port in your current number.",
                    forwardTitle: "Use my own number",
                    forwardMessage: "I already have a business number and would like to forward my calls to PATLive when needed.",
                    localTitle: "Local Number",
                    localMessage: "Choose a number with a specific area code to establish a local presence in your target market",
                    newTitle: "Get a new number",
                    newMessage: "I need a business phone number I can advertise and provide to my customers.",
                    noPortsWhenSignupForCustomer: "Agents can not choose to port numbers for customers",
                    tollFreeTitle: "Toll-Free Number",
                    tollFreeMessage: "Get a professional number that customers can call for free from anywhere",
                    port: "Transfer a Number",
                    selectionRequired: "Please select an option.",
                },
                signupPhoneNumberLocal: {
                    headingText: "Pick your local number",
                    subtitleText: "Choose from the numbers available in your area code.",
                    default: shared.enUS.default,
                    flowBText: 'Don’t want a local number? <br /> Click here to see all options.',
                    gotIt: "Ok, Got it",
                    modalButtonText: "Ok, Got it",
                    selectANumber: "Please select a number to continue.",
                },
                signupPhoneNumberTollfree: {
                    headingText: "Pick your toll-free number",
                    subtitleText: "Choose from our available toll-free numbers.",
                    default: shared.enUS.default,
                    flowBText: 'Don’t want a toll-free number? <br />  Click here to see all options.',
                    selectANumber: "Please select a number to continue.",
                },
                sidebarNavigation: {
                    accountProfile: "Profile",
                    autoAttendant: "Auto Attendants",
                    billCycleToDate: "Bill Cycle to Date",
                    billing: "Billing Settings",
                    billingHistory: "History",
                    blocking: "Blocking",
                    callerId: "Caller ID",
                    callQueues: "Call Queues",
                    contactPermissions: 'Contacts',
                    extensions: "Extensions",
                    forwardingNumbers: "Forwarding Numbers",
                    humanDetection: "Human Detection",
                    integrations: "Integrations",
                    liveReceptionistScripts: "Live Receptionist Scripts",
                    packageMinutes: "Package Minutes",
                    paymentMethods: "Payment Methods",
                    makeAPayment: "Make a Payment",
                    messagingCompliance: "Messaging Compliance",
                    outboundCallingCampaigns: "Outbound Calling Campaigns",
                    phoneNumbers: "Phone Numbers",
                    plans: "Plans",
                    prompts: "Audio Files",
                    reports: "Reports",
                    schedules: "Schedules",
                    system: "System Settings",
                    userDevices: "Devices",
                    userGroupMembership: "Groups",
                    userGroups: "Groups",
                    userProfile: "Profile",
                    userSettings: "My Settings",
                    users: "Users",
                    userSubscriptions: "Subscriptions",
                    userVoicemail: "Voicemail",
                    voicemailBoxes: "Voicemail Boxes",
                    webChatWidgets: "Web Chat Widgets"
                },
                accountManager: {
                    faqs: "FAQs",
                    helpCenter: "Help Center",
                    labelAccountManager: "Account Manager",
                    labelEmail: "Email",
                    labelMore: "Explore Further",
                    labelPhone: "Phone",
                    title: "Account Manager",
                    toggleLabel: "Contact Account Manager"
                },
                userProfile: {
                    available: "Available",
                    atLunch: "At Lunch",
                    away: "Away",
                    inAMeeting: "In A Meeting",
                    doNotDisturb: "Do Not Disturb",
                    goneHome: "Gone Home",
                    outOfOffice: "Out of Office",
                    billing: "Billing",
                    cancel: shared.enUS.cancel,
                    helpCenter: "Help",
                    loggedInAs: "Logged in as",
                    signOut: "Sign Out",
                    userSettings: "My Settings",
                    profile: "My Profile",
                    labelFirstName: "First Name",
                    labelLastName: "Last Name",
                    labelTitle: "Job Title",
                    labelEmail: "Email Address",
                    labelSecurity: "Security",
                    labelStatus: "Status",
                    labelTimeZone: "Time Zone",
                    changePassword: "Change Password",
                    changeVerificationQA: "Change Verification Question &amp; Answer",
                    resendInvite: "Resend Invite",
                    sendPasswordReset: "Send Password Reset Link",
                    systemSettings: "System Settings"
                },
                userDevices: {
                    add: shared.enUS.add,
                    addDevice: "Add Device",
                    addAnother: "+ Add Another",
                    callersNumber: "Caller's Number",
                    cancel: shared.enUS.cancel,
                    devices: "My Devices",
                    devicePhoneNumberRequired: "Phone number is required.",
                    deviceTooltip: "At least one device is required.",
                    editDevice: "Edit Device",
                    labelCallerId: "Caller ID",
                    labelName: "Name",
                    labelNumber: "Phone Number",
                    maxDevices: "You have reached the limit of five devices per user.",
                    mobileAppWarning: "You have an instance of the mobile app linked to this device, so the device phone number cannot be edited. <br /><br /> To change the device phone number, create a new device with the updated phone number and then delete this device. You will be required to verify the new number with a two-factor authentication code that we will text to you the first time you log into the mobile app using the new device / phone number. ",
                    save: shared.enUS.save,
                    trestaNumber: "PATLive Number",
                    validCanadianNumber: "This doesn't seem to be a valid Canadian phone number.",
                    validUSNumber: "This doesn't seem to be a valid US phone number."
                },
                userGroupMembership: {
                    addAnother: "+ Add Another",
                    allUsersGroup: "Cannot remove user from All Users.",
                    allUsersGroupSelf: "Cannot remove yourself from All Users.",
                    cancel: shared.enUS.cancel,
                    groups: "My Groups",
                    groupMembership: "User is a member of the following groups:",
                    groupMembershipSelf: "You are a member of the following groups:",
                    lastMember: "User is the last member of this group and cannot be removed.",
                    lastMemberSelf: "You are the last member of this group and cannot be removed.",
                    save: shared.enUS.save,
                    systemAdminsGroup: "Cannot remove yourself from System Admins.",
                },
                userSubscriptions: {
                    cancel: shared.enUS.cancel,
                    recordingTab: "Call Recordings",
                    save: shared.enUS.save,
                    subscriptions: "My Subscriptions",
                    voicemailTab: "Voicemail Boxes",
                },
                userCallRecordingSubscriptions: {
                    email: "Email",
                    mobile: "Mobile",
                    web: "Web",
                    noResults: "No Call Recording Subscriptions to Display",
                    phoneNumbers: 'Phone Numbers',
                    subscribers: "{{count}} Subscriber",
                    subscribers_plural: "{{count}} Subscribers",
                },
                userVoicemailSubscriptions: {
                    email: "Email",
                    mobile: "Mobile",
                    web: "Web",
                    noResults: "No Voicemail Subscriptions to Display",
                    subscribers: "{{count}} Subscriber",
                    subscribers_plural: "{{count}} Subscribers",
                    voicemailBoxes: 'Voicemail Boxes',
                },
                userVoicemail: {
                    cancel: shared.enUS.cancel,
                    greetingsTab: "Greetings",
                    lastMember: "Cannot remove user from their own voicemail box.",
                    lastMemberSelf: "Cannot remove yourself from your own voicemail box.",
                    save: shared.enUS.save,
                    subscribersTab: "Subscribers",
                    voicemail: "My Voicemail",
                },
                userVoicemailGreetings: {
                    addItemTitle: "+ Add Another",
                    currentTooltip: "Cannot delete the current greeting.",
                    default: "Current Greeting",
                    deleteTooltip: "Cannot delete the default greeting.",
                    editTooltip: "Cannot edit the default greeting.",
                    setDefault: "Make Current",
                },
                addVoicemailGreeting: {
                    add: shared.enUS.add,
                    cancel: shared.enUS.cancel,
                    conversionFailed: "Conversion failed, please choose another file.",
                    download: "Download",
                    headerAdd: "Add Greeting",
                    headerEdit: "Edit Greeting",
                    labelFile: "File",
                    labelMethod: "Method",
                    labelName: "Name",
                    labelPreview: "Preview",
                    greetingNameInvalid: "Please enter a valid greeting name.",
                    greetingNameRequired: "Name is required.",
                    greetingAudioRecordingRequired: "Please record a greeting.",
                    greetingAudioUploadRequired: "Please select a greeting.",
                    greetingAudioUploadSizeExceedsMax: shared.enUS.fileTooBig,
                    greetingAudioUploadTypeInvalid: shared.enUS.invalidAudioFile,
                    greetingNameNotUnique: "This name is already used by another greeting.",
                    greetingNameNotLocallyUnique: "This name is already in use by another new greeting.",
                    greetingRequired: "Greeting is required.",
                    save: shared.enUS.save,
                },
                oneTimePaymentModal: {
                    paymentError: 'Error Making one-time Payment'
                },
                billCycleToDate: {
                    billCycleToDate: "Bill Cycle to Date",
                    adjustments: {
                        header: "Adjustments"
                    },
                    currentCharges: {
                        header: "Current Charges"
                    },
                    monthlyRecurringCharges: {
                        header: "Monthly Recurring Charges",
                        billingPeriodDisplay: "{{- startDate}} - {{- endDate}}",
                        processingInfoDisplay: "",
                        tooltip: "",
                        totalsHeader: "Monthly Recurring Charges"
                    },
                    monthlyRecurringChargesForAutomatedServices: {
                        header: "Monthly Recurring Charges",
                        billingPeriodDisplay: "{{- startDate}} - {{- endDate}}",
                        processingInfoDisplay: "",
                        tooltip: "",
                        totalsHeader: "Monthly Recurring Charges for Automated Services"
                    },
                    monthlyRecurringChargesForLiveServices: {
                        header: "Monthly Recurring Charges",
                        billingPeriodDisplay: "{{- startDate}} - {{- endDate}}",
                        processingInfoDisplay: "",
                        tooltip: "",
                        totalsHeader: "Monthly Recurring Charges for Live Services"
                    },
                    currentUsage: {
                        header: "Usage Charges",
                        billingPeriodDisplay: "{{- startDate}} - {{- endDate}}",
                        processingInfoDisplay: "",
                        tooltip: "",
                        totalsHeader: "Current Usage"
                    },
                    currentTaxes: {
                        header: "Taxes, Fees & Surcharges",
                        billingPeriodDisplay: "{{- startDate}} - {{- endDate}}",
                        processingInfoDisplay: "",
                        tooltip: "",
                        totalsHeader: "Taxes, Fees & Surcharges"
                    },
                    estimatedBalance: {
                        header: "Estimated Balance",
                        processingInfoDisplay: "Processing on {{- processingDateDisplay}}",
                        billingPeriodDisplay: "For the billing period from {{- startDate}} to {{- endDate}}",
                        tooltip: "Your estimated balance is based on your account's current<br/>configuration and usage to-date in the current bill cycle.",
                        totalsHeader: "Estimated Balance",
                    },
                    exampleBalance: {
                        header: "Example Balance",
                        processingInfoDisplay: "",
                        billingPeriodDisplay: "",
                        tooltip: "",
                        totalsHeader: "Example Balance",
                    },
                    freeTrialWarningTitle: "You have {{freeTrialDaysRemaining}} day remaining in your free trial.",
                    freeTrialWarningTitle_plural: "You have {{freeTrialDaysRemaining}} days remaining in your free trial.",
                    freeTrialWarningMessage: "If you close your account before your free trial ends on {{freeTrialEndDate}}, you won’t be billed. Here’s an estimate of the monthly recurring charges, based on your account’s current configuration, that will apply after the free trial. This estimate may change if you add or remove users, phone numbers, or scripts.",
                    freeTrialNotStartedTitle: "Your free trial hasn’t started yet.",
                    freeTrialNotStartedMessage: "This is just an estimate of how your Bill Cycle to Date would look after your free trial, with your current service configuration. Charges do not accrue during the free trial. If you continue with service after the free trial, your Bill Cycle to Date starts fresh on the day you convert. If you cancel during the free trial, you will not be charged anything.",
                    freeTrialStartedOn: "Free Trial started on {{- freeTrialStartDate}}",
                    invoiceFor: "Statement for {{- cycleStartDate}} - {{- cycleEndDate)",
                    oneTimeCharges: {
                        header: "One-Time Charges",
                        billingPeriodDisplay: "{{- startDate}} - {{- endDate}}",
                        processingInfoDisplay: "",
                        tooltip: "",
                        totalsHeader: "One-Time Charges"
                    },
                    pastDueBalance: {
                        header: "Starting Balance",
                        tooltip: "Please pay your past due balance<br/>in order to avoid an interruption of service.",
                        billingPeriodDisplay: "For the billing period from {{- startDate}} to {{- endDate}}",
                        processingInfoDisplay: "Processing on {{- processingDateDisplay}}",
                        totalsHeader: "Pending Charges",
                    },
                    pastDueBalance_part1: "Your account has a&nbsp;<b>past due balance</b>&nbsp;of <b>{{pastDueBalanceAmount}}</b>.&nbsp;To avoid an interruption, please",
                    pastDueBalance_part2: "&nbsp;<b>make a payment</b>&nbsp;",
                    pastDueBalance_part3: "as soon as possible to clear the past due portion of your balance.",
                    pendingPayment: {
                        header: "Starting Balance",
                        tooltip: "This is the balance you currently owe on <br/>your account. It will be automatically billed<br/> to your default payment method on {{processingDateDisplay}}.",
                        billingPeriodDisplay: "For the billing period from {{- startDate}} to {{- endDate}}",
                        processingInfoDisplay: "Processing on {{- processingDateDisplay}}",
                        totalsHeader: "Pending Charges",
                    },
                    phoneNumbers: {
                        header: "Phone Numbers ({{countDisplay}})",
                    },
                    plan: {
                        header: "Platform Fee"
                    },
                    remainingBalance: "Remaining Balance",
                    taxesAndFees: {
                        header: "Taxes, Fees and Surcharges",
                    },
                    federalTaxes: {
                        header: "Federal"
                    },
                    stateTaxes: {
                        header: "State"
                    },
                    countyTaxes: {
                        header: "County"
                    },
                    cityTaxes: {
                        header: "City"
                    },
                    localTaxes: {
                        header: "Local"
                    },
                    startingBalance: {
                        header: "Starting Balance"
                    },
                    users: {
                        header: "Users ({{countDisplay}})"
                    },
                    scripts: {
                        header: "Scripts ({{countDisplay}})"
                    },
                    receptionistPackageUsage: {
                        header: "Receptionist Call Usage ({{countDisplay}})",
                        packageMinutes: {
                            title: "Package Minutes",
                            description: "{{includedMinutes}} minutes included, {{usedMinutes}} minutes used"
                        }
                    },
                    telephonyPackageUsage: {
                        header: "Minutes ({{countDisplay}})",
                        packageMinutes: {
                            title: "Package Minutes",
                            description: "{{includedMinutes}} minutes included, {{usedMinutes}} minutes used"
                        }
                    },
                    webChatPackageUsage: {
                        header: "Web Chat Usage ({{countDisplay}})",
                        packageUsage: {
                            title: "Web Chats",
                            description: "{{included}} chats included, {{used}} chats used"
                        }
                    },
                    outboundCallingPackageUsage: {
                        header: "Outbound Calling Usage ({{countDisplay}})",
                        packageUsage: {
                            title: "Outbound Calling Contacts",
                            description: "{{included}} contacts included, {{used}} contacts used"
                        }
                    },
                    additionalLiveCallAnsweringMinutes: {
                        header: "Additional Minutes for Live Call Answering ({{countDisplay}})",
                        packageMinutes: {
                            title: "Minutes",
                            description: "{{includedMinutes}} minutes included, {{usedMinutes}} minutes used"
                        }
                    },
                    additionalAutomatedMinutes: {
                        header: "Additional Automated Minutes ({{countDisplay}})",
                        packageMinutes: {
                            title: "Automated Minutes",
                            description: "{{includedMinutes}} minutes included, {{usedMinutes}} minutes used"
                        },
                        note: "Automated Minutes are only charged for calls that do not involve a live receptionist. If a call is routed to or from a live receptionist, no Automated Minutes are charged — even for time spent in your auto attendant, or for time incurred if the receptionist transfers the call to someone on your team."
                    },
                    additionalWebChats: {
                        header: "Additional Chats for Live Web Chat ({{countDisplay}})",
                        packageUsage: {
                            title: "Chats",
                            description: "{{included}} chats included, {{used}} chats used"
                        }
                    },
                    additionalOutreaches: {
                        header: "Additional Outreaches for Live Outbound Calls ({{countDisplay}})",
                        packageUsage: {
                            title: "Outreaches",
                            description: "{{included}} outreaches included, {{used}} outreaches used"
                        }
                    },
                },
                billingHistory: {
                    title: "History",
                    currentBalance: "Current Balance:&nbsp;",
                    pastDueBalance_part1: "Your account has a&nbsp;<b>past due balance</b>&nbsp;of <b>{{pastDueBalanceAmount}}</b>.&nbsp;To avoid an interruption, please",
                    pastDueBalance_part2: "&nbsp;<b>make a payment</b>&nbsp;",
                    pastDueBalance_part3: "as soon as possible to clear the past due portion of your balance.",
                    noResults: "No Billing History to Display",
                    invoiceGenerated: "Statement Generated",
                    refundToCard: "Refund to Card",
                    oneTimePayment: "One-time Payment",
                    autoPay: "Auto-pay",
                    autoPayRetry: "Auto-pay Retry",
                    completed: "Completed",
                    failed: "Failed",
                    billingHistoryTableHeaders: {
                        date: 'Date',
                        transactionType: 'Transaction Type',
                        paymentMethod: 'Payment Method',
                        amount: 'Amount',
                        status: 'Status'
                    }
                },
                accountProfile: {
                    accountClosed: "Account Closed",
                    accountNumber: "Account Number",
                    accountType: "I'm using PATLive for",
                    accountTypeRequired: "Account type selection is required.",
                    add: '+ Add',
                    addAnother: '+ Add Another',
                    addressRequired: "Address is required.",
                    billingMethods: {
                        creditCard: "Credit Card",
                        ach: "Bank Transfer (ACH)",
                        invoice: "Invoice",
                    },
                    businessNameRequired: "Business Name is required.",
                    cancel: shared.enUS.cancel,
                    cityRequired: "City is required.",
                    closeAccount: "Close Account",
                    companySizeRequired: "Company Size is required.",
                    countryRequired: "Country is required.",
                    emailAddressNotUnique: "Email address is already in use.",
                    firstNameRequired: "First Name is required.",
                    header: "Billing Profile",
                    howYouAreBilled: "How You're Billed",
                    industryRequired: "Industry is required.",
                    labelAccountHolderFirstName: "Account Holder First Name",
                    labelAccountHolderLastName: "Account Holder Last Name",
                    labelAddressLineOne: "Address",
                    labelAddressLineTwo: "Address 2 (optional)",
                    labelAgreement: "Agreement",
                    labelBillingCC: "CC These Email Addresses",
                    labelBillingCommunication: "Send Invoices and Billing Notifications to These Users and Groups",
                    labelBusinessName: "Business Name",
                    labelBusinessType: "Business Type",
                    labelCity: "City",
                    labelCompanySize: "Company Size",
                    labelCountry: "Country",
                    labelFirstName: "First Name",
                    labelIndustry: "Industry",
                    labelLastName: "Last Name",
                    labelPhoneNumber: "Phone Number",
                    labelPostalCode: "Postal Code",
                    labelProvince: "Province",
                    labelState: "State",
                    labelMonthYearFounded: "Month/Year Founded",
                    labelPointOfContact: "Point of Contact for Billing Inquiries",
                    labelTimeZone: "Time Zone",
                    labelWebsiteUrl: "Website URL",
                    labelZipCode: "Zip",
                    lastBillingSubscriber: "At least one is required.",
                    lastNameRequired: "Last Name is required.",
                    locationDescriptionOne: "Please provide the address associated with your ",
                    locationDescriptionThree: "which could be different than the address of your payment method.",
                    locationDescriptionTwo: "business registration,",
                    maxCCEmailsMessage: "You've reached the maximum number of CCs.",
                    monthYearFoundedInvalid: "Please enter a valid month/year.",
                    monthYearFoundedRequired: "Month/Year Founded is required.",
                    monthYearPlaceholder: "12 / 2024",
                    noMoreBillingSubscribers: "There are no more users or groups to add.",
                    oopsInvalidItems: "Oops, it looks like there are some issues with these sections:",
                    pleaseCorrectInvalidFields: "Please correct the highlighted fields and try again.",
                    pleaseSpecify: "Please specify",
                    postalCodeRequired: "Postal code is required.",
                    provinceRequired: "Province is required.",
                    save: shared.enUS.save,
                    sectionBillingCommunication: "Billing Communication",
                    select: "Select",
                    stateRequired: "State is required.",
                    timeZoneRequired: "Time Zone is required.",
                    websiteUrlInvalid: "Please enter a valid URL.",
                    zipCodeRequired: "Zip is required.",
                    industries: {
                        accounting: shared.enUS.industries.accounting,
                        architecture: shared.enUS.industries.architecture,
                        arts: shared.enUS.industries.arts,
                        automotive: shared.enUS.industries.automotive,
                        beauty: shared.enUS.industries.beauty,
                        camping: shared.enUS.industries.camping,
                        chiropractors: shared.enUS.industries.chiropractors,
                        cleaning: shared.enUS.industries.cleaning,
                        construction: shared.enUS.industries.construction,
                        consulting: shared.enUS.industries.consulting,
                        dental: shared.enUS.industries.dental,
                        education: shared.enUS.industries.education,
                        electrical: shared.enUS.industries.electrical,
                        financial: shared.enUS.industries.financial,
                        flooring: shared.enUS.industries.flooring,
                        funeralHome: shared.enUS.industries.funeralHome,
                        generalContracting: shared.enUS.industries.generalContracting,
                        health: shared.enUS.industries.health,
                        home: shared.enUS.industries.home,
                        hospitality: shared.enUS.industries.hospitality,
                        humanResources: shared.enUS.industries.humanResources,
                        hvac: shared.enUS.industries.hvac,
                        insurance: shared.enUS.industries.insurance,
                        internet: shared.enUS.industries.internet,
                        landscaping: shared.enUS.industries.landscaping,
                        legal: shared.enUS.industries.legal,
                        manufacturing: shared.enUS.industries.manufacturing,
                        marketing: shared.enUS.industries.marketing,
                        media: shared.enUS.industries.media,
                        medical: shared.enUS.industries.medical,
                        non: shared.enUS.industries.non,
                        other: shared.enUS.industries.other,
                        personalCare: shared.enUS.industries.personalCare,
                        plumbing: shared.enUS.industries.plumbing,
                        real: shared.enUS.industries.real,
                        religion: shared.enUS.industries.religion,
                        restaurant: shared.enUS.industries.restaurant,
                        retail: shared.enUS.industries.retail,
                        roofing: shared.enUS.industries.roofing,
                        sports: shared.enUS.industries.sports,
                        telecommunications: shared.enUS.industries.telecommunications,
                        transportation: shared.enUS.industries.transportation,
                        travel: shared.enUS.industries.travel,
                    }
                },
                audioRecorder: {
                    deviceSelectorTooltip: "Microphone selection is only supported in Chrome",
                    labelMic: "Microphone",
                    labelPreview: "Preview",
                    noDevices: "Your browser did not detect a microphone. If you have a microphone and believe this is an error, please confirm the microphone settings and retry.",
                    notSupported: "Your current browser does not support this feature.",
                    permissionRequired: "To record audio using your microphone, you must first allow permission to access the microphone in your browser's settings.",
                    record: "Start Recording",
                    reRecord: "Re-Record",
                    starting: "Starting in... ",
                    stop: "Stop "
                },
                callDetails: {
                    callId: "Call ID",
                    chatId: "Chat ID",
                    callRoute: "Call Flow",
                    chatRoute: "Chat Flow",
                    chatTranscript: "Chat Transcript",
                    domain: "Domain",
                    email: "Email",
                    formSubmission: "Form Submission",
                    formSubmissionEmptyMessage: "None",
                    location: "Location",
                    name: "Name",
                    recipients: "Recipients",
                    subscribers: "Subscribers",
                    tollFreeMapMessage: "Location Data Unavailable",
                    userSubmittedInfo: "User-Submitted Info"
                },
                callFlow: {
                    audioSeparatorMessage: "After playing the audio file, send it to",
                    defaultScheduleSegment: "All Other Times",
                    defaultSeparatorMessage: "Then send it to",
                    hangup: "Hang Up",
                    playRinging: "Ring until answered or caller hangs up",
                    timeoutMessage: " seconds, send it to",
                    timeoutSeparatorMessage: "If it's not answered after ",
                },
                callRoute: {
                    formRouteName: "Form Submitted",
                    junkRouteName: "Marked as Junk",
                    receptionistRouteName: "Receptionist",
                    receptionistAnsweredRouteName: "Receptionist Answered",
                    receptionistTransferredRouteName: "Receptionist Transferred"
                },
                closeAccount: {
                    areYouSure: "Are you sure?",
                    areYouSwitchingServices: "Are you switching to another service?",
                    canYouExplainTheIssue: "Please describe the issue(s) you were having.",
                    canYouProvideSummaryOfCustomerServiceIssue: "Please provide a summary of the customer service issue.",
                    doYouHaveFeedback: "Do you have any feedback you'd like to share with us?",
                    cancel: "Cancel",
                    cancellationComment: "Cancellation Comment",
                    closeAccount: "Close Account",
                    customerDidNotProvideRating: "Customer didn't provide a rating",
                    fraudStatus: "Fraud Status",
                    header: "Close Account",
                    howLikelyAreYouToRecommend: "How likely are you to recommend PATLive to a friend?",
                    pleaseMakeSelection: "Please make a selection.",
                    pleaseProvideResponse: "Please provide a response.",
                    pleaseSelect: "Select",
                    pleaseSelectReason: "Please select a reason.",
                    pleaseSpecify: "Please specify",
                    pleaseSpecifyWhichService: "Please specify the service you are switching to.",
                    pleaseSpecifyFeaturesNeeded: "What features did you need?",
                    pleaseSpecifyLiveReceptionistIssues: "What issue(s) did you have with the Live Receptionist service?",
                    pleaseSpecifyOtherReasonForCancelling: "Please specify the reason you want to close your account.",
                    pleaseSpecifyReasonForCancelling: "Please specify the reason you are cancelling.",
                    portInProgress: "Port in progress",
                    portInProgressWarningMessage_part1: "You have a phone number in an active port status and cannot close your account until the port has completed. If you have questions or need assistance with your port, please email",
                    portInProgressWarningMessage_part2: " or call " + shared.enUS.customerServiceNumberFormatted + ".",
                    portOutInstructionsWarningTitle: "Port outs must be completed before closing your account.",
                    portOutInstructionsWarningMessage: "If you want to keep your current number, you must port it out before closing your account. Failure to follow these instructions may result in an interruption of service and/or loss of your number.",
                    portOutInstructionsSteps: "To port your number out:",
                    portOutInstructions_step1: "1) Initiate the number port with your new service provider",
                    portOutInstructions_step2: "2) Wait for confirmation that the port is complete",
                    portOutInstructions_step3: "3) Verify that the number is working correctly with the new provider",
                    portOutInstructions_step4: "4) Then return here to close your account",
                    whatDidYouHaveTroubleWith: "Please describe the issue(s) you were having.",
                    whatsYourViewOfPricing: "Which best fits your view of PATLive’s pricing?",
                    whatWouldMakeItWorthThePrice: "What, if anything, would have made the service worth the price for your business?",
                    whyDoYouNoLongerNeedTresta: "Which best describes why you no longer need PATLive?",
                    whatWasTheIssue: "What was the issue?",
                    whichService: "Which service?",
                    whyDoYouWantToCloseYourAccount: "Why do you want to close your account?"
                },
                closeAccountActionModal: {
                    title: "Pressing the Close Account button will close your account immediately.",
                    accountAccessTitle: "Account Access",
                    accountAccessMessage: "All users on your account will be signed out from the web app and the mobile app.",
                    numberPortingTitle: "Number Porting",
                    numberPortingMessage: "You will no longer be eligible to port your number to a new service provider. If you want to port your number, complete the transfer to your new provider first and then close your PATLive account.",
                    callingMessagingReportingTitle: "Calling, Messaging & Reporting",
                    callingMessagingReportingMessage: "You will no longer be able to place or receive calls and messages on your PATLive number, and you'll no longer be able to access reporting data associated with your PATLive number."
                },
                dateRangeSelection: {
                    endPlaceholder: "To",
                    startPlaceholder: "From"
                },
                integrityWarningModal: {
                    cancel: shared.enUS.cancel,
                    conflicts: "Please resolve the following conflicts and try again.",
                    deactivate: "Deactivate {{type}}",
                    delete: "Delete {{type}}",
                    inUse: "This {{type}} cannot be deleted because it is in use.",
                    remove: "Remove {{type}}"
                },
                autoAttendantIntegrityWarningModal: {
                    cancel: shared.enUS.cancel,
                    conflicts: "Please resolve the following conflicts and try again.",
                    delete: "Delete {{type}}",
                    inUse: "This {{type}} cannot be deleted because it is in use.",
                },
                liveReceptionistScriptIntegrityWarningModal: {
                    cancel: shared.enUS.cancel,
                    conflicts: "Please resolve the following conflicts and try again.",
                    deactivate: "Deactivate {{type}}",
                    inUse: "This {{type}} cannot be deleted because it is in use.",
                },
                warningModal: {
                    areYouSure: "Are you sure?",
                    areYouSure_navigate: "There are some unsaved changes. Navigating away from this page will discard any changes made. Are you sure you want to navigate away from this page?",
                    areYouSure_phoneNumber: "Are you sure you want to delete this phone number? You will lose any associated Call Recordings.",
                    areYouSure_unassign: "Are you sure you want to unassign this {{type}}?",
                    areYouSure_delete: "Are you sure you want to delete this {{type}}?",
                    cancel: shared.enUS.cancel,
                    cancelPort: "Please contact customer service to cancel number port.",
                    delete: "Delete {{type}}",
                    delete_callRecording: "Delete Call Recording",
                    delete_voicemail: "Delete Voicemail",
                    noCancel: "No, Cancel",
                    oneNumberRequired: "Sorry, at least one active phone number is required.",
                    inUse: "Sorry, this {{type}} cannot be deleted because it is in use.",
                    unassign: "Unassign",
                    yesDelete: "Yes, Delete",
                    yesNavigate: "Yes, Navigate Away"
                },
                actionModal: {
                    add: shared.enUS.add,
                    agentBypass: shared.enUS.agentBypass,
                    archive: "Archive",
                    areYouSure_charge: "Are you sure you want to charge {{amount}} to this card?",
                    areYouSure_deactivate: "Are you sure you want to deactivate this {{type}}?",
                    areYouSure_delete: "Are you sure you want to delete this {{type}}?",
                    areYouSure_reactivate: "Are you sure you want to reactivate this {{type}}?",
                    areYouSure_remove: "Are you sure you want to remove this option from the menu?",
                    cancel: shared.enUS.cancel,
                    cancelInvite: "Cancel Invite",
                    close: "Close",
                    closeAccount: "Close Account",
                    confirm: "Confirm",
                    copy: " Copy",
                    continue: "Continue",
                    deactivate: "Deactivate",
                    delete: "Delete",
                    deleteConfirmation: "Delete Confirmation",
                    deleteHeader: "Delete {{type}}",
                    oneTimePaymentHeader: "One-time Payment",
                    pay: "Pay",
                    paymentApproved: "Your payment of {{amount}} was approved.",
                    paymentDeclined: "Your payment of {{amount}} was declined.",
                    paymentDeclinedBody: "Please verify your saved card details and retry, <br/> or try using another payment method.",
                    paymentError: "We’re having trouble processing your payment.",
                    paymentErrorBody: "Please call +1 (800) 775-7790 for assistance.",
                    reactivate: "Reactivate",
                    remove: "Remove",
                    removeHeader: "Remove Menu Option",
                    save: shared.enUS.save,
                    saveCopy: "Save a Copy",
                    send: "Send",
                    unsavedChangesHeader: "Unsaved Changes",
                    unsavedChangesText: "You have unsaved changes that will be lost if you navigate away.",
                    unsavedPhoneNumbers: "Unsaved Phone Numbers",
                    unsavedPhoneNumbersText: "You have unsaved numbers that will be lost if you navigate away.",
                },
                deletePaymentMethodModal: {
                    areYouSure: "Are you sure you want to delete this payment method?",
                },
                changePasswordModal: {
                    areYouSure: "Are you sure you want to send a password reset link?",
                    cancel: shared.enUS.cancel,
                    change: "Change",
                    changePassword: "Change Password",
                    close: "Close",
                    confirmationMessage: "Your password has been updated.",
                    confirmPasswordRequired: "Please re-enter your new password.",
                    currentPasswordRequired: "Please enter your current password.",
                    currentPasswordValid: "The password you entered is incorrect.",
                    labelConfirm: "New Password Confirm",
                    labelCurrent: "Current Password",
                    labelNew: "New Password",
                    newPasswordInvalid: "Password must contain 8-32 characters, 1 upper case letter, 1 lower case letter & 1 number.",
                    newPasswordRequired: "Please enter a new password.",
                    passwordPlaceholder: "8-32 characters, 1 upper case, 1 lower case, and 1 number",
                    resetPassword: "Send Password Reset",
                    send: "Send"
                },
                changeVerificationQAModal: {
                    cancel: shared.enUS.cancel,
                    change: "Change",
                    changeVerificationQA: "Change Verification Q&A",
                    close: "Close",
                    confirmationMessage: "Your verification question and answer have been updated.",
                    labelAnswer: "Answer",
                    labelQuestion: "Verification Question",
                },
                confirmPasswordModal: {
                    cancel: shared.enUS.cancel,
                    changeVerificationQA: "Change Verification Q&A",
                    continueMessage: "To continue, enter your password and click Next.",
                    labelPassword: "Password",
                    next: "Next",
                },
                resendInviteModal: {
                    areYouSure: "Are you sure you want to send a new invite?",
                    cancel: shared.enUS.cancel,
                    header: "Resend Invite",
                    send: "Send"
                },
                uploadImageModal: {
                    cancel: shared.enUS.cancel,
                    cropEmptyText: "No Photo Selected",
                    cropLoadingText: "Uploading ...",
                    preview: "Preview",
                    save: shared.enUS.save,
                    stepOne: "Step 1: Upload a Photo",
                    stepTwo: "Step 2: Crop Your Photo",
                    uploadPhoto: "Upload Photo",
                },
                freeTrialMessagingSnackbar: {
                    message: "Messaging cannot be enabled while in a free trial."
                },
                onboardingSnackbar: {
                    liveReceptionistWizardDoneOnboardingCallOutstandingMessage: "Nice work — your call answering is live! Let's get {{services}} set up too.",
                    singleServiceNotStartedMessage: "Ready to configure {{serviceName}}? Your free trial won't start until you're set up.",
                    multipleServicesNotStartedMessage: "Ready to configure your services? Your free trial won't start until you're set up.",
                    onboardingCallBookedMessage: "Your onboarding session is booked. Want to start with message taking service in the meantime? We can start answering your calls and taking messages immediately, and we'll upgrade your service to the full experience after your onboarding call.",
                    onboardingCallBookedNoActionMessage: "Your onboarding session is booked — we'll take it from here.",
                    getStarted: "Get Started",
                    configureMessageTakingService: "Let's Do It!",
                    serviceLiveCallAnswering: shared.enUS.serviceLiveCallAnswering,
                    serviceLiveWebChat: shared.enUS.serviceLiveWebChat,
                    serviceOutboundCalls: shared.enUS.serviceOutboundCalls,
                },
                filterSelection: {
                    addAnotherMessage: "There are no more {{optionText}} available to add.",
                    all: "All",
                    clear: "Clear",
                },
                membershipSelection: {
                    addAnotherMessage: "There are no more {{optionText}} available to add",
                    lastItemRemoveTitle: "Cannot remove the last member.",
                },
                subscriberSelection: {
                    addAnotherMessage: "There are no more subscribers available to add.",
                    added: "added",
                    addItemTitle: "+ Add Another",
                    allMembers: "All Members",
                    at: "at",
                    by: " by ",
                    currentlyDisabled: "currently disabled",
                    customerServiceAgent: "Customer Service Agent",
                    disabled: "disabled",
                    emailOnlyRecipients: "Email Only Recipients",
                    enabled: "enabled",
                    enabledButNoPermissions: "enabled but there are no users or groups included in the call flow",
                    inbound: "Inbound",
                    lastItemRemoveTitle: "At least one subscriber is required.",
                    maxEmailRecipients: "You've reached the maximum number of email recipients.",
                    on: "on",
                    outbound: "Outbound",
                    removed: "removed",
                    subscriberLogPermissionTitle: "Feature",
                    subscriberLogTitle: "History:",
                    systemProcess: "System",
                    today: "today",
                    unknown: "Unknown",
                    viewMore: "View More",
                    yesterday: "yesterday"
                },
                inheritedSubscriberSelection: {
                    noInheritedActors: "Inbound calls are {{inboundCallingStatus}}, so no one is inheriting permissions to {{inheritedAction}}.",
                    toAllowAction: "To allow users to {{inheritedAction}}, either:",
                    noInheritedActorsBulletOne: "Enable inbound calls on the Inbound Calls tab and send calls to the users and groups that need to be able to {{inheritedAction}}, or",
                    noInheritedActorsBulletTwo: "Use the dropdown above to select “{{manualOption}}” and grant {{grantedPermission}} to the user and groups that need to be able to {{inheritedAction}}.",
                },
                timeframe: {
                    timeframe: "Timeframe",
                    clear: "Clear",
                    all: "All",
                    now: "Now",
                    today: 'Today',
                    thisWeek: 'This Week',
                    thisMonth: 'This Month',
                    thisQuarter: 'This Quarter',
                    thisYear: 'This Year',
                    yesterday: 'Yesterday',
                    lastWeek: 'Last Week',
                    lastMonth: 'Last Month',
                    lastQuarter: 'Last Quarter',
                    lastYear: 'Last Year',
                    monthToDate: 'Month to Date',
                    quarterToDate: 'Quarter to Date',
                    yearToDate: 'Year to Date',
                    lastDays7: 'Last 7 Days',
                    lastDays14: 'Last 14 Days',
                    lastDays30: 'Last 30 Days',
                    lastDays60: 'Last 60 Days',
                    lastDays90: 'Last 90 Days',
                    lastMonths12: 'Last 12 Months',
                    custom: 'Custom',
                },
                notFound: {
                    headline: 'Oops! We can\'t find the page you\'re looking for.',
                    message: 'Go to ',
                    previousPage: 'Previous Page'
                },
                navigationConfiguration: {
                    login: {
                        title: "Sign In | PATLive",
                        description: " Sign in to your PATLive phone system.",
                        displayName: "Sign In",
                    },
                    acceptFlexInvite: {
                        title: "Welcome to Flex | PATLive",
                        description: "",
                        displayName: "Welcome to Flex",
                    },
                    accountClosed: {
                        title: "Account Closed | PATLive",
                        description: "Close your PATLive account.",
                        displayName: "PATLive Account Closed"
                    },
                    accountClosedAch: {
                        title: "Account Closed | PATLive",
                        description: "Your PATLive account has been closed.",
                        displayName: "PATLive Account Closed"
                    },
                    accountClosedFreeTrial: {
                        title: "Account Closed | PATLive",
                        description: "Your PATLive account has been closed.",
                        displayName: "PATLive Account Closed"
                    },
                    accountClosedInvoice: {
                        title: "Account Closed | PATLive",
                        description: "Your PATLive account has been closed.",
                        displayName: "PATLive Account Closed"
                    },
                    closeAccount: {
                        title: "Close Account | PATLive",
                        description: "Close your PATLive account.",
                        displayName: "Close PATLive Account"
                    },
                    closedBalanceOwed: {
                        title: "Sign In | PATLive",
                        description: "Sign in to your PATLive account.",
                        displayName: "Sign In - Account Closed - Balance Owed",
                    },
                    closedCannotReactivate: {
                        title: "Sign In | PATLive",
                        description: "Sign in to your PATLive account.",
                        displayName: "Sign In - Account Closed - Cannot Reactivate",
                    },
                    closedDoNotReactivate: {
                        title: "Sign In | PATLive",
                        description: "Sign in to your PATLive account.",
                        displayName: "Sign In - Account Closed - Do Not Reactivate",
                    },
                    miscellaneousProblems: {
                        title: "Sign In | PATLive",
                        description: "Sign in to your PATLive account.",
                        displayName: "Sign In - Miscellaneous Problems",
                    },
                    reactivation: {
                        title: "Sign In | PATLive",
                        description: "Sign in to your PATLive account.",
                        displayName: "Sign In - Account Closed",
                    },
                    reactivationPlans: {
                        title: "Sign In | PATLive",
                        description: "Sign in to your PATLive account.",
                        displayName: "Reactivation",
                    },
                    reactivationSuccess: {
                        title: "Sign In | PATLive",
                        description: "Sign in to your PATLive account.",
                        displayName: "Reactivation Success",
                    },
                    payBalance: {
                        title: "Sign In | PATLive",
                        description: "Sign in to your PATLive account.",
                        displayName: "Sign In - Pay Balance",
                    },
                    forgotPassword: {
                        title: "PATLive | Forgot Password",
                        description: "",
                        displayName: "Forgot Password",
                    },
                    resetPassword: {
                        title: "PATLive | Reset Password",
                        description: "",
                        displayName: "Reset Password",
                    },
                    acceptUserInvite: {
                        title: "Welcome to PATLive | PATLive",
                        description: "",
                        displayName: "Welcome to PATLive",
                    },
                    resendInvite: {
                        title: "Resend Invite | PATLive",
                        description: "",
                        displayName: "Resend Invite",
                    },
                    index: {
                        title: "Index | PATLive",
                        description: "",
                        displayName: "Index",
                    },
                    signupFreeTrial: {
                        title: "Free Trial | PATLive",
                        description: "Test drive PATLive with a 14 day free trial - 24/7 live answering, scheduling and a 100% US-based team, with no contracts.",
                        displayName: "Signup Free Trial",
                    },
                    signupSuccess: {
                        title: "Start Free Trial - Success!",
                        description: "",
                        displayName: "Signup Success",
                    },
                    signupScheduling: {
                        title: "Schedule Onboarding | PATLive",
                        description: "",
                        displayName: "Signup | Schedule Onboarding",
                    },
                    signupError: {
                        title: "Account Setup | PATLive",
                        description: "",
                        displayName: "Signup Error",
                    },
                    signupEmail: {
                        title: "Free Trial | PATLive",
                        description: "Get started with your free 14 day trial of PATLive answering service - award-winning 24/7 live virtual receptionists.",
                        displayName: "Signup Email",
                    },
                    signupEmailVerify: {
                        title: "Account Setup | PATLive",
                        description: "",
                        displayName: "Signup Email Verify",
                    },
                    signupPlans: {
                        title: "Start Free Trial - Select Your Plan",
                        description: "",
                        displayName: "Signup Plans",
                    },
                    signupPhoneNumberType: {
                        title: "Account Setup | PATLive",
                        description: "",
                        displayName: "Signup Phone Number Type",
                    },
                    signupPhoneNumberLocal: {
                        title: "Account Setup | PATLive",
                        description: "",
                        displayName: "Signup Phone Number Local",
                    },
                    signupPhoneNumberTollfree: {
                        title: "Account Setup | PATLive",
                        description: "",
                        displayName: "Signup Phone Number Toll-Free",
                    },
                    signupPhoneNumberPort: {
                        title: "Account Setup | PATLive",
                        description: "",
                        displayName: "Signup Phone Number Port",
                    },
                    signupPhoneNumberPortBilling: {
                        title: "Account Setup | PATLive",
                        description: "",
                        displayName: "Signup Phone Number Port",
                    },
                    signupPhoneNumberPortAuthorization: {
                        title: "Account Setup | PATLive",
                        description: "",
                        displayName: "Signup Phone Number Port",
                    },
                    signupProfile: {
                        title: "Start Free Trial - Create Your User",
                        description: "",
                        displayName: "Signup Profile",
                    },
                    signupSecurity: {
                        title: "Start Free Trial - Set Your Password",
                        description: "",
                        displayName: "Signup Security",
                    },
                    signupPaymentMethod: {
                        title: "Start Free Trial - Add a Payment Method",
                        description: "",
                        displayName: "Payment Method",
                    },
                    liveReceptionistOnboardingWelcome: {
                        title: "Onboarding: Live Call Answering",
                        description: "",
                        displayName: "Live Receptionist Onboarding",
                    },
                    liveReceptionistOnboardingScheduling: {
                        title: "Onboarding: Schedule Your Onboarding Call",
                        description: "",
                        displayName: "Live Receptionist Onboarding | Scheduling",
                    },
                    liveReceptionistOnboardingIdentity: {
                        title: "Onboarding: Live Call Answering",
                        description: "",
                        displayName: "Live Receptionist Onboarding | Identity",
                    },
                    liveReceptionistOnboardingAvailability: {
                        title: "Onboarding: Live Call Answering",
                        description: "",
                        displayName: "Live Receptionist Onboarding | Availability",
                    },
                    liveReceptionistOnboardingInformation: {
                        title: "Onboarding: Live Call Answering",
                        description: "",
                        displayName: "Live Receptionist Onboarding | Information",
                    },
                    liveReceptionistOnboardingDelivery: {
                        title: "Onboarding: Live Call Answering",
                        description: "",
                        displayName: "Live Receptionist Onboarding | Delivery",
                    },
                    liveReceptionistOnboardingProcessing: {
                        title: "Onboarding: Live Call Answering",
                        description: "",
                        displayName: "Live Receptionist Onboarding | Processing...",
                    },
                    analytics: {
                        title: "Analytics | PATLive",
                        description: "",
                        displayName: "Analytics",
                    },
                    receptionist: {
                        title: "Receptionist | PATLive",
                        description: "",
                        displayName: "Receptionist",
                    },
                    receptionistMessage: {
                        title: "Message | PATLive",
                        description: "",
                        displayName: "Message",
                    },
                    contacts: {
                        title: "Contacts | PATLive",
                        description: "",
                        displayName: "Contacts",
                    },
                    messages: {
                        title: "Messaging | PATLive",
                        description: "",
                        displayName: "Messaging",
                    },
                    newMessage: {
                        title: "New Message | PATLive",
                        description: "",
                        displayName: "New Message"
                    },
                    conversation: {
                        title: "Conversation | PATLive",
                        description: "",
                        displayName: "Conversation"
                    },
                    inbox: {
                        title: "Voicemail | PATLive",
                        description: "",
                        displayName: "Voicemail",
                    },
                    inboxRecordings: {
                        title: "Call Recordings | PATLive",
                        description: "",
                        displayName: "Call Recordings",
                    },
                    inboxRecordingsFiltered: {
                        title: "Call Recordings | PATLive",
                        description: "",
                        displayName: "Call Recordings",
                    },
                    inboxVoicemail: {
                        title: "Voicemail | PATLive",
                        description: "",
                        displayName: "Voicemail",
                    },
                    inboxVoicemailFiltered: {
                        title: "Voicemail | PATLive",
                        description: "",
                        displayName: "Voicemail",
                    },
                    settings: {
                        title: "Settings | PATLive",
                        description: "",
                        displayName: "System",
                    },
                    contactUs: {
                        title: "Contact Us | PATLive",
                        description: "",
                        displayName: "Contact Us",
                    },
                    helpCenter: {
                        title: "Help Center | PATLive",
                        description: "",
                        displayName: "Help Center",
                    },
                    'my-profile': {
                        title: "{{fullName}} | PATLive",
                        description: "",
                        displayName: "{{fullName}}",
                    },
                    userProfile: {
                        title: "User Profile | PATLive",
                        description: "",
                        displayName: "User Profile",
                    },
                    userDevices: {
                        title: "Devices | PATLive",
                        description: "",
                        displayName: 'Devices',
                    },
                    userSubscriptions: {
                        title: "Subscriptions | PATLive",
                        description: "",
                        displayName: 'Subscriptions',
                    },
                    userSubscriptionsFiltered: {
                        title: "Subscriptions | PATLive",
                        description: "",
                        displayName: 'Subscriptions',
                    },
                    userGroupMembership: {
                        title: "Groups | PATLive",
                        description: "",
                        displayName: "Groups",
                    },
                    userVoicemail: {
                        title: "Voicemail | PATLive",
                        description: "",
                        displayName: 'Voicemail',
                    },
                    'system-settings': {
                        title: "System Settings | PATLive",
                        description: "",
                        displayName: "System",
                    },
                    prompts: {
                        title: "Audio Files | PATLive",
                        description: "",
                        displayName: "Audio Files",
                    },
                    newPrompt: {
                        title: "Add Audio File | PATLive",
                        description: "",
                        displayName: "Add Audio File",
                    },
                    editPrompt: {
                        title: "Edit Audio File | PATLive",
                        description: "",
                        displayName: "Edit Audio File",
                    },
                    autoAttendant: {
                        title: "Auto Attendants | PATLive",
                        description: "",
                        displayName: "Auto Attendants",
                    },
                    addAutoAttendant: {
                        title: "Add Auto Attendant | PATLive",
                        description: "",
                        displayName: "Add Auto Attendant",
                    },
                    editAutoAttendant: {
                        title: "Edit Auto Attendant | PATLive",
                        description: "",
                        displayName: "Edit Auto Attendant",
                    },
                    contactPermissions: {
                        title: "Contacts | PATLive",
                        description: "",
                        displayName: "Contacts"
                    },
                    blocking: {
                        title: "Blocking | PATLive",
                        description: "",
                        displayName: "Blocking"
                    },
                    extensions: {
                        title: "Extensions | PATLive",
                        description: "",
                        displayName: "Extensions",
                    },
                    forwardingNumbers: {
                        title: "Forwarding Numbers | PATLive",
                        description: "",
                        displayName: "Forwarding Numbers",
                    },
                    newForwardingNumber: {
                        title: "Add Forwarding Number | PATLive",
                        description: "",
                        displayName: "Add Forwarding Number",
                    },
                    editForwardingNumber: {
                        title: "Edit Forwarding Number | PATLive",
                        description: "",
                        displayName: "Edit Forwarding Number",
                    },
                    liveReceptionistScripts: {
                        title: "Live Receptionist Scripts | PATLive",
                        description: "",
                        displayName: "Live Receptionist Scripts",
                    },
                    addLiveReceptionistScript: {
                        title: "Add Live Receptionist Script | PATLive",
                        description: "",
                        displayName: "Add Live Receptionist Script",
                    },
                    associateLiveReceptionistScript: {
                        title: "Associate Live Receptionist Script | PATLive",
                        description: "",
                        displayName: "Associate Live Receptionist Script",
                    },
                    editLiveReceptionistScript: {
                        title: "Edit Live Receptionist Script | PATLive",
                        description: "",
                        displayName: "Edit Live Receptionist Script",
                    },
                    messagingCompliance: {
                        title: "Messaging Compliance | PATLive",
                        description: "",
                        displayName: "Messaging Compliance",
                    },
                    phoneNumbers: {
                        title: "Phone Numbers | PATLive",
                        description: "",
                        displayName: "Phone Numbers",
                    },
                    newPhoneNumberType: {
                        title: "Add Phone Number | PATLive",
                        description: "",
                        displayName: "Add Phone Number",
                    },
                    newPhoneNumberLocal: {
                        title: "Add Phone Number | PATLive",
                        description: "",
                        displayName: "Add Phone Number",
                    },
                    newPhoneNumberTollFree: {
                        title: "Add Phone Number | PATLive",
                        description: "",
                        displayName: "Add Phone Number",
                    },
                    newPhoneNumberPort: {
                        title: "Add Phone Number | PATLive",
                        description: "",
                        displayName: "Add Phone Number",
                    },
                    newPhoneNumberSummary: {
                        title: "Add Phone Number | PATLive",
                        description: "",
                        displayName: "Add Phone Number",
                    },
                    editPhoneNumbers: {
                        title: "Edit Phone Number | PATLive",
                        description: "",
                        displayName: "Edit Phone Number",
                    },
                    reports: {
                        title: "Reports | PATLive",
                        description: "",
                        displayName: "Reports",
                    },
                    editReport: {
                        title: "Edit Report | PATLive",
                        description: "",
                        displayName: "Edit Report",
                    },
                    schedules: {
                        title: "Schedules | PATLive",
                        description: "",
                        displayName: "Schedules",
                    },
                    newSchedule: {
                        title: "Add Schedule | PATLive",
                        description: "",
                        displayName: "Add Schedule",
                    },
                    editSchedule: {
                        title: "Edit Schedule | PATLive",
                        description: "",
                        displayName: "Edit Schedule",
                    },
                    callQueues: {
                        title: "Call Queues | PATLive",
                        description: "",
                        displayName: "Call Queues",
                    },
                    newCallQueue: {
                        title: "Add Call Queue | PATLive",
                        description: "",
                        displayName: "Add Call Queue",
                    },
                    editCallQueue: {
                        title: "Edit Call Queue | PATLive",
                        description: "",
                        displayName: "Edit Call Queue",
                    },
                    humanDetection: {
                        title: "Human Detection | PATLive",
                        description: "",
                        displayName: "Human Detection",
                    },
                    newHumanDetectionPhoneNumber: {
                        title: "Add Phone Number to Whitelist | PATLive",
                        description: "",
                        displayName: "Add Phone Number to Whitelist",
                    },
                    integrations: {
                        title: "Integrations | PATLive",
                        description: "",
                        displayName: "Integrations",
                    },
                    addIntegration: {
                        title: "Integrations | PATLive",
                        description: "",
                        displayName: "Integrations",
                    },
                    users: {
                        title: "Users | PATLive",
                        description: "",
                        displayName: "Users",
                    },
                    editUser: {
                        title: "Edit User | PATLive",
                        description: "",
                        displayName: "Edit User",
                    },
                    userGroups: {
                        title: "Groups | PATLive",
                        description: "",
                        displayName: "Groups",
                    },
                    addUserGroup: {
                        title: "Add Group | PATLive",
                        description: "",
                        displayName: "Add Group",
                    },
                    editUserGroup: {
                        title: "Edit Group | PATLive",
                        description: "",
                        displayName: "Edit Group",
                    },
                    voicemailBoxes: {
                        title: "Voicemail Boxes | PATLive",
                        description: "",
                        displayName: "Voicemail Boxes",
                    },
                    newVoicemailBox: {
                        title: "Add Voicemail Box | PATLive",
                        description: "",
                        displayName: "Add Voicemail Box",
                    },
                    editVoicemailBox: {
                        title: "Edit Voicemail Box | PATLive",
                        description: "",
                        displayName: "Edit Voicemail Box",
                    },
                    outboundCallingCampaigns: {
                        title: "Outbound Calling Campaigns | PATLive",
                        description: "",
                        displayName: "Outbound Calling Campaigns",
                    },
                    addOutboundCallingCampaign: {
                        title: "Add Outbound Calling Campaign | PATLive",
                        description: "",
                        displayName: "Add Outbound Calling Campaign",
                    },
                    editOutboundCallingCampaign: {
                        title: "Edit Outbound Calling Campaign | PATLive",
                        description: "",
                        displayName: "Edit Outbound Calling Campaign",
                    },
                    webChatWidgets: {
                        title: "Web Chat Widgets | PATLive",
                        description: "",
                        displayName: "Web Chat Widgets",
                    },
                    addWebChatWidget: {
                        title: "Add Web Chat Widget | PATLive",
                        description: "",
                        displayName: "Add Web Chat Widget",
                    },
                    editWebChatWidget: {
                        title: "Edit Web Chat Widget | PATLive",
                        description: "",
                        displayName: "Edit Web Chat Widget",
                    },
                    billing: {
                        title: "Billing | PATLive",
                        description: "",
                        displayName: "Billing",
                    },
                    accountProfile: {
                        title: "Billing Profile | PATLive",
                        description: "",
                        displayName: "Profile",
                    },
                    billCycleToDate: {
                        title: "Bill Cycle to Date | PATLive",
                        description: "",
                        displayName: "Bill Cycle to Date",
                    },
                    billingHistory: {
                        title: "History | PATLive",
                        description: "",
                        displayName: "History",
                    },
                    paymentMethods: {
                        title: "Payment Methods | PATLive",
                        description: "",
                        displayName: "Payment Methods",
                    },
                    addPaymentMethods: {
                        title: "Add Payment Method | PATLive",
                        description: "",
                        displayName: "Add Payment Method",
                    },
                    editPaymentMethods: {
                        title: "Edit Payment Method | PATLive",
                        description: "",
                        displayName: "Edit Payment Method",
                    },
                    makeAPayment: {
                        title: 'Make a Payment | PATLive',
                        description: '',
                        displayName: 'Make a Payment',
                    },
                    plans: {
                        title: 'Plans | PATLive',
                        description: '',
                        displayName: 'Plans',
                    },
                    addPlan: {
                        title: "Manage Plans | PATLive",
                        description: "",
                        displayName: "Manage Plans",
                    },
                    removePlan: {
                        title: "Remove Plan | PATLive",
                        description: "",
                        displayName: "remove Plan",
                    },
                    styleGuide: {
                        title: "Style Guide",
                        description: "",
                        displayName: "Style Guide",
                    },
                    notFound: {
                        title: "Error",
                        description: "",
                        displayName: "Page not found"
                    }
                },
                referentialConstraints: {
                    audioFile: {
                        message: " is using this audio file.",
                    },
                    autoAttendant: {
                        entityText: "Auto Attendant ",
                        message: " is routed to this auto attendant.",
                    },
                    forwardingNumber: {
                        entityText: "Forwarding Number ",
                        message: " is routed to this forwarding number.",
                    },
                    liveReceptionistScript: {
                        entityText: "Live Receptionist Script ",
                        message: " is routed to this live receptionist script.",
                    },
                    phoneNumber: {
                        entityText: "Phone Number ",
                    },
                    recordingNotification: {
                        message: " is using this notification in its call recording settings.",
                    },
                    schedule: {
                        entityText: "Schedule ",
                        message: " is using this schedule.",
                    },
                    transferOption: {
                        message: " is using this as a transfer option."
                    },
                    user: {
                        entityText: "User ",
                        message: " is routed to this user.",
                    },
                    userGroup: {
                        entityText: "Group ",
                        message: " is routed to this group.",
                    },
                    voicemailBox: {
                        entityText: "Voicemail Box ",
                        message: " is routed to this voicemail box.",
                    },
                    voicemailGreeting: {
                        message: " is using this audio file as a voicemail greeting.",
                    },
                    webChatWidget: {
                        entityText: "Web Chat Widget ",
                        liveReceptionistMessage: " is using this live receptionist script."
                    },
                    outboundCallingCampaign: {
                        entityText: "Outbound Calling Campaign ",
                        liveReceptionistMessage: " is using this live receptionist script."
                    }
                },
            },
        };
    }
);

